import _createForOfIteratorHelper from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectWithoutProperties from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["requireAuthentication", "component"];

var _handleActions, _handleActions2, _handleActions3;

import React, { useRef, useEffect, useState, useContext, createContext, lazy, forwardRef, useImperativeHandle, useLayoutEffect, Children, cloneElement, useCallback, isValidElement } from 'react';
import { createActions, handleActions } from 'redux-actions';
import axios from 'axios';
import zlib from 'zlib';
import { MD5 } from 'crypto-js';
import uuidv4 from 'uuid/v4';
import moment from 'moment';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'react-html-parser';
import StringMask from 'string-mask';
import cx from 'clsx';
import ReactGA from 'react-ga';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Tooltip as Tooltip$1, InputGroupText, InputGroupAddon, CustomInput, Input, Label, FormFeedback, FormGroup, InputGroup, ListGroup, ListGroupItem, UncontrolledTooltip, Card, CardHeader, CardBody, Form, Row, Col, Spinner, Progress as Progress$1, Collapse, Nav, TabContent, NavItem, NavLink, TabPane, Dropdown, DropdownToggle, DropdownMenu, UncontrolledDropdown, Badge, UncontrolledPopover } from 'reactstrap';
import debounce from 'lodash.debounce';
import InputMask from 'react-input-mask';
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import MaskedInput from 'react-maskedinput';
import Async from 'react-select/async';
import { useHistory, useLocation, Redirect } from 'react-router';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, useHistory as useHistory$1 } from 'react-router-dom';
import { faStar, faThumbsUp, faTimes, faLayerGroup, faCalendarAlt, fas, faAlignCenter, faAngleDoubleLeft, faAngleDoubleRight, faAngleDown, faAngleLeft, faAngleRight, faAngleUp, faArrowDown, faArrowLeft, faArrowRight, faArrowsAltH, faArrowUp, faAward, faBars, faBatteryEmpty, faBatteryFull, faBirthdayCake, faBomb, faBookOpen, faBusAlt, faCameraRetro, faCarBattery, faCaretRight, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCloudUploadAlt, faCog, faCubes, faDesktop, faDonate, faDownload, faEllipsisH, faEllipsisV, faExclamationCircle, faExternalLinkAlt, faEyeDropper, faFileContract, faFileCsv, faFileInvoiceDollar, faFilePowerpoint, faFilm, faFilter, faHeart, faIdCard, faInfoCircle, faKey, faLemon, faLink, faMapMarkedAlt, faNetworkWired, faPager, faPaste, faPen, faPencilRuler, faPlayCircle, faPlus, faPlusCircle, faPrint, faQuoteRight, faReceipt, faReply, faSadTear, faSave, faSearch, faShapes, faShareSquare, faSignOutAlt, faSitemap, faSlidersH, faSmile, faSmileWink, faStarHalfAlt, faSync, faTable, faTachometerAlt, faTrash, faUndoAlt, faUnlockAlt, faUpload, faUserClock, faUserCog, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStar$1, faAddressCard, faBell, faBuilding, faCalendarAlt as faCalendarAlt$1, faChartBar, faCheckCircle, faClock, faCommentDots, faComments, faCopy, faDotCircle, faEnvelope, faEye, faFile, faFileAlt, faFileArchive, faFileAudio, faFileCode, faFileExcel, faFileImage, faFilePdf, faFileVideo, faFileWord, faFolder, faFolderOpen, faGem, faImages, faKeyboard, faLifeRing, faLightbulb, faMap, faObjectGroup, faQuestionCircle, far, faSquare, faThumbsUp as faThumbsUp$1, faTimesCircle, faTrashAlt, faUser, faUserCircle } from '@fortawesome/free-regular-svg-icons';
import Rating from 'react-rating';
import { library } from '@fortawesome/fontawesome-svg-core';
import { BeatLoader } from 'react-spinners';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import Pagination from 'rc-pagination';
import localeInfo from 'rc-pagination/lib/locale/pt_BR';
import Select$1 from 'rc-select';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';
import { BlockPicker } from 'react-color';

function useInterval(callback, delay) {
  var savedCallback = useRef(callback); // Remember the latest callback.

  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  useEffect(function () {
    var tick = function tick() {
      return savedCallback.current();
    };

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }

    return undefined;
  }, [delay]);
}

var STORAGE_CHANGE_EVENT = 'onStorageChange';

function createCustomEvent(type, detail) {
  return new CustomEvent(type, {
    detail: detail
  });
}

function createStorageChanged(detail) {
  return createCustomEvent(STORAGE_CHANGE_EVENT, detail);
}

function deleteFromStorage(storage) {
  return function (key) {
    storage.removeItem(key);
    window.dispatchEvent(createStorageChanged({
      key: key,
      value: ''
    }));
  };
}

function writeStorage(storage) {
  return function (key, value) {
    storage.setItem(key, value);
    window.dispatchEvent(createStorageChanged({
      key: key,
      value: value
    }));
  };
}

function useStorage(storage) {
  return function (key, initialValue) {
    var _useState = useState(storage.getItem(key)),
        _useState2 = _slicedToArray(_useState, 2),
        storageValue = _useState2[0],
        setStorageValue = _useState2[1];

    var onStorageChange = function onStorageChange(event) {
      if (event.type === STORAGE_CHANGE_EVENT && event.detail && event.detail.key === key) {
        setStorageValue(event.detail.value);
      }
    };

    useEffect(function () {
      var storageChange = function storageChange(e) {
        return onStorageChange(e);
      };

      window.addEventListener(STORAGE_CHANGE_EVENT, storageChange);

      if (initialValue) {
        writeStorage(storage)(key, initialValue);
      }

      return function () {
        return window.removeEventListener(STORAGE_CHANGE_EVENT, storageChange);
      };
    }, []);
    return [storageValue, function (value) {
      return writeStorage(storage)(key, value);
    }, function () {
      return deleteFromStorage(storage)(key);
    }];
  };
}

var useLocalStorage = /*#__PURE__*/useStorage(localStorage);
var writeInLocalStorage = /*#__PURE__*/writeStorage(localStorage);
var deleteFromLocalStorage = /*#__PURE__*/deleteFromStorage(localStorage);
var useSessionStorage = /*#__PURE__*/useStorage(sessionStorage);
var writeInSessionStorage = /*#__PURE__*/writeStorage(sessionStorage);
var deleteFromSessionStorage = /*#__PURE__*/deleteFromStorage(sessionStorage);
var GRAPHIC = {
  label: 'Gráfico (*.pdf)',
  value: 'GRAPHIC'
};
var TEXT = {
  label: 'Texto (*.txt)',
  value: 'TEXT'
};
var CSV = {
  label: 'CSV (*.csv)',
  value: 'CSV'
};
var EXCEL = {
  label: 'Excel (*.xlsx)',
  value: 'EXCEL'
};
var HTML = {
  label: 'HTML',
  value: 'HTML'
};
var WORD = {
  label: 'Word (*.docx)',
  value: 'WORD'
};
var RTF = {
  label: 'Rich Text Format (*.rft)',
  value: 'RTF'
};
var DESIGN_TYPE_ENUM = [GRAPHIC, TEXT, CSV, EXCEL, HTML, WORD, RTF];
var SIMPLE = {
  label: 'Simples',
  value: 'SIMPLE'
};
var DATE = {
  label: 'Data',
  value: 'DATE'
};
var DATES = {
  label: 'Datas',
  value: 'DATES'
};
var REFERENCE = {
  label: 'Referência',
  value: 'REFERENCE'
};
var REFERENCES = {
  label: 'Referências',
  value: 'REFERENCES'
};
var ANO = {
  label: 'Ano',
  value: 'ANO'
};
var SIM = {
  label: 'Sim',
  value: 'SIM'
};
var NAO = {
  label: 'Não',
  value: 'NAO'
};
var OperationEnum;

(function (OperationEnum) {
  OperationEnum["EQUAL"] = "_field = _value";
  OperationEnum["GREATER_THAN_EQUAL"] = "_field >= _value";
  OperationEnum["LESS_THAN_EQUAL"] = "_field <= _value";
  OperationEnum["GREATER_THAN"] = "_field > _value";
  OperationEnum["LESS_THAN"] = "_field < _value";
  OperationEnum["DIFERENT"] = "_field <> _value";
  OperationEnum["CONTAINS"] = "upper(_field) like '%_value%'";
  OperationEnum["START_WITH"] = "upper(_field) like '_value%'";
  OperationEnum["END_WITH"] = "upper(_field) like '%_value'";
  OperationEnum["IN"] = "upper(_field) IN _value";
  OperationEnum["NUMBER_IN"] = "_field IN _value";
  OperationEnum["NOT_IN"] = "upper(_field) NOT IN _value";
  OperationEnum["NUMBER_NOT_IN"] = "_field NOT IN _value";
  OperationEnum["START_NOT_LIKE"] = "upper(_field) not like '_value%'";
  OperationEnum["END_NOT_LIKE"] = "upper(_field) not like '%_value'";
})(OperationEnum || (OperationEnum = {}));

var ComparatorEnum;

(function (ComparatorEnum) {
  ComparatorEnum["LIKE"] = "LIKE";
  ComparatorEnum["EQ"] = "=";
  ComparatorEnum["NE"] = "!=";
  ComparatorEnum["GT"] = ">";
  ComparatorEnum["GE"] = ">=";
  ComparatorEnum["LT"] = "<";
  ComparatorEnum["LE"] = "<=";
})(ComparatorEnum || (ComparatorEnum = {}));

var CountComparatorEnum;

(function (CountComparatorEnum) {
  CountComparatorEnum["EQ"] = "=";
  CountComparatorEnum["NE"] = "<>";
  CountComparatorEnum["GT"] = ">";
  CountComparatorEnum["GE"] = ">=";
  CountComparatorEnum["LT"] = "<";
  CountComparatorEnum["LE"] = "<=";
})(CountComparatorEnum || (CountComparatorEnum = {}));

var OrderType;

(function (OrderType) {
  OrderType["ASC"] = "asc";
  OrderType["DESC"] = "desc";
})(OrderType || (OrderType = {}));

var FilterType;

(function (FilterType) {
  FilterType["TEXT"] = "textFilter";
  FilterType["NUMBER"] = "numberFilter";
  FilterType["SELECT"] = "selectFilter";
  FilterType["MULTI_SELECT"] = "multiSelectFilter";
  FilterType["DATE"] = "dateFilter";
  FilterType["REFERENCE"] = "referenceFilter";
})(FilterType || (FilterType = {}));

var SelectModeEnum;

(function (SelectModeEnum) {
  SelectModeEnum["RADIO"] = "radio";
  SelectModeEnum["CHECKBOX"] = "checkbox";
})(SelectModeEnum || (SelectModeEnum = {}));

var PositionEnum;

(function (PositionEnum) {
  PositionEnum["LEFT"] = "left";
  PositionEnum["RIGHT"] = "right";
})(PositionEnum || (PositionEnum = {}));

var initialState = {
  data: {},
  showing: false
};
var actions = /*#__PURE__*/createActions({
  HIDE_PROGRESS: function HIDE_PROGRESS(progressParam) {
    return progressParam;
  },
  SHOW_PROGRESS: function SHOW_PROGRESS(progressParam) {
    return progressParam;
  }
});
var reducer = /*#__PURE__*/handleActions((_handleActions = {}, _defineProperty(_handleActions, /*#__PURE__*/actions.showProgress.toString(), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    data: action.payload,
    showing: true
  });
}), _defineProperty(_handleActions, /*#__PURE__*/actions.hideProgress.toString(), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    data: action && action.payload || {},
    showing: false
  });
}), _handleActions), initialState);
var initialState$1 = {};
var actions$1 = /*#__PURE__*/createActions({
  LOGIN: function LOGIN(param) {
    return param;
  },
  LOGOUT: null
});
var reducer$1 = /*#__PURE__*/handleActions((_handleActions2 = {}, _defineProperty(_handleActions2, /*#__PURE__*/actions$1.login.toString(), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    param: action.payload
  });
}), _defineProperty(_handleActions2, /*#__PURE__*/actions$1.logout.toString(), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    param: null
  });
}), _handleActions2), initialState$1);
var initialState$2 = {
  content: null
};
var actions$2 = /*#__PURE__*/createActions({
  CREATE_DOCK: function CREATE_DOCK(content) {
    return content;
  },
  DESTROY_DOCK: function DESTROY_DOCK() {
    return null;
  }
});
var reducer$2 = /*#__PURE__*/handleActions((_handleActions3 = {}, _defineProperty(_handleActions3, /*#__PURE__*/actions$2.createDock.toString(), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    content: action.payload
  });
}), _defineProperty(_handleActions3, /*#__PURE__*/actions$2.destroyDock.toString(), function () {
  return {
    content: null
  };
}), _handleActions3), initialState$2);
var environment = {
  production: process.env.NODE_ENV === 'production',
  productionURL: 'http://qa-react.projetusti.com.br/calima/',
  siteURL: process.env.REACT_APP_SITE_URL || 'http://localhost:8080/calima/'
};
var URL_CONTROLLER_LOGIN_TOKEN = '/token';
var URL_LOGIN_SITUACAO = '/informacaoCliente/consultarSituacao?codigoClienteProjetus=';
var URL_VALIDAR_LOGIN = '/autenticacao/validarLogin';
var URL_RECUPERAR_LOGIN = '/autenticacao/recuperar?login=';
var URL_LOGIN_TOKEN = '/autenticacao/recuperarLoginTokenTemporario?token=';
var URL_WIKI_CONTROLLER = '/urlSistema/getUrlBySistemaIdentificador?codigoSistema=1&identificador=';
var URL_WIKI = 'https://ajuda.calima.app/?curid=';
var NOTIFICAR_FALHA_LOGIN = '/autenticacao/notificarFalhaLogin?codigoCliente=';
var CONTAINER_STATUS_OK = 90;
var controllerHttps = /*#__PURE__*/axios.create({
  baseURL: 'https://login-api-controller.projetusti.com.br/'
});

function obterTokenLogin(thenFunc) {
  controllerHttps.post(URL_CONTROLLER_LOGIN_TOKEN, 'grant_type=password&username=02e3030bdcd918b3a2cb517a5a537a3d&password=C%2BxFgQ06llg%3D', {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (response) {
    var token = response.data && response.data.access_token;
    thenFunc(token);
  });
}

function consultarSituacao(param) {
  executar({
    method: 'POST',
    url: "".concat(URL_LOGIN_SITUACAO + param.codigoCliente.replace(/[^\d]/, ''), "&logando=true")
  }, param.tokenAcesso, function (response, token) {
    var json = response.data;

    if (servicoHabilitado(json, param.warningFunc)) {
      if (Number(json.status) === 1 && json.descricaoStatus) {
        param.errorFunc(json.descricaoStatus);
      } else {
        var url = json.calimaUrlReact ? json.calimaUrlReact : '';
        var containerStatus = json.containerStatus;

        if (json.codigoCliente === 0) {
          containerStatus = CONTAINER_STATUS_OK;
          url = environment.production ? environment.productionURL : '';
        }

        var result = {
          aplicationReleaseName: json.aplicationReleaseName,
          codigoCliente: json.codigoCliente,
          containerStatus: containerStatus,
          containerStatusMessage: json.containerStatusMessage,
          dataValidacaoCPF: param.dataValidacaoCPF,
          urlSistema: url,
          usuario: param.usuario
        };
        param.resultFunc(result, token);
      }
    }
  }, function (error) {
    param.errorFunc(getErrosJson(error.response && error.response.data));
  });
}

function validarLoginController(param) {
  var body = JSON.stringify({
    login: param.login,
    senha: param.senha
  });
  executar({
    data: body,
    method: 'POST',
    url: URL_VALIDAR_LOGIN
  }, param.tokenAcesso, function (response, token) {
    var dataValidacaoCPF = '';

    if (!response.data.cpf && response.data.dataLimiteObrigatoriedadeCpf) {
      dataValidacaoCPF = response.data.dataLimiteObrigatoriedadeCpf;
    }

    consultarSituacao({
      codigoCliente: String(response.data.codigoClienteProjetus),
      dataValidacaoCPF: dataValidacaoCPF,
      errorFunc: param.errorFunc,
      resultFunc: param.resultFunc,
      tokenAcesso: token,
      usuario: response.data.usuario,
      warningFunc: param.warningFunc
    });
  }, function (error) {
    param.errorFunc(getErrosJson(error.response && error.response.data));
  });
}

function loginToken(param) {
  executar({
    method: 'POST',
    url: URL_LOGIN_TOKEN + param.token
  }, param.tokenAcesso, function (response, token) {
    param.resultFunc(response.data, token);
  }, function (error) {
    param.errorFunc(getErrosJson(error.response && error.response.data));
  });
}

function recuperarLogin(param) {
  executar({
    method: 'POST',
    url: URL_RECUPERAR_LOGIN + param.login
  }, param.tokenAcesso, function (response, token) {
    param.resultFunc(response, token);
  }, function (error) {
    param.errorFunc(getErrosJson(error.response && error.response.data));
  });
}

function notificarFalhaLogin(param) {
  executar({
    method: 'POST',
    url: "".concat(NOTIFICAR_FALHA_LOGIN).concat(param.codigoCliente)
  }, param.tokenAcesso, function () {
    return null;
  }, function () {
    return null;
  });
}

function getErrosJson(json) {
  return json && json.errors && json.errors.map(function (it) {
    return it.description;
  }).join(' ');
}

function servicoHabilitado(json, errorFunc) {
  var isHabilitado = true;

  if (json.urlDebito && json.mensagemDebito && json.debito) {
    isHabilitado = false;
    errorFunc(json.mensagemDebito, json.urlDebito);
  }

  return isHabilitado;
}

function executar(param, tokenAcesso, sucessFunc, errorFunc) {
  if (tokenAcesso) {
    param.headers = {
      Authorization: "Bearer ".concat(tokenAcesso),
      'Content-type': 'application/json'
    };
    controllerHttps.request(param).then(function (response) {
      sucessFunc(response, tokenAcesso);
    }).catch(function (error) {
      if (error.code === '401' || error.response && error.response.status === 401) {
        obterTokenLogin(function (token) {
          executar(param, token, sucessFunc, errorFunc);
        });
      } else {
        errorFunc(error);
      }
    });
  } else {
    obterTokenLogin(function (token) {
      executar(param, token, sucessFunc, errorFunc);
    });
  }
}

var navegarWikiController = function navegarWikiController(id) {
  var params = {
    url: "".concat(URL_WIKI_CONTROLLER).concat(id),
    method: 'GET'
  };

  var success = function success(res) {
    return window.open(res.data, '_blank');
  };

  var error = function error() {
    return null;
  };

  executar(params, null, success, error);
};

var navegarWiki = function navegarWiki(id) {
  return window.open("".concat(URL_WIKI).concat(id), '_blank');
};

function consultarSituacaoFalhaConexao(param) {
  executar({
    method: 'POST',
    url: "".concat(URL_LOGIN_SITUACAO + param.codigoCliente.replace(/[^\d]/, ''), "&logando=false")
  }, param.tokenAcesso, function (response, token) {
    var json = response.data;
    var result = {
      containerStatus: json.containerStatus,
      urlSistema: json.calimaUrlReact
    };
    param.resultFunc(result, token);
  }, function (error) {
    param.errorFunc(getErrosJson(error.response && error.response.data));
  });
}

function removeAccents(value) {
  return value ? value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '';
}

var ALPHA = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

var gerarSequenciaChars = function gerarSequenciaChars(sizeInicial) {
  var size = sizeInicial;
  var result = '';
  var limit = ALPHA.length;

  while (size > 0) {
    var index = Math.round(Math.random() * limit);

    if (index === limit) {
      index--;
    }

    result = result.concat(ALPHA[index]);
    size--;
  }

  return result;
};

var fillText = function fillText(text, length, textToFill) {
  var result = '';

  if (text && textToFill) {
    for (var i = text.length; i < length; i++) {
      result += textToFill;
    }

    result += text;
  }

  return result;
};

var fillZero = function fillZero(text, lenghtField) {
  return fillText(text, lenghtField, '0');
};

var valToString = function valToString(val) {
  return (val === null || val === undefined ? '' : val).toString();
};

var MAX_NUMBER = 9999999999999;
var MAX_MONEY_NUMBER = 9999999999999.99;
var EMAIL_INVALIDO_MSG = 'E-mail inválido.';
var EMAIL_REGEX_VALIDATION = /^$|(^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$)/i;
var CEP_INVALIDO_MSG = 'CEP inválido.';
var TELEFONE_INVALIDO_MSG = 'Telefone inválido.';
var MASCARA_INVALIDA_MSG = 'Campo está fora do formato esperado.';
var URL_INVALIDA_MSG = 'URL inválida.';
var URL_REGEX_VALIDATION = /https?:\/\/.+/;

function isEmpty(value) {
  return !value || typeof value === 'string' && value.trim() === '';
}

function isNotEmpty(value) {
  return !isEmpty(value);
}

function isNumEmpty(value) {
  return !(value || value === 0);
}

function isCPF(value) {
  var result = false;

  if (value && value.trim().length === 11) {
    var cpf = value.trim();

    if (!isAllCharsEquals(cpf)) {
      var d1 = 0;
      var d2 = 0;

      for (var nCount = 1; nCount < cpf.length - 1; nCount++) {
        var digitoCPF = Number(cpf.substring(nCount - 1, nCount));
        d1 += (11 - nCount) * digitoCPF;
        d2 += (12 - nCount) * digitoCPF;
      }

      var resto = d1 % 11;
      var digito1 = resto < 2 ? 0 : 11 - resto;
      d2 += 2 * digito1;
      resto = d2 % 11;
      var digito2 = resto < 2 ? 0 : 11 - resto;
      var nDigVerific = cpf.substring(cpf.length - 2, cpf.length);
      var nDigResult = "".concat(digito1).concat(digito2);
      result = nDigVerific === nDigResult;
    }
  }

  return result;
}

function isAllCharsEquals(value) {
  var c = value.charAt(0);
  var iguais = true;

  for (var i = 0; i < value.length; i++) {
    iguais = iguais && value.charAt(i) === c;
  }

  return iguais;
}

function firstPartValidation(cnpj) {
  var soma = 0;
  var aux;

  for (var i = 0; i < 4; i++) {
    aux = cnpj.charCodeAt(i) - 48;

    if (aux >= 0 && aux <= 9) {
      soma += aux * (6 - (i + 1));
    }
  }

  for (var _i = 0; _i < 8; _i++) {
    aux = cnpj.charCodeAt(_i + 4) - 48;

    if (aux >= 0 && aux <= 9) {
      soma += aux * (10 - (_i + 1));
    }
  }

  return soma;
}

function secondPartValidation(cnpj) {
  var soma = 0;
  var aux;

  for (var i = 0; i < 5; i++) {
    aux = cnpj.charCodeAt(i) - 48;

    if (aux >= 0 && aux <= 9) {
      soma += aux * (7 - (i + 1));
    }
  }

  for (var _i2 = 0; _i2 < 8; _i2++) {
    aux = cnpj.charCodeAt(_i2 + 5) - 48;

    if (aux >= 0 && aux <= 9) {
      soma += aux * (10 - (_i2 + 1));
    }
  }

  return soma;
}

function isCNPJ(value) {
  var result = false;

  if (value && value.trim().length === 14) {
    var cnpj = value.trim();

    if (!isAllCharsEquals(cnpj)) {
      var cnpjCalculado = cnpj.substring(0, 12);
      /* Primeira parte */

      var soma = firstPartValidation(cnpj);
      var dig = 11 - soma % 11;
      cnpjCalculado += dig >= 10 ? '0' : dig.toString();
      /* Segunda parte */

      var validationResult = secondPartValidation(cnpj);
      dig = 11 - validationResult % 11;
      cnpjCalculado += dig >= 10 ? '0' : dig.toString();
      result = cnpj === cnpjCalculado;
    }
  }

  return result;
}
/**
 *
 * Função para a validação de valores principais ex: listagem de endereços, telefones
 * @param formValues valores do form do detailManager
 * @param parentObject valores do objeto pai
 * @param parentListObject atributo do objeto pai referente a lista que será percorrida ex: telefones
 * @param uniqueProp atributo que será pesquisado ex: tipoTelefonePrincipal
 * @returns true ou false caso já exista um registro da lista com o atributo marcado
 */


function validateUniqueProp(formValues, parentObject, parentListObject, uniqueProp) {
  var isInsert = isEmpty(formValues.rowIndex) && isEmpty(formValues.id);
  var foundProp;

  if (isInsert) {
    foundProp = parentObject[parentListObject].find(function (it) {
      return it[uniqueProp];
    });
  } else {
    foundProp = parentObject[parentListObject].find(function (it) {
      var hasId = isNotEmpty(formValues.id);
      var result;

      if (hasId) {
        result = it[uniqueProp] && Number(formValues.id) !== Number(it.id);
      } else {
        result = it[uniqueProp] && Number(formValues.rowIndex) !== Number(it.rowIndex);
      }

      return result;
    });
  }

  return !!foundProp;
}

function getMaxMoney(validation) {
  var max = MAX_MONEY_NUMBER;

  if (validation) {
    if (validation.max) {
      max = typeof validation.max === 'object' ? validation.max.value : validation.max;
    } else if (validation.maxLength) {
      max = parseFloat('.99'.padStart(validation.maxLength.value + 1, '9'));
    }
  }

  return max;
}

function getMaxLengthMoney(max) {
  var length = max.toFixed(0).length;
  var decPoints = length / 3;

  if (Number.isInteger(decPoints)) {
    decPoints--;
  } else {
    decPoints = Math.floor(decPoints);
  }

  return length + decPoints + 3;
}

function getMaxFloatValue(value) {
  var result = value;

  if (value.length > MAX_MONEY_NUMBER.toFixed(2).length) {
    var val = result.replace(/\D/g, '');
    var len = MAX_MONEY_NUMBER.toFixed(0).length;
    result = "".concat(val.substring(0, len), ".").concat(val.substring(len, len + 2));
  }

  return result;
}

function isCEP(value) {
  return value && value.length === 8;
}

function isEmail(value) {
  return new RegExp(EMAIL_REGEX_VALIDATION).test(value);
}

function isTelefone(value) {
  return value && value.length >= 8 && value.length <= 11;
}

function isMask(value, mascara) {
  return value && value.length === mascara.match(/9/g).length;
}

function isURL(value) {
  return new RegExp(URL_REGEX_VALIDATION).test(value);
}

var SIZE_LIMIT = 3;

var md5 = function md5(contents) {
  return Buffer.from(MD5(contents).toString()).toString('base64');
};

var getRandomUUID = function getRandomUUID() {
  return uuidv4();
};

var enc = function enc(value) {
  var size = value ? value.length : 0;
  var result = '';

  if (size > 0) {
    var sizeStr = size.toString();

    if (sizeStr.length <= SIZE_LIMIT) {
      result = result.concat(gerarSequenciaChars(SIZE_LIMIT - sizeStr.length)).concat(sizeStr);

      for (var index = 0; size > index; index++) {
        result = result.concat(value.charAt(index)).concat(gerarSequenciaChars(gerarSize(index + 1)));
      }
    }
  }

  return result;
};

var dec = function dec(value) {
  var result = '';

  if (value) {
    var lengthStr = value.slice(0, SIZE_LIMIT).replace(new RegExp('[^0-9]', 'g'), '');

    if (lengthStr) {
      var withoutSize = value.substring(SIZE_LIMIT);
      var size = parseInt(lengthStr, 0);
      var ofsset = 0;

      for (var index = 0; index < size; index++) {
        result = result.concat(withoutSize.charAt(ofsset));
        ofsset += index + 2;
      }
    }
  }

  return result;
};

var defaultEncrypt = function defaultEncrypt(value) {
  var result = '';

  if (!isEmpty(value)) {
    var passo = 150;
    result = result.concat(String(passo));

    for (var index = 0; value.length > index; index++) {
      result = result.concat(String.fromCharCode(value.charCodeAt(index) + passo));
    }
  }

  return result;
};

var defaultDecrypt = function defaultDecrypt(value) {
  var result = value;

  if (value && value.length > 3) {
    var sizeStr = value.substring(0, 3);
    var size = Number(sizeStr);

    if (!isNaN(size)) {
      result = '';

      for (var index = 3; value.length > index; index++) {
        result = result.concat(String.fromCharCode(value.charCodeAt(index) - size));
      }
    }
  }

  return result;
};

var gerarSize = function gerarSize(sizeInicial) {
  return sizeInicial;
};

var DEFAULT_TIMEOUT = 100000;

function getDefaulTransform(defaultValue) {
  var transformRequest;

  if (defaultValue) {
    if (Array.isArray(defaultValue)) {
      transformRequest = defaultValue;
    } else {
      transformRequest = [defaultValue];
    }
  } else {
    transformRequest = [];
  }

  return transformRequest;
}

var create = function create(path) {
  var addGzip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var transformRequest = getDefaulTransform(axios.defaults.transformRequest);

  if (addGzip) {
    transformRequest = transformRequest.concat(function (data, headers) {
      headers['Crypt-Algorithm'] = 'default';
      var result = data;

      if (typeof result === 'string') {
        headers['Content-Encoding'] = 'gzip';
        result = zlib.gzipSync(defaultEncrypt(data));
      } else {
        headers['Content-Encoding'] = undefined;
      }

      return result;
    });
  }

  var axiosInstance = axios.create({
    baseURL: "".concat(environment.siteURL, "spring").concat(path),
    transformRequest: transformRequest,
    withCredentials: true
  });
  axiosInstance.defaults.timeout = DEFAULT_TIMEOUT;
  return axiosInstance;
};

var send = function send(promise, param) {
  promise.then(function (result) {
    param.thenFunction(result.data);
  }).catch(function (error) {
    errorFunc(error, param.errorFunction);
  });
};

var errorFunc = function errorFunc(error, errorHandler) {
  var mensagem = '';
  var detalhes = '';

  if (error && error.response) {
    switch (error.response.status) {
      case 404:
        mensagem = 'Registro não encontrado';
        break;

      case 500:
        if (error.response.data) {
          mensagem = error.response.data.description;
          detalhes = error.response.data.details;
        }

        break;
    }
  }

  if (isEmpty(mensagem)) {
    mensagem = 'Ocorreu um erro não esperado';
  }

  if (errorHandler) {
    errorHandler(mensagem, detalhes, error);
  }
};

function getService() {
  var addGzip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return create('/persistence', addGzip);
}

function findAllByExpression(searchCriteria, param) {
  var addGzip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  send(getService(addGzip).post('/findAllByExpression', searchCriteria), param);
}

function persist(entity, dtoClassName, param) {
  var addGzip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  send(getService(addGzip).post('/persist', {
    data: entity,
    className: dtoClassName
  }), param);
}

function persistFiles(entity, dtoClassName, file, param) {
  var addGzip = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var formDataSend = new FormData();
  formDataSend.append('file', file);
  formDataSend.append('entity', new Blob([JSON.stringify({
    data: entity,
    className: dtoClassName
  })], {
    type: 'application/json'
  }));
  send(getService(addGzip).post('/persistfile', formDataSend), param);
}

function remove(entity, dtoClassName, param) {
  var addGzip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  send(getService(addGzip).delete('/remove', {
    params: {
      id: entity.id,
      className: dtoClassName
    }
  }), param);
}

function findById(entity, dtoClassName, param) {
  var addGzip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  send(getService(addGzip).get('/findById', {
    params: {
      id: entity.id,
      className: dtoClassName
    }
  }), param);
}

function findByExample(entity, dtoClassName, param) {
  var addGzip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  send(getService(addGzip).post('/findByExample', {
    data: entity,
    className: dtoClassName
  }), param);
}

function persistList(entities, dtoClassName, param) {
  var addGzip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  send(getService(addGzip).post('/persistList', {
    data: entities,
    className: dtoClassName
  }), param);
}

function removeList(entities, dtoClassName, param) {
  var addGzip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  send(getService(addGzip).post('/removeList', {
    data: entities,
    className: dtoClassName
  }), param);
}

function findAll(dtoClassName, param) {
  var addGzip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  send(getService(addGzip).post('/findAll', {
    className: dtoClassName
  }), param);
}

var CALIMA_PRIMARY = '#0062cc';
var CALIMA_SUCCESS = '#28a745';
var CALIMA_INFO = '#117a8b';
var CALIMA_WARNING = '#ffc107';
var CALIMA_ORANGE = '#f4772e';
var CALIMA_DANGER = '#bd2130';
var CALIMA_DARK = '#343a40';
var CALIMA_LIGHT = '#f8f9fa';
var THEME_PRIMARY = '#3c44b1';
var THEME_SECONDARY = '#070919';
var THEME_SUCCESS = '#1bc943';
var THEME_DANGER = '#f83245';
var THEME_WARNING = '#f4772e';
var THEME_INFO = '#11c5db';
var THEME_DARK = '#7a7b97';
var REGISTRO_INSERIDO_COM_SUCESSO_MSG = 'Registro inserido com sucesso!';
var REGISTRO_ALTERADO_COM_SUCESSO_MSG = 'Registro alterado com sucesso!';
var REGISTRO_EXCLUIDO_COM_SUCESSO_MSG = 'Registro excluído com sucesso!';
var REQUIRED_FIELD = 'Campo não pode estar em branco';
var DATE_MONTH_YEAR_PATTERN = 'DD/MM/YYYY';
var MONTH_YEAR_PATTERN = 'MM/YYYY';
var REF_PATTERN = 'YYYYMM';
var YEAR_MONTH_DATE_PATTERN = 'YYYY/MM/DD';
var TIME_PATTERN = 'HH:mm:ss';
var DATE_MONTH_YEAR_TIME_PATTERN = 'DD/MM/YYYY HH:mm:ss';
var YEAR_MONTH_DATE_TIME_PATTERN = 'YYYY/MM/DD HH:mm:ss';

function toDate(value) {
  var datePattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DATE_MONTH_YEAR_PATTERN;
  var result;

  if (isEmpty(value)) {
    result = undefined;
  } else {
    result = moment(value, datePattern).toDate();
  }

  return result;
}

function toDateTime(value) {
  var datePattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DATE_MONTH_YEAR_TIME_PATTERN;
  return toDate(value, datePattern);
}

function format(value, datePattern) {
  var result;

  if (value) {
    result = moment(value).format(datePattern);
  } else {
    result = undefined;
  }

  return result;
}

function formatDate(value) {
  var datePattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DATE_MONTH_YEAR_PATTERN;
  return format(value, datePattern);
}

function formatRef(value) {
  var refPattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : REF_PATTERN;
  return format(value, refPattern);
}

function formatTime(value) {
  var datePattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TIME_PATTERN;
  return format(value, datePattern);
}

function formatDateTime(value) {
  var datePattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DATE_MONTH_YEAR_TIME_PATTERN;
  return format(value, datePattern);
}

function addSeconds(date, value) {
  return add(date, value, 's');
}

function addMilliseconds(date, value) {
  return add(date, value, 'ms');
}

function add(date, value, unit) {
  var result;

  if (date && value && unit) {
    result = moment(date).add(value, unit).toDate();
  } else {
    result = undefined;
  }

  return result;
}

function getDate(str, isRefType, pattern) {
  var date = toDate(str, pattern);

  if (isRefType) {
    date = parseRefToDate(pattern === MONTH_YEAR_PATTERN ? refToFormatYearAndMonth(str) : str, 1);
  }

  return date ? date.getTime() : date;
}
/**
 * Compara datas em qualquer formato, por padrão DD/MM/YYYY
 * @param {string} firstDateStr
 * @param {string} secondDateStr
 * @param {string} pattern
 * @returns {number} 0 para datas iguais, -1 para firstDateStr menor e 1 para firstDateStr maior
 */


function compare(firstDateStr, secondDateStr) {
  var pattern = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DATE_MONTH_YEAR_PATTERN;
  var isRefType = [MONTH_YEAR_PATTERN, REF_PATTERN].indexOf(pattern) !== -1;
  var firstDate = getDate(firstDateStr, isRefType, pattern);
  var secondDate = getDate(secondDateStr, isRefType, pattern);
  var result = 0;

  if (firstDate && secondDate) {
    result = firstDate < secondDate ? -1 : firstDate === secondDate ? 0 : 1;
  } else if (firstDate != null) {
    result = -1;
  } else if (secondDate != null) {
    result = 1;
  }

  return result;
}

function currentMomentDate() {
  return moment();
}

function currentDate() {
  return moment().toDate();
}
/**
 * Converte a referência YYYYMM para MM/YYYY
 * @param {string} reference
 * @returns {string | undefined}
 */


function refToFormat(reference) {
  var result;

  if (!reference || reference.length !== 6 || reference.indexOf('/') !== -1) {
    result = undefined;
  } else {
    result = "".concat(reference.substring(4), "/").concat(reference.substring(0, 4));
  }

  return result;
}
/**
 * Converte uma data em uma referência (202007).
 * @param {Date} date
 * @returns Referência no formato YYYYMM
 */


function parseDateToRef(date) {
  return format(date, REF_PATTERN);
}
/**
 * Converte uma referência (202007) em uma data.
 * @param {string} ref Referência no formato YYYYMM
 * @param {number} day Dia desejado, utilize 0 para o último dia do mês.
 * @returns {Date}
 */


function parseRefToDate(ref, day) {
  if (!ref) {
    ref = parseDateToRef(new Date());
  }

  var year = parseInt(ref.substr(0, 4), 10);
  var month = parseInt(ref.substr(4, 2), 10);
  var daysInMonth = moment(ref, REF_PATTERN).daysInMonth();

  if (day === 0) {
    month++;
  } else if (day > daysInMonth) {
    day = daysInMonth;
  }

  return new Date(year, month - 1, day, 12, 0, 0);
}
/**
 * Converte a referência para o ultimo dia do mês
 * @param {string} ref Referência no formato YYYYMM
 * @returns {Date} data com o ultimo dia do mês.
 */


function parseLastDay(ref) {
  return parseRefToDate(ref, 0);
}
/**
 * Converte a referência MM/YYYY para referência YYYYMM
 * @param {string} reference - Referência no formato MM/YYYY
 * @returns {string} Referência no formato YYYYMM
 */


function refToFormatYearAndMonth(reference) {
  var result;

  if (reference && reference.match(/^\d{2}\/\d{4}$/g)) {
    result = "".concat(reference.substring(3, 7)).concat(reference.substring(0, 2));
  }

  return result;
}

var NOT_FOUND = -1;
var EXTENSION_SEPARATOR = '.';
var UNIX_SEPARATOR = '/';
var WINDOWS_SEPARATOR = '\\';
var SIZE_ONE_HUNDRED_BYTES = 104857600;
var SIZE_TWO_BYTES = 2097100;

function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (bytes === 0) {
    return '0 Bytes';
  }

  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), " ").concat(sizes[i]);
}

function getExtension(filename) {
  if (filename == null || filename === undefined) {
    return null;
  }

  var index = indexOfExtension(filename);

  if (index === NOT_FOUND) {
    return '';
  } else {
    return filename.substring(index + 1);
  }
}

function indexOfExtension(filename) {
  var extensionPos = filename.lastIndexOf(EXTENSION_SEPARATOR);
  var lastSeparator = indexOfLastSeparator(filename);
  return lastSeparator > extensionPos ? NOT_FOUND : extensionPos;
}

function indexOfLastSeparator(filename) {
  var lastUnixPos = filename.lastIndexOf(UNIX_SEPARATOR);
  var lastWindowsPos = filename.lastIndexOf(WINDOWS_SEPARATOR);
  return Math.max(lastUnixPos, lastWindowsPos);
}

var ONLY_NUMBER_MESSAGE = 'Somente são permitidos números.';
var ONLY_ALPHA_NUM_MESSAGE = 'Somente são permitidos números ou letras.';
var ONLY_ALPHA_MESSAGE = 'Somente são permitidos letras.';

function onlyNumber(minLength, maxLength) {
  var allowFloat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var regExp = allowFloat ? '[\\d.]' : '[\\d]';
  return {
    maxLength: maxLength,
    minLength: minLength,
    validate: function validate(value) {
      var rx = new RegExp("^".concat(regExp, "{").concat(minLength, ",").concat(maxLength, "}$"));
      return !value || rx.test(value) || ONLY_NUMBER_MESSAGE;
    }
  };
}

function onlyAlphaNum(minLength, maxLength) {
  return {
    maxLength: maxLength,
    minLength: minLength,
    pattern: {
      message: ONLY_ALPHA_NUM_MESSAGE,
      value: new RegExp("^[a-zA-Z0-9]{".concat(minLength, ",").concat(maxLength, "}$"))
    }
  };
}

function onlyAlpha(minLength, maxLength) {
  return {
    maxLength: maxLength,
    minLength: minLength,
    pattern: {
      message: ONLY_ALPHA_MESSAGE,
      value: new RegExp("^[a-zA-Z]{".concat(minLength, ",").concat(maxLength, "}$"))
    }
  };
}

function getSelectedItem(props) {
  var emptyObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    id: null
  };

  if (props.isModal) {
    return props.selectedItem || emptyObj;
  } else {
    var state = props.history.location.state;
    return state && state.selectedItem || emptyObj;
  }
}

var ToastMsg = function ToastMsg(props) {
  function renderToast() {
    var isString = typeof props.message === 'string';
    return React.createElement("div", null, React.createElement(FontAwesomeIcon, {
      icon: props.icon
    }), " ", props.title, React.createElement("br", null), isString ? React.createElement("small", null, ReactHtmlParser(props.message)) : props.message);
  }

  return renderToast();
};

var INFORMATION = {
  title: 'Informação',
  icon: 'info-circle',
  type: 'info'
};
var SUCCESS = {
  title: 'Sucesso',
  icon: 'check-circle',
  type: 'success'
};
var WARNING = {
  title: 'Atenção',
  icon: 'exclamation-circle',
  type: 'warning'
};
var ERROR = {
  title: 'Erro',
  icon: 'times-circle',
  type: 'error'
};

function showToast(message, props) {
  toast(React.createElement(ToastMsg, Object.assign({}, props, {
    message: message
  })), {
    autoClose: props.delay || 10000,
    type: props.type
  });
}

function cpfMaskFormatter(cpf) {
  var result = '';

  if (cpf && cpf.length === 11) {
    result = new StringMask('000.000.000-00').apply(cpf);
  }

  return result;
}

function cnpjMaskFormatter(cnpj) {
  var result = '';

  if (cnpj && cnpj.length === 14) {
    result = new StringMask('00.000.000/0000-00').apply(cnpj);
  }

  return result;
}

function decimalMaskFormatter(value) {
  var result = '0,00';
  var negative = false;

  if (value && value !== 0) {
    if (value < 0) {
      negative = true;
      value *= -1;
    }

    var stringValue = value.toFixed(2).replace('.', '');
    result = new StringMask('#.##0,00', {
      reverse: true
    }).apply(stringValue);
  }

  return "".concat(negative ? '-' : '').concat(result);
}

function phoneMaskFormatter(value) {
  var withDDD = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var mask = withDDD ? '(00) 90000-0000' : '90000-0000';
  var result = '';

  if (!isEmpty(value)) {
    result = new StringMask(mask).apply(value);
  }

  return result;
}

function percentualMaskFormatter(value) {
  var result = '0,00%';

  if (value && value !== 0) {
    var stringValue = value.toFixed(2).replace('.', '');
    result = new StringMask('#0,00%', {
      reverse: true
    }).apply(stringValue);
  }

  return result;
}

function cepMaskFormatter(cep) {
  var result = '';

  if (!isEmpty(cep) && cep.length === 8) {
    result = new StringMask('00.000-000').apply(cep);
  }

  return result;
}

var findInputChildrens = function findInputChildrens(tabRef, selector) {
  var mainList = [];

  if (tabRef.current) {
    var tabs = tabRef.current.querySelectorAll(selector);
    tabs.forEach(function (it, index) {
      var elms = it.querySelectorAll('input[name],.react-select-container');
      var inputs = Array.from(elms.values()).map(function (el) {
        return el.tagName === 'INPUT' ? el.getAttribute('name').replace('Fmt', '') : el.getAttribute('id');
      });

      if (inputs.length) {
        mainList.push({
          index: index + 1,
          inputs: inputs
        });
      }
    });
  }

  return mainList;
};

var getComponentBasicProps = function getComponentBasicProps(basicProps) {
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var defaultStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var itemProps = {};
  var classNames = [];
  var styles = {};

  if (defaultClassName) {
    classNames.push(defaultClassName);
  }

  if (defaultStyle) {
    styles = _objectSpread({}, defaultStyle);
  }

  if (basicProps) {
    if (basicProps.style) {
      styles = _objectSpread(_objectSpread({}, styles), basicProps.style);
    }

    if (basicProps.className) {
      classNames.push(basicProps.className);
    }
  }

  if (classNames.length > 0) {
    itemProps.className = cx.apply(void 0, classNames);
  }

  if (Object.keys(styles).length > 0) {
    itemProps.style = styles;
  }

  return itemProps;
};

var getFirstChildrenFound = function getFirstChildrenFound(element, selectors) {
  var children;
  selectors.some(function (selector) {
    children = element.querySelector(selector);
    return !!children;
  });
  return children;
};

var isElementVisible = function isElementVisible(element) {
  return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
};

var getNextVisibleElement = function getNextVisibleElement(list, start) {
  return Array.from(Array(list.length - start), function (_, i) {
    return list[i + start];
  }).find(isElementVisible);
};

var focusOnInput = function focusOnInput(mainElement, field) {
  var ignoreBlur = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var element = getFirstChildrenFound(mainElement, ["[name=\"".concat(field, "Fmt\"], [name=\"id").concat(field, "Fmt\"]"), "#".concat(field, "Fmt, #id").concat(field, "Fmt"), "[name=\"".concat(field, "\"], [name=\"id").concat(field, "\"]"), "#".concat(field, ", #id").concat(field)]);

  if (element) {
    window.dispatchEvent(new CustomEvent('programatic', {
      detail: {
        element: element,
        ignoreBlur: ignoreBlur
      }
    }));

    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
      element.focus();
    } else if (element.tagName === 'DIV') {
      var select = element.querySelector('.react-select-container');

      if (select) {
        select.dispatchEvent(new Event('externalFocus'));
      }
    }
  }
};

var cloneEvent = function cloneEvent(e) {
  // tslint:disable-next-line:no-empty
  function CustomEvent() {}

  CustomEvent.prototype = e;
  return new CustomEvent();
};

var INPUT_SELECTOR = "input[name]{NOT_LIST},.react-select-container{NOT_LIST},textarea[name]{NOT_LIST}";
var NOT_LIST = ['[name="id"]', '[type="file"]', '[type="hidden"]', '[tabindex="-1"]', '[disabled]', '.react-select--is-disabled', '.react-select-dropdown--is-disabled'];

var getInputSelector = function getInputSelector() {
  return INPUT_SELECTOR.replace(/\{NOT_LIST\}/g, NOT_LIST.map(function (it) {
    return ":not(".concat(it, ")");
  }).join(''));
};

var initialFocus = function initialFocus(divRef) {
  return setTimeout(function () {
    var input = divRef.current.querySelector(getInputSelector());

    if (input) {
      focusOnInput(divRef.current, (input.name || input.id).replace('Fmt', ''), true);
    }
  }, 250);
};

var handleFocusOnEnter = function handleFocusOnEnter(useEnterAsTab, divRef, e) {
  if (useEnterAsTab !== false && (e.keyCode || e.which) === 13) {
    var inputs = Array.from(divRef.current.querySelectorAll(getInputSelector()));
    var current = inputs.findIndex(function (it) {
      return (it.name || it.id) === (e.target.name || e.target.id);
    });
    var item = getNextVisibleElement(inputs, current + 1);

    if (item) {
      focusOnInput(divRef.current, (item.name || item.id).replace('Fmt', ''));
    }
  }
};
/**
 * Initialize - init the GA track.
 * @param {string} trackingId
 * @param {boolean} debug
 */


var initializeGA = function initializeGA(trackingId) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  ReactGA.initialize(trackingId, {
    debug: debug
  });
};
/**
 * PageView - Hit a page.
 * @param {History} history
 * @return UnregisterCallback
 */


var gaPageView = function gaPageView(history) {
  return history.listen(function (location) {
    var page = location.pathname;

    if (page !== '/') {
      ReactGA.set({
        page: page
      });
      ReactGA.pageview(page);
    }
  });
};
/**
 * ModalView - Hit a modal.
 * @param {string} page
 */


var gaModalView = function gaModalView(page) {
  ReactGA.modalview(page);
};
/**
 * Event - Add custom tracking event.
 * @param {string} category
 * @param {string} action
 * @param {string} label
 */


var gaEvent = function gaEvent(category, action) {
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  ReactGA.event({
    action: action,
    category: category,
    label: label
  });
};
/**
 * OutboundLink - hit external link.
 * @param {string} label
 */


var gaOutboundLink = function gaOutboundLink(label) {
  ReactGA.outboundLink({
    label: label
  }, function () {
    gaEvent('Link externo', 'Click', label);
  });
};
/**
 * GenerateTestId - generate test id for cypress.
 * @param {string} componentId
 */


var generateTestId = function generateTestId(componentId) {
  return {
    'data-testid': componentId
  };
};
/**
 * Converte um valor numérico para uma string de valor adicionando se é crédito ou débito.
 * (Crédito para valores positivos e Débito para valores negativos)
 * @param {string} saldo - Saldo no formato string
 * @returns {string} Saldo no formato String. Exemplo: (10,00 D)
 */


function formatSaldo(saldo) {
  var result;

  if (isNaN(saldo)) {
    result = '0,0';
  } else {
    var saldoStr = decimalMaskFormatter(Math.abs(saldo));

    if (saldo > 0) {
      result = saldoStr.concat(' C');
    } else if (saldo === 0) {
      result = saldoStr.concat('  ');
    } else {
      result = saldoStr.concat(' D');
    }
  }

  return result;
}

function cpfFormatter(cell, row) {
  return cpfMaskFormatter(cell);
}

function cnpjFormatter(cell, row) {
  return cnpjMaskFormatter(cell);
}

function decimalFormatter(cell, row) {
  return decimalMaskFormatter(parseFloat(cell));
}

function phoneWithDDDFormatter(cell, row) {
  return phoneMaskFormatter(cell);
}

function phoneFormatter(cell, row) {
  return phoneMaskFormatter(cell, false);
}

function percentualFormatter(cell, row) {
  return percentualMaskFormatter(parseFloat(cell));
}

function cepFormatter(cell, row) {
  return cepMaskFormatter(cell);
}

function enumFormatter(cell, row, rowIndex, formatExtraData) {
  var isNumber = !isNaN(cell);

  var cmpInt = function cmpInt(a, b) {
    return parseInt(a, 10) === parseInt(b, 10);
  };

  var item = formatExtraData.find(function (it) {
    return isNumber ? cmpInt(it.value, cell) : it.value === cell;
  });
  return item ? item.label : '';
}

function boolFormatter(cell, row, rowIndex, formatExtraData) {
  var result = null;

  if (cell === true || cell === 'true') {
    result = SIM.label;
  } else if (cell === false || cell === 'false') {
    result = NAO.label;
  }

  return result;
}

function currencyFomatter(cell, row, rowIndex, formatExtraData) {
  var options = formatExtraData ? formatExtraData : {
    style: 'currency',
    currency: 'BRL'
  };
  var value = Number(cell);
  return value.toLocaleString('pt-br', options);
}

function referenceFormatter(cell, row, rowIndex, formatExtraData) {
  return refToFormat(cell.length === 6 ? cell : formatRef(toDate(cell, formatExtraData || REF_PATTERN)));
}

function isRequired(column) {
  return column.validation && column.validation.required;
}

function getPattern(column) {
  return column.validation && column.validation.pattern;
}

function dateValidator(newValue, row, column) {
  var result = true;

  if (!isEmpty(newValue) || isRequired(column)) {
    var datePattern = getPattern(column) || DATE_MONTH_YEAR_PATTERN;

    if (newValue.length !== datePattern.length || !toDate(newValue, datePattern)) {
      result = {
        message: 'Campo não é uma data válida',
        valid: false
      };
    }
  }

  return result;
}

function dateTimeValidator(newValue, row, column) {
  var result = true;

  if (!isEmpty(newValue) || isRequired(column)) {
    var datePattern = getPattern(column) || DATE_MONTH_YEAR_TIME_PATTERN;

    if (newValue.length !== datePattern.length || !toDateTime(newValue, datePattern)) {
      result = {
        message: 'Campo não é uma data válida',
        valid: false
      };
    }
  }

  return result;
}

function booleanOptionList() {
  return [{
    label: SIM.label,
    value: true
  }, {
    label: NAO.label,
    value: false
  }];
}

function getObjectSubValue(data, key) {
  var keyList = key.split('.');
  var result = null;
  keyList.forEach(function (field, index) {
    if (result === null && index === 0) {
      result = data[field];
    } else if (!!result && typeof result === 'object') {
      result = result[field];
    }
  });
  return result;
}

var adjustNonEmptyExpressions = function adjustNonEmptyExpressions(expression) {
  if (expression.operation.toUpperCase().indexOf('LIKE') === -1) {
    expression.operation = expression.operation.replace('_value', ":".concat(expression.alias));
  } else {
    var like = expression.operation.match(/'[%]{0,1}_value[%]{0,1}'/g);

    if (like && like.length > 0) {
      expression.operation = expression.operation.replace(like[0], ":".concat(expression.alias));
      expression.value = like[0].replace('_value', expression.value).replace(/'/g, '');
    }
  }

  return expression;
};

var adjustExpressions = function adjustExpressions(expressions) {
  return expressions.map(function (expression) {
    if (expression.expressions && expression.expressions.length > 0) {
      expression.expressions = adjustExpressions(expression.expressions);
    }

    if (expression.operation) {
      expression.alias = expression.alias || expression.fieldName.replace(/\./g, '_');
      expression.operation = expression.operation.replace('_field', expression.fieldName);

      if (expression.value === null) {
        expression.operation = expression.operation.replace('= _value', 'is null').replace('<> _value', 'is not null');
      } else {
        expression = adjustNonEmptyExpressions(expression);
      }
    }

    return expression;
  });
};

var ACTION_EVENTS = {
  CLOSE: 1,
  SHOW: 0
};
var alertManager = {
  events: /*#__PURE__*/new Map(),
  on: function on(event, callback) {
    if (!this.events.has(event)) {
      this.events.set(event, []);
    }

    this.events.get(event).push(callback);
    return this;
  },
  off: function off(event) {
    this.events.delete(event);
    return this;
  },
  emit: function emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.events.has(event)) {
      this.events.get(event).forEach(function (callback) {
        return callback.apply(void 0, args);
      });
    }
  }
};
var DEFAULT_DELETE_SELECTED_ITEM_MSG = 'Tem certeza que deseja excluir o registro selecionado ?';
var DEFAULT_ONE_SELECTED_ITEM_MSG = 'Pelo menos um item deve ser selecionado';
var AlertType;

(function (AlertType) {
  /**
   * Categoriza o componente como um alerta de <b>Informação</b>.
   */
  AlertType["INFORMATION"] = "info";
  /**
   * Categoriza o componente como um <b>alerta de Erro</b>.
   */

  AlertType["ERROR"] = "error";
  /**
   * Categoriza o componente como um alerta de <b>Aviso</b>.
   */

  AlertType["WARNING"] = "warning";
  /**
   * Categoriza o componente como um alerta de <b>Aviso (Com os botões: Sim e Não)</b>.
   */

  AlertType["WARNING_YES_NO"] = "warning_yes_no";
  /**
   * Categoriza o componente como um alerta de <b>Aviso (Com os botões: Sim, Não e Cancelar)</b>.
   */

  AlertType["WARNING_YES_NO_CANCEL"] = "warning_yes_no_cancel";
  /**
   * Categoriza o componente como um alerta de <b>Confirmação</b>.
   */

  AlertType["QUESTION"] = "question";
  /**
   * Categoriza o componente como um alerta de <b>Confirmação (Com os botões: Sim, Não e Cancelar)</b>.
   */

  AlertType["QUESTION_YES_NO_CANCEL"] = "question_yes_no_cancel";
})(AlertType || (AlertType = {}));

var AlertContainer = function AlertContainer() {
  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      alertInstance = _useState4[0],
      setAlertInstance = _useState4[1];

  useEffect(function () {
    function buildAlert(content) {
      var alertOptions = {
        isOpen: true,
        message: content.message,
        onCancelClick: content.onCancelClick || removeAlert,
        onHide: content.onHide || removeAlert,
        onNoClick: content.onNoClick || removeAlert,
        onOkClick: content.onOkClick || removeAlert,
        textOKButton: content.textOKButton || 'OK',
        textWarningNo: content.textWarningNo || 'Não',
        textWarningYes: content.textWarningYes || 'Sim',
        type: content.type || AlertType.INFORMATION
      };
      setAlertInstance(alertOptions);
    }

    alertManager.on(ACTION_EVENTS.SHOW, function (content) {
      return buildAlert(content);
    }).on(ACTION_EVENTS.CLOSE, function () {
      return removeAlert();
    });
    return function cleanup() {
      alertManager.off(ACTION_EVENTS.SHOW).off(ACTION_EVENTS.CLOSE);
    };
  }, []);

  function removeAlert() {
    setAlertInstance({});
  }

  function onOkButtonClick() {
    alertInstance.onOkClick();
    removeAlert();
  }

  function onCancelButtonClick() {
    alertInstance.onCancelClick();
    removeAlert();
  }

  function onNoButtonClick() {
    alertInstance.onNoClick();
    removeAlert();
  }

  function getHeader() {
    var title;
    var iconName = 'info-circle';
    var iconColor;

    switch (alertInstance.type) {
      case AlertType.INFORMATION:
        title = 'Informação';
        iconColor = CALIMA_INFO;
        break;

      case AlertType.ERROR:
        iconName = 'times-circle';
        iconColor = CALIMA_DANGER;
        title = 'Erro';
        break;

      case AlertType.WARNING:
      case AlertType.WARNING_YES_NO:
      case AlertType.WARNING_YES_NO_CANCEL:
        iconName = 'exclamation-circle';
        iconColor = CALIMA_WARNING;
        title = 'Atenção';
        break;

      case AlertType.QUESTION:
      case AlertType.QUESTION_YES_NO_CANCEL:
        iconName = 'question-circle';
        iconColor = CALIMA_PRIMARY;
        title = 'Confirmação';
        break;
    }

    return React.createElement(React.Fragment, null, React.createElement(FontAwesomeIcon, {
      icon: iconName,
      color: iconColor
    }), " ", title);
  }

  function getButtons() {
    var buttons = null;

    switch (alertInstance.type) {
      case AlertType.INFORMATION:
      case AlertType.ERROR:
      case AlertType.WARNING:
      case AlertType.QUESTION:
        // 1 btn OK
        buttons = React.createElement(Button, {
          color: "first",
          onClick: onOkButtonClick
        }, alertInstance.textOKButton);
        break;

      case AlertType.WARNING_YES_NO:
        // 2 btn Sim/Não
        buttons = React.createElement(React.Fragment, null, React.createElement(Button, {
          color: "first",
          onClick: onOkButtonClick
        }, alertInstance.textWarningYes), React.createElement(Button, {
          color: "secondary",
          onClick: onNoButtonClick
        }, alertInstance.textWarningNo));
        break;

      case AlertType.WARNING_YES_NO_CANCEL: // 3 btn Sim/Não/Cancelar

      case AlertType.QUESTION_YES_NO_CANCEL:
        buttons = React.createElement(React.Fragment, null, React.createElement(Button, {
          color: "first",
          onClick: onOkButtonClick
        }, "Sim"), React.createElement(Button, {
          color: "secondary",
          onClick: onNoButtonClick
        }, "N\xE3o"), React.createElement(Button, {
          color: "neutral-second",
          onClick: onCancelButtonClick
        }, "Cancelar"));
        break;
    }

    return buttons;
  }

  function renderAlert() {
    var isString = typeof alertInstance.message === 'string';
    return React.createElement(Modal, {
      centered: true,
      backdrop: "static",
      isOpen: alertInstance.isOpen
    }, React.createElement(ModalHeader, null, getHeader()), React.createElement(ModalBody, {
      className: isString ? 'text-center' : ''
    }, isString ? React.createElement("p", null, alertInstance.message) : alertInstance.message), React.createElement(ModalFooter, {
      className: "justify-content-center"
    }, getButtons()));
  }

  return React.createElement(React.Fragment, null, alertInstance.message ? renderAlert() : null);
};

var InputContext = /*#__PURE__*/createContext(null);

var useInputContext = function useInputContext() {
  return useContext(InputContext);
};

var InputProvider = function InputProvider(_ref) {
  var children = _ref.children,
      onEvent = _ref.onEvent;
  return React.createElement(InputContext.Provider, {
    value: {
      onEvent: onEvent
    }
  }, children);
};

var Tooltip = function Tooltip(props) {
  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isOpen = _useState6[0],
      setIsOpen = _useState6[1];

  var debounceRef = useRef();
  var closedViaKeyboard = useRef(false);
  var isOpenRef = useRef(false);
  useEffect(function () {
    document.addEventListener('keydown', handleKeyDown, false);
    document.addEventListener('keyup', handleKeyUp, false);
    debounceRef.current = debounce(reShow, 500);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
      debounceRef.current.flush();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useEffect(function () {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  var handleKeyDown = function handleKeyDown() {
    if (isOpenRef.current) {
      closedViaKeyboard.current = true;
      setIsOpen(false);
    }
  };

  var handleKeyUp = function handleKeyUp() {
    if (!isOpenRef.current && closedViaKeyboard.current) {
      debounceRef.current();
    }
  };

  var reShow = function reShow() {
    if (!isOpenRef.current && closedViaKeyboard.current) {
      closedViaKeyboard.current = false;
      setIsOpen(true);
    }
  };

  var toggle = function toggle() {
    if (!isOpenRef.current && closedViaKeyboard.current) {
      closedViaKeyboard.current = false;
    } else {
      setIsOpen(!isOpen);
    }
  };

  return React.createElement(Tooltip$1, Object.assign({}, props, {
    isOpen: isOpen,
    toggle: toggle
  }));
};

function withTooltip(tooltipProps, name) {
  var result = null;

  if (tooltipProps && Object.keys(tooltipProps).length > 0) {
    var target = "id".concat(name.replace(/\./g, '_'));
    result = React.createElement(Tooltip, Object.assign({
      target: target
    }, tooltipProps), tooltipProps.message);
  }

  return result;
}

var InputType;

(function (InputType) {
  /** Renderiza o InputSearch */
  InputType[InputType["INPUT_SEARCH"] = 0] = "INPUT_SEARCH";
  InputType[InputType["DATE"] = 1] = "DATE";
  InputType[InputType["TIME"] = 2] = "TIME";
  InputType[InputType["REFERENCE"] = 3] = "REFERENCE";
  InputType[InputType["DROP_DOWN"] = 4] = "DROP_DOWN";
  InputType[InputType["CNPJ"] = 5] = "CNPJ";
  InputType[InputType["CPF"] = 6] = "CPF";
  InputType[InputType["CEP"] = 7] = "CEP";
  InputType[InputType["MASK"] = 8] = "MASK";
  InputType[InputType["EMAIL"] = 9] = "EMAIL";
  InputType[InputType["TELEFONE"] = 10] = "TELEFONE";
  InputType[InputType["NUMBER"] = 11] = "NUMBER";
  InputType[InputType["TEXT_AREA"] = 12] = "TEXT_AREA";
  InputType[InputType["PASSWORD"] = 13] = "PASSWORD";
  InputType[InputType["URL"] = 14] = "URL";
  InputType[InputType["FRACTION_OF_TIME"] = 15] = "FRACTION_OF_TIME";
  InputType[InputType["MONEY"] = 16] = "MONEY";
  InputType[InputType["PERCENT"] = 17] = "PERCENT";
  InputType[InputType["COLOR"] = 18] = "COLOR";
  InputType[InputType["CPF_CNPJ"] = 19] = "CPF_CNPJ";
})(InputType || (InputType = {}));

var viewMap = /*#__PURE__*/new Map();

function createLoadable(loader, importName) {
  var result = lazy(loader);
  viewMap.set(importName, result);
  return result;
}

function getViewElement(elementName) {
  return viewMap.get(elementName);
}

function dispatchClose(props, history) {
  var goBack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var isModal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (props) {
    if (!isModal) {
      history.replace(history.location.pathname, {});

      if (goBack) {
        history.goBack();
      }
    }
  }
}

function openChildView(props, history) {
  if (props) {
    history.push("".concat(history.location.pathname, "/edit"), props);
  }
}

var SearchViewModal = function SearchViewModal(props) {
  var SearchViewComp = getViewElement(props.searchViewId);

  var searchViewProps = _objectSpread(_objectSpread({}, props.searchViewProps), {}, {
    searchDataGridProps: _objectSpread(_objectSpread({}, props.searchDataGridProps), {}, {
      disableDoubleClick: props.disableDoubleClick,
      extraData: {
        isModal: true,
        size: 'xl'
      },
      onSelect: props.onSelect
    })
  });

  return React.createElement(Modal, Object.assign({
    size: props.modalProps.size || 'xl'
  }, props.modalProps), React.createElement(SearchViewComp, Object.assign({}, searchViewProps, {
    windowToggle: props.modalProps.toggle
  })), React.createElement(ModalFooter, null, React.createElement(Button, {
    color: "success",
    onClick: props.onSelect,
    size: "sm"
  }, React.createElement(FontAwesomeIcon, {
    icon: "cog"
  }), " OK"), React.createElement(Button, {
    type: "button",
    color: "danger",
    className: "mr-2",
    size: "sm",
    onClick: props.modalProps.toggle
  }, React.createElement(FontAwesomeIcon, {
    icon: "times"
  }), " Cancelar")));
};

var InputSearchGroupInlineAppend = function InputSearchGroupInlineAppend(props) {
  var isMulti = props.inputSearchProps && props.inputSearchProps.selectProps && props.inputSearchProps.selectProps.isMulti;
  var inputValue = isMulti ? [] : null;

  if (props.formProps.getValues && props.formProps.getValues()[props.id]) {
    inputValue = props.formProps.getValues()[props.id];
  }

  var onHideHandler = function onHideHandler() {
    props.setShow(false);
  };

  var onSelectHandler = function onSelectHandler() {
    onHideHandler();
    props.setInputValue(inputValue);
    props.formProps.setValue(props.id, inputValue, true);

    if (props.onChange) {
      props.onChange(inputValue);
    }
  };

  var handleOnSelect = function handleOnSelect(row, isSelect, rowIndex, e) {
    // Update disparado pelo SearchDataGrid para atualizar os itens já selecionados
    if (rowIndex === -1 && e === 'forceUpdate' && inputValue) {
      if (isMulti) {
        inputValue = inputValue.map(function (item) {
          return row.find(function (it) {
            return it.id === item.id;
          }) || item;
        });
      } else {
        inputValue = row.find(function (it) {
          return it.id === inputValue.id;
        }) || inputValue;
      }
    } else if (rowIndex === -1 && e === 'setFromNew') {
      if (isMulti) {
        inputValue = row;
      } else {
        inputValue = row.length > 0 ? row[0] : null;
      }
    } else {
      if (isMulti) {
        if (isSelect) {
          inputValue = inputValue.concat(row);
        } else {
          inputValue = inputValue.filter(function (it) {
            return it.id !== row.id;
          });
        }
      } else {
        inputValue = row;
      }
    }

    return true;
  };

  var selected = null;

  if (inputValue) {
    if (isMulti) {
      selected = inputValue.map(function (it) {
        return it.id;
      });
    } else {
      selected = [inputValue.id];
    }
  }

  var defaultSearchExpressions = function defaultSearchExpressions() {
    return [{
      fieldName: 'id',
      value: selected
    }];
  };

  var emptySearchExpressions = function emptySearchExpressions() {
    return [];
  };

  var searchDataGridProps = {
    defaultSearchExpressions: defaultSearchExpressions,
    searchExpressions: props.inputSearchProps && props.inputSearchProps.searchExpressions ? props.inputSearchProps.searchExpressions : emptySearchExpressions,
    selectRow: {
      clickToSelect: true,
      hideSelectAll: true,
      mode: isMulti ? 'checkbox' : 'radio',
      onSelect: handleOnSelect,
      selected: selected
    }
  };
  return React.createElement(SearchViewModal, {
    modalProps: {
      isOpen: props.show,
      toggle: onHideHandler,
      size: props.inputSearchProps.size || 'xl',
      backdrop: 'static'
    },
    onSelect: onSelectHandler,
    searchViewId: props.inputSearchProps.searchViewId,
    searchDataGridProps: searchDataGridProps,
    searchViewProps: props.searchViewProps,
    disableDoubleClick: props.disableDoubleClick
  });
};

var InputGroupInlineAppend = function InputGroupInlineAppend(props) {
  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      show = _useState8[0],
      setShow = _useState8[1];

  var iconAppend = props.iconAppend;
  var appendClickHandler = props.appendClickHandler;
  var complemento = null;

  switch (props.type) {
    case InputType.INPUT_SEARCH:
      if (props.inputSearchProps && props.inputSearchProps.searchViewId) {
        iconAppend = iconAppend || 'external-link-alt';

        var isAppendClickHandler = function isAppendClickHandler(event) {
          event.stopPropagation();
          setShow(true);
        };

        appendClickHandler = appendClickHandler || isAppendClickHandler;
        complemento = React.createElement(InputSearchGroupInlineAppend, Object.assign({}, props, {
          show: show,
          setShow: setShow
        }));
      }

      break;

    case InputType.URL:
      iconAppend = iconAppend || 'link';
      var inputValue = props.formProps.getValues()[props.id];

      var openUrl = function openUrl(event) {
        event.stopPropagation();

        if (!(props.formProps.errors[props.id] || !inputValue)) {
          window.open(inputValue, '_blank');
        }
      };

      appendClickHandler = appendClickHandler || openUrl;
      complemento = withTooltip({
        message: 'Ir para...'
      }, "".concat(props.id, "-append"));
      break;

    case InputType.FRACTION_OF_TIME:
      iconAppend = iconAppend || 'clock';
      var inputValueFmt = props.formProps.watch("".concat(props.id, "Fmt"));
      complemento = React.createElement(InputGroupText, null, inputValueFmt ? inputValueFmt : '00:00h');
      break;
  }

  var fontAwesomeIcon = iconAppend ? React.createElement(FontAwesomeIcon, {
    icon: iconAppend
  }) : null;
  var cursorStyle = appendClickHandler ? {
    cursor: 'pointer'
  } : null;
  var appendClickFunc = appendClickHandler;

  if (props.disabled) {
    cursorStyle = {
      cursor: 'not-allowed'
    };
    appendClickFunc = null;
  }

  return fontAwesomeIcon ? React.createElement(InputGroupAddon, {
    addonType: "append"
  }, React.createElement(InputGroupText, {
    onClick: appendClickFunc,
    style: cursorStyle,
    id: "id".concat(props.id, "-append")
  }, fontAwesomeIcon), complemento) : null;
};

var InputCpfCnpjType;

(function (InputCpfCnpjType) {
  InputCpfCnpjType["CPF"] = "CPF";
  InputCpfCnpjType["CNPJ"] = "CNPJ";
})(InputCpfCnpjType || (InputCpfCnpjType = {}));

var InputCpfCnpj = function InputCpfCnpj(props) {
  var _useState9 = useState(InputCpfCnpjType.CPF),
      _useState10 = _slicedToArray(_useState9, 2),
      type = _useState10[0],
      setType = _useState10[1];

  var uniqueId = useRef(Math.floor(Math.random() * 10001));
  var cpf = useRef();
  var cnpj = useRef();
  var value = props.formProps.watch(props.inputProps.name);
  var inputFmt = "".concat(props.inputProps.name, "Fmt");
  var isInvalid = props.inputProps.className.indexOf('is-invalid') !== -1;
  useEffect(function () {
    if (value && value.length === 11) {
      cpf.current.setInputValue(cpfMaskFormatter(value));
      setType(InputCpfCnpjType.CPF);
    } else if (value && value.length === 14) {
      cnpj.current.setInputValue(cnpjMaskFormatter(value));
      setType(InputCpfCnpjType.CNPJ);
    } else {
      if (cpf.current.getInputValue().length === 11) {
        cpf.current.setInputValue('');
      }

      if (cnpj.current.getInputValue().length === 14) {
        cnpj.current.setInputValue('');
      }
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [value]);

  var onChangeType = function onChangeType(e) {
    setType(e.currentTarget.value);
    var val = (e.currentTarget.value === InputCpfCnpjType.CPF ? cpf : cnpj).current.value.replace(/\D/g, '');

    if (val.length === 11 || val.length === 14) {
      props.formProps.setValue(props.inputProps.name, val);
      props.formProps.triggerValidation(props.inputProps.name);
    } else {
      props.formProps.setValue(props.inputProps.name, null);
    }
  };

  var onChangeCPF = function onChangeCPF(e) {
    var val = e.currentTarget.value.replace(/\D/g, '');

    if (val.length === 0 || val.length === 11) {
      props.formProps.setValue(props.inputProps.name, val || null, true);
    }
  };

  var onChangeCNPJ = function onChangeCNPJ(e) {
    var val = e.currentTarget.value.replace(/\D/g, '');

    if (val.length === 0 || val.length === 14) {
      props.formProps.setValue(props.inputProps.name, val || null, true);
    }
  };

  var onBlurCPF = function onBlurCPF(e) {
    if (type === InputCpfCnpjType.CPF) {
      var val = e.currentTarget.value.replace(/\D/g, '');
      props.formProps.setValue(props.inputProps.name, val || null, true);

      if (props.onBlur) {
        props.onBlur();
      }
    }
  };

  var onBlurCNPJ = function onBlurCNPJ(e) {
    if (type === InputCpfCnpjType.CNPJ) {
      var val = e.currentTarget.value.replace(/\D/g, '');
      props.formProps.setValue(props.inputProps.name, val || null, true);

      if (props.onBlur) {
        props.onBlur();
      }
    }
  };

  return React.createElement("div", {
    id: "id".concat(inputFmt),
    className: cx('input-cpf-cnpj', {
      'is-invalid': isInvalid
    })
  }, React.createElement(CustomInput, {
    type: "radio",
    name: "type",
    value: InputCpfCnpjType.CPF,
    label: "CPF",
    id: "type-CPF-".concat(uniqueId.current),
    checked: type === InputCpfCnpjType.CPF,
    onChange: onChangeType,
    className: "radio-cpf",
    invalid: isInvalid && type === InputCpfCnpjType.CPF
  }), React.createElement(CustomInput, {
    type: "radio",
    name: "type",
    value: InputCpfCnpjType.CNPJ,
    label: "CNPJ",
    id: "type-CNPJ-".concat(uniqueId.current),
    checked: type === InputCpfCnpjType.CNPJ,
    onChange: onChangeType,
    className: "radio-cnpj",
    invalid: isInvalid && type === InputCpfCnpjType.CNPJ
  }), React.createElement("div", {
    className: cx('flex-grow-1', {
      'd-none': type === InputCpfCnpjType.CNPJ
    })
  }, React.createElement(InputMask, {
    className: cx('form-control-sm', props.inputProps.className),
    name: "cpf",
    ref: cpf,
    onChange: onChangeCPF,
    onBlur: onBlurCPF,
    mask: "999.999.999-99",
    maskChar: null
  })), React.createElement("div", {
    className: cx('flex-grow-1', {
      'd-none': type === InputCpfCnpjType.CPF
    })
  }, React.createElement(InputMask, {
    className: cx('form-control-sm', props.inputProps.className),
    name: "cnpj",
    ref: cnpj,
    onChange: onChangeCNPJ,
    onBlur: onBlurCNPJ,
    mask: "99.999.999/9999-99",
    maskChar: null
  })), React.createElement("input", {
    type: "hidden",
    name: props.inputProps.name,
    ref: props.formProps.register(props.formProps.validation)
  }), withTooltip(props.tooltipProps, inputFmt));
};

function getInputDateMask(dateFormat, timeFormat) {
  var mask = '';

  if (typeof dateFormat === 'string') {
    mask += dateFormat;

    if (timeFormat) {
      mask += ' ';
    }
  }

  if (typeof timeFormat === 'string') {
    mask += timeFormat;
  }

  return mask;
}

var InputDate = function InputDate(props) {
  var mask = getInputDateMask(props.dateProps.dateFormat, props.dateProps.timeFormat);
  var inputRef = useRef();

  function handleChange(_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
        momentValue = _ref3[0];

    var value = null;

    if (momentValue && typeof momentValue === 'object') {
      var dateValue = momentValue.toDate();
      value = format(dateValue, mask);
    }

    props.formProps.setValue(props.propName, value);

    if (value) {
      props.formProps.triggerValidation(props.propName);
    }

    if (props.onChange && props.dateProps.value !== value) {
      props.onChange(value);
    }

    var result = momentValue.length && momentValue !== '__/__/____' ? momentValue : value;

    if (typeof momentValue === 'string' && momentValue.indexOf('_') === -1 && !value) {
      result = null;
    }

    return result;
  }

  function handleBlur() {
    props.formProps.triggerValidation(props.propName);

    if (typeof inputRef.current !== 'undefined' && inputRef.current.state !== null) {
      if (inputRef.current.state.inputValue.indexOf('_') !== -1) {
        props.formProps.setValue(props.propName, null);
      }

      if (inputRef.current.state.selectedDate === null) {
        inputRef.current.setState(_objectSpread(_objectSpread({}, inputRef.current.state), {}, {
          inputValue: '__/__/____'
        }));
      }
    }

    if (props.onBlur) {
      setTimeout(function () {
        return props.onBlur();
      }, 150);
    }
  }

  var dateProps = _objectSpread(_objectSpread({}, props.dateProps), {}, {
    inputProps: _objectSpread(_objectSpread({}, props.dateProps.inputProps), {}, {
      name: props.propName
    }),
    renderInput: function renderInput(renderInputProps, openCalendar, closeCalendar) {
      var onBlur = function onBlur() {
        return !inputRef.current.state.open && handleBlur();
      }; // @ts-ignore


      return props.dateProps.renderInput(_objectSpread(_objectSpread({}, renderInputProps), {}, {
        onBlur: onBlur
      }), openCalendar, closeCalendar);
    }
  });

  return React.createElement(Controller, {
    testId: "input-date",
    as: React.createElement(DateTime, Object.assign({}, dateProps, {
      ref: inputRef,
      closeOnSelect: true
    })),
    name: props.propName,
    control: props.formProps.control,
    rules: props.formProps.validation,
    onChange: handleChange,
    onBlur: handleBlur,
    mode: "onBlur"
  });
};

var InputDropDownControl = function InputDropDownControl(props) {
  var ref = useRef();

  var handleChange = function handleChange(selectedOption) {
    props.setInputValue(selectedOption);

    if (props.onChangeValue) {
      props.onChangeValue(selectedOption && selectedOption.value);
    }

    props.onChange(selectedOption && selectedOption.value);
  };

  var handleBlur = function handleBlur() {
    try {
      if (props.onBlurInput) {
        props.onBlurInput();
      }

      props.onBlur();
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleKeyDown = function handleKeyDown(evt) {
    if (evt.key === 'Enter') {
      evt.preventDefault();

      if (ref.current && ref.current.select.state.focusedOption) {
        ref.current.select.selectOption(ref.current.select.state.focusedOption);
      }

      if (props.selectProps && props.selectProps.onKeyUp) {
        props.selectProps.onKeyUp(evt);
      }
    }
  };

  var noOptionsMessage = function noOptionsMessage(inputTest) {
    return 'Nenhum resultado encontrado';
  };

  var formatOptionLabel = function formatOptionLabel(option, labelMeta) {
    return props.labelPropName ? option[props.labelPropName] : option.label;
  };

  return React.createElement(React.Fragment, null, React.createElement(Select, Object.assign({}, props.selectProps, {
    testId: "input-dropdown",
    ref: ref,
    value: props.selectProps.defaultValue,
    isClearable: props.selectProps.hasOwnProperty('isClearable') ? props.selectProps.isClearable : true,
    cacheOptions: true,
    onChange: handleChange,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    name: props.selectProps.name,
    noOptionsMessage: props.selectProps.noOptionsMessage || noOptionsMessage,
    formatOptionLabel: formatOptionLabel
  })), withTooltip(props.tooltipProps, props.selectProps.name));
};

var InputDropDown = function InputDropDown(props) {
  var dropDownProps = _objectSpread(_objectSpread({}, props), {}, {
    onBlurInput: props.onBlur,
    onChangeValue: props.onChange
  });

  return React.createElement(Controller, {
    as: React.createElement(InputDropDownControl, Object.assign({}, dropDownProps)),
    name: props.selectProps.name,
    control: props.formProps.control,
    rules: props.formProps.validation,
    mode: "onBlur"
  });
};

var getMin = function getMin(validation) {
  var result = null;

  if (validation && validation.min) {
    result = typeof validation.min === 'object' ? validation.min.value : validation.min;
  }

  return result;
};

var getMax = function getMax(validation) {
  var result = null;

  if (validation && validation.max) {
    result = typeof validation.max === 'object' ? validation.max.value : validation.max;
  }

  return result;
};

var InputFractionOfTime = function InputFractionOfTime(props) {
  var propFmt = "".concat(props.inputProps.name, "Fmt");
  var min = getMin(props.formProps.validation);
  var max = getMax(props.formProps.validation);
  var lastValidValue = useRef(min);
  var debounceRef = useRef();
  useEffect(function () {
    debounceRef.current = debounce(onDebounce, 500);
    return function () {
      return debounceRef.current.flush();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  var onDebounce = function onDebounce(val) {
    var value = parseFloat(val);

    if (!isNaN(value)) {
      if (min && min > value) {
        handleChange({
          target: {
            value: lastValidValue.current.toFixed(2)
          }
        });
      } else if (max && max < value) {
        handleChange({
          target: {
            value: lastValidValue.current.toFixed(2)
          }
        });
      } else {
        lastValidValue.current = value;
      }
    }
  };

  var handleBlur = function handleBlur() {
    try {
      return Promise.resolve(props.formProps.triggerValidation(props.inputProps.name)).then(function () {
        var inputValue = props.formProps.getValues()[props.inputProps.name];
        var result;

        if (inputValue) {
          if (inputValue.indexOf(':') > -1) {
            var splitedHour = inputValue.split(':');
            splitedHour[0] = parseFloat(splitedHour[0]) || 0;
            splitedHour[0] += splitedHour[1] && !isNaN(splitedHour[1]) ? parseFloat(splitedHour[1]) / 60 : 0;
            result = splitedHour[0];
          } else {
            result = inputValue;
          }

          props.formProps.setValue(propFmt, getTime(result), false);
          props.formProps.setValue(props.inputProps.name, parseFloat((Math.round(result * 100) / 100).toString()).toFixed(2), false);
        } else {
          props.formProps.setValue(propFmt, null, false);
          props.formProps.setValue(props.inputProps.name, '', false);
        }

        if (props.onBlur) {
          props.onBlur();
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleChange = function handleChange(evt) {
    var time = evt.target.value.replace(',', '.').trim();
    var value;

    if (isNaN(time) && time.indexOf(':') < 0) {
      value = '';
    } else {
      value = time;
    }

    props.formProps.setValue(props.inputProps.name, value);
    debounceRef.current(value);

    if (props.onChange) {
      props.onChange(value);
    }
  };

  function getTime(fractionOfTime) {
    var hours = parseInt(fractionOfTime.toString(), 10);
    var minutes = (fractionOfTime - hours) * 60;
    minutes = Math.abs(Math.round(minutes));

    if (minutes === 60) {
      minutes = 0;
      hours += 1;
    }

    return "".concat(fillText(hours.toString(), 2, '0'), ":").concat(fillText(minutes.toString(), 2, '0'), "h");
  }

  return React.createElement(React.Fragment, null, React.createElement("input", Object.assign({}, props.inputProps, {
    type: "text",
    onBlur: handleBlur,
    onChange: handleChange,
    ref: props.formProps.register(props.formProps.validation),
    "data-testid": "input-fraction"
  })), withTooltip(props.tooltipProps, props.inputProps.name), React.createElement("input", {
    type: "hidden",
    ref: props.formProps.register({
      name: propFmt
    })
  }));
};

var InputMasked = function InputMasked(props) {
  var _useState11 = useState(typeof props.mask === 'string' ? props.mask : props.mask[0]),
      _useState12 = _slicedToArray(_useState11, 2),
      mask = _useState12[0],
      setMask = _useState12[1];

  var formValue = props.formProps && props.formProps.watch(props.inputProps.name);
  var message = props.formProps.validation && props.formProps.validation.pattern && props.formProps.validation.pattern.message;
  var debounceRef = useRef();
  var externalChange = useRef(false);
  var internalChange = useRef(false);
  var inputRef = useRef();
  useEffect(function () {
    debounceRef.current = debounce(onDebounce, 500);
    return function () {
      return debounceRef.current.flush();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useEffect(function () {
    if (formValue) {
      if (internalChange.current) {
        internalChange.current = false;
      } else {
        adjustMask(formValue, true);
        externalChange.current = true;
        inputRef.current.onChange({
          target: {
            value: formValue
          }
        });
      }
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [formValue]);

  var getCleanValue = function getCleanValue(formatValue) {
    return formatValue.replace(/[^A-Za-z0-9_]/g, '').trim();
  };

  var adjustMask = function adjustMask(value) {
    var eq = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var valueClean = getCleanValue(value);
    var maskClean = getCleanValue(mask);
    var propsMask = typeof props.mask === 'string' ? [] : props.mask;
    var newMask = null;

    if (valueClean.length === maskClean.length) {
      newMask = propsMask.find(function (it) {
        return getCleanValue(it).length > valueClean.length;
      });
    } else if (eq) {
      newMask = propsMask.find(function (it) {
        return getCleanValue(it).length === valueClean.length;
      });
    }

    if (newMask) {
      setMask(newMask);
    }

    return valueClean.length === maskClean.length || !!newMask;
  };

  var onDebounce = function onDebounce(inputValue) {
    var value = getCleanValue(inputValue);
    props.formProps.setValue(props.inputProps.name, value);

    if (props.onChange) {
      props.onChange(value);
    }
  };

  var onChangeHandler = function onChangeHandler(event) {
    internalChange.current = true;
    adjustMask(event.target.value);
    debounceRef.current(event.target.value);
  };

  var onBlurHandler = function onBlurHandler(event) {
    if (adjustMask(event.target.value, true) || getCleanValue(event.target.value).length === 0) {
      props.formProps.triggerValidation(props.inputProps.name);
    } else {
      props.formProps.setError(props.inputProps.name, 'pattern', message);
    }

    if (props.onBlur) {
      props.onBlur();
    }
  };

  var onFocusHandler = function onFocusHandler(event) {
    return adjustMask(event.target.value);
  };

  var beforeMaskedValueChange = function beforeMaskedValueChange(event) {
    if (externalChange.current) {
      event.value = new StringMask(mask).apply(formValue);
      externalChange.current = false;
    }

    return event;
  };

  return React.createElement(React.Fragment, null, React.createElement(InputMask, Object.assign({}, _objectSpread(_objectSpread({}, props.inputProps), {}, {
    name: "".concat(props.inputProps, "Fmt")
  }), {
    mask: mask,
    maskChar: null,
    onChange: onChangeHandler,
    onBlur: onBlurHandler,
    onFocus: onFocusHandler,
    beforeMaskedValueChange: beforeMaskedValueChange,
    ref: inputRef,
    testId: "input-mask"
  })), React.createElement("div", {
    ref: props.formProps.register({
      name: props.inputProps.name
    }, props.formProps.validation)
  }), withTooltip(props.tooltipProps, props.inputProps.name));
};

var InputMaskPolyfill = function InputMaskPolyfill(props) {
  var hadEvent = useRef(null);
  useEffect(function () {
    window.addEventListener('programatic', onProgramaticEvent, false);
    return function () {
      window.removeEventListener('programatic', onProgramaticEvent);
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  var onProgramaticEvent = function onProgramaticEvent(e) {
    if (e.detail.element.id === props.id || e.detail.element.name === props.name) {
      hadEvent.current = 'focus';
    } else if (!e.detail.ignoreBlur) {
      hadEvent.current = 'blur';
    }
  };

  var onBlur = function onBlur(e) {
    e.persist();

    if (props.onBlur) {
      props.onBlur(cloneEvent(e), hadEvent.current === 'blur');
      hadEvent.current = null;
    }
  };

  var onFocus = function onFocus(e) {
    e.persist();

    if (props.onFocus) {
      props.onFocus(cloneEvent(e), hadEvent.current === 'focus');
      hadEvent.current = null;
    }
  };

  return React.createElement(MaskedInput, Object.assign({}, props, {
    mask: props.mask.replace(/9/g, '1'),
    onBlur: onBlur,
    onFocus: onFocus
  }));
};

var getMinMaxZero = function getMinMaxZero(validation) {
  return {
    max: getMaxMoney(validation),
    min: validation && validation.min && validation.min.value || 0,
    zeroDefault: validation && validation.zeroDefault
  };
};

var InputMoney = function InputMoney(props) {
  var inputFmt = "".concat(props.inputProps.name.replace(/\./g, '_'), "Fmt");
  var value = props.formProps.watch(props.inputProps.name);
  var inputRef = useRef();
  var oldValue = useRef(value || null);

  var _getMinMaxZero = getMinMaxZero(props.formProps.validation),
      min = _getMinMaxZero.min,
      max = _getMinMaxZero.max,
      zeroDefault = _getMinMaxZero.zeroDefault;

  useEffect(function () {
    if (props.inputProps && props.inputProps.autoFocus) {
      inputRef.current.focus();
    }

    if (zeroDefault && (value === null || value === undefined)) {
      props.formProps.setValue(props.inputProps.name, 0);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useEffect(function () {
    inputRef.current.value = decimalMaskFormatter(isEmpty(value) ? 0 : parseFloat(value));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [value]);

  var inputToFloat = function inputToFloat(inputValue) {
    var val = parseFloat(getMaxFloatValue("0".concat(inputValue).replace(/\D/g, '').replace(/(\d+)(\d{2})+/g, '$1.$2')));
    return (isNaN(val) || val === 0) && !zeroDefault ? null : val;
  };

  var atTheEnd = function atTheEnd() {
    return setTimeout(function () {
      inputRef.current.selectionStart = inputRef.current.value.toString().length;
      inputRef.current.selectionEnd = inputRef.current.value.toString().length;
    }, 50);
  };

  var setValue = function setValue() {
    return props.formProps.setValue(props.inputProps.name, inputToFloat(inputRef.current.value));
  };

  var onBlur = function onBlur() {
    try {
      setValue();
      return Promise.resolve(props.formProps.triggerValidation(props.inputProps.name)).then(function () {
        if (props.onBlur) {
          props.onBlur();
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var onKeyDown = function onKeyDown() {
    oldValue.current = inputToFloat(inputRef.current.value);
  };

  var onKeyUp = function onKeyUp(e) {
    var val = inputToFloat(e.target.value);
    var keyCode = e.keyCode || e.which;
    var ignoreOldValue = keyCode === 8 || keyCode === 9;
    var result = val >= min && val <= max || ignoreOldValue ? val : oldValue.current;
    inputRef.current.value = decimalMaskFormatter(result);
    atTheEnd();

    if (props.onChange) {
      props.onChange(result);
    }

    if (props.inputProps && props.inputProps.onKeyUp) {
      props.inputProps.onKeyUp(e);
    }
  };

  return React.createElement(React.Fragment, null, React.createElement("input", Object.assign({}, props.inputProps, {
    id: "id".concat(inputFmt),
    name: inputFmt,
    ref: inputRef,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onFocus: atTheEnd,
    onBlur: onBlur,
    "data-testid": "input-money",
    maxLength: getMaxLengthMoney(max)
  })), React.createElement("div", {
    ref: props.formProps.register(props.inputProps.name, props.formProps.validation)
  }), withTooltip(props.tooltipProps, inputFmt));
};

var InputNumber = function InputNumber(props) {
  var inputRef = useRef();
  var debounceRef = useRef();
  var formatPrecision = useRef(true);
  var value = props.formProps.watch(props.inputProps.name);
  var precision = props.formProps.validation && props.formProps.validation.precision || null;
  useEffect(function () {
    debounceRef.current = debounce(onDebounce, 1000);
    return function () {
      return debounceRef.current.flush();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useEffect(function () {
    if (precision && !isNaN(precision) && value) {
      toPrecision();
    } else {
      setValue(value);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [value]);

  var toPrecision = function toPrecision() {
    if (precision && !isNaN(precision)) {
      if (formatPrecision.current) {
        setValue(value ? parseFloat(value.toString()).toFixed(precision) : null);
      } else {
        formatPrecision.current = true;
      }
    }
  };

  var setValue = function setValue(v) {
    return inputRef.current.value = isNaN(v) ? '' : v;
  };

  var onDebounce = function onDebounce() {
    var val = inputRef.current.value;

    if (val.toString().indexOf(',') !== -1) {
      val = val.replace(/\./g, '').replace(',', '.');
    }

    var num = parseFloat(val);

    if (isNaN(num)) {
      num = null;
    } else {
      if (val.length >= 14) {
        num = MAX_NUMBER;
      }
    }

    formatPrecision.current = false;
    props.formProps.setValue(props.inputProps.name, num);

    if (props.onChange) {
      props.onChange(num);
    }
  };

  var handleChange = function handleChange(event) {
    if (event.persist) {
      event.persist();
    }

    setValue(event.target.value.replace(/((?![\d,.]).)/g, ''));
    debounceRef.current();
  };

  var handleBlur = function handleBlur() {
    try {
      onDebounce();
      formatPrecision.current = true;
      toPrecision();
      return Promise.resolve(props.formProps.triggerValidation(props.inputProps.name)).then(function () {
        if (props.onBlur) {
          props.onBlur();
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return React.createElement(React.Fragment, null, React.createElement("input", Object.assign({}, props.inputProps, {
    onChange: handleChange,
    onBlur: handleBlur,
    ref: inputRef,
    "data-testid": "input-number"
  })), React.createElement("div", {
    ref: props.formProps.register(props.inputProps.name, props.formProps.validation)
  }), withTooltip(props.tooltipProps, props.inputProps.name));
};

var getFloatString = function getFloatString(v, precision) {
  var val = "000000".concat(v).replace(/\D/g, '');
  var int = val.substr(0, val.length - precision);
  var dec = val.substr(val.length - precision, val.length);
  return "".concat(int, ".").concat(dec);
};

var inputToFloat = function inputToFloat(inputValue, precision, zeroDefault) {
  var val = parseFloat(getFloatString(inputValue, precision));
  return (isNaN(val) || val === 0) && !zeroDefault ? null : val;
};

var getMinMaxZero$1 = function getMinMaxZero$1(validation) {
  return {
    max: validation && validation.max || 100,
    min: validation && validation.min || 0,
    precision: validation && validation.precision || 2,
    zeroDefault: validation && validation.zeroDefault
  };
};

var InputPercent = function InputPercent(props) {
  var inputFmt = "".concat(props.inputProps.name.replace(/\./g, '_'), "Fmt");
  var value = props.formProps.watch(props.inputProps.name);
  var inputRef = useRef();
  var oldValue = useRef(value || null);

  var _getMinMaxZero$ = getMinMaxZero$1(props.formProps.validation),
      min = _getMinMaxZero$.min,
      max = _getMinMaxZero$.max,
      zeroDefault = _getMinMaxZero$.zeroDefault,
      precision = _getMinMaxZero$.precision;

  useEffect(function () {
    if (props.inputProps && props.inputProps.autoFocus) {
      inputRef.current.focus();
    }

    if (zeroDefault && (value === null || value === undefined)) {
      props.formProps.setValue(props.inputProps.name, 0);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useEffect(function () {
    inputRef.current.value = format(isEmpty(value) ? 0 : parseFloat(value));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [value]);

  var format = function format(val) {
    return val.toFixed(precision).replace('.', ',');
  };

  var atTheEnd = function atTheEnd() {
    inputRef.current.selectionStart = inputRef.current.value.toString().length;
    inputRef.current.selectionEnd = inputRef.current.value.toString().length;
  };

  var setValue = function setValue() {
    return props.formProps.setValue(props.inputProps.name, inputToFloat(inputRef.current.value, precision, zeroDefault));
  };

  var onKeyDown = function onKeyDown() {
    var val = inputToFloat(inputRef.current.value, precision, zeroDefault);

    if (val >= min && val <= max) {
      oldValue.current = val;
    }
  };

  var onKeyUp = function onKeyUp(e) {
    var val = inputToFloat(e.target.value, precision, zeroDefault);
    var result = val >= min && val <= max ? val : oldValue.current;
    inputRef.current.value = format(result || 0);
    atTheEnd();

    if (props.onChange) {
      props.onChange(result);
    }

    if (props.inputProps && props.inputProps.onKeyUp) {
      props.inputProps.onKeyUp(e);
    }
  };

  var onBlur = function onBlur() {
    try {
      setValue();
      return Promise.resolve(props.formProps.triggerValidation(props.inputProps.name)).then(function () {
        if (props.onBlur) {
          props.onBlur();
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return React.createElement(React.Fragment, null, React.createElement("input", Object.assign({}, props.inputProps, {
    id: "id".concat(inputFmt),
    name: inputFmt,
    ref: inputRef,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onFocus: atTheEnd,
    onBlur: onBlur,
    "data-testid": "input-percent",
    maxLength: precision + 4
  })), React.createElement("div", {
    ref: props.formProps.register(props.inputProps.name, props.formProps.validation)
  }), withTooltip(props.tooltipProps, inputFmt));
};

var InputReference = function InputReference(props) {
  var watchProp = props.formProps.watch(props.propName);
  var mask = typeof props.dateProps.dateFormat === 'string' ? props.dateProps.dateFormat : '';
  var propFmt = "".concat(props.propName, "Fmt");
  var inputRef = useRef();
  useEffect(function () {
    var newRef = refToFormat(watchProp);

    if (newRef !== inputRef.current.state.inputValue) {
      props.formProps.setValue(propFmt, refToFormat(watchProp));
    }
  }, [watchProp]);

  function handleChange(_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
        momentValue = _ref5[0];

    var value = null;

    if (momentValue !== '' && momentValue !== '__/____') {
      if (momentValue && typeof momentValue === 'object') {
        var dateValue = momentValue.toDate();
        value = format(dateValue, mask);
        props.formProps.setValue(props.propName, format(dateValue, REF_PATTERN));
      }

      if (value) {
        props.formProps.triggerValidation(props.propName);
      }

      if (props.onChange) {
        props.onChange(value);
      }
    }

    return momentValue.length && momentValue !== '__/____' ? momentValue : value;
  }

  function handleBlur() {
    if (!props.formProps.getValues()[propFmt]) {
      props.formProps.setValue(props.propName, null);
    }

    if (typeof inputRef.current !== 'undefined' && inputRef.current.state !== null && inputRef.current.state.selectedDate === null) {
      inputRef.current.setState(_objectSpread(_objectSpread({}, inputRef.current.state), {}, {
        inputValue: '__/____'
      }));
    }

    if (props.onBlur) {
      props.onBlur();
    }
  }

  var dateProps = _objectSpread(_objectSpread({}, props.dateProps), {}, {
    inputProps: _objectSpread(_objectSpread({}, props.dateProps.inputProps), {}, {
      name: propFmt
    }),
    renderInput: function renderInput(renderInputProps, openCalendar, closeCalendar) {
      var onBlur = function onBlur() {
        return !inputRef.current.state.open && handleBlur();
      }; // @ts-ignore


      return props.dateProps.renderInput(_objectSpread(_objectSpread({}, renderInputProps), {}, {
        onBlur: onBlur
      }), openCalendar, closeCalendar);
    }
  });

  return React.createElement(React.Fragment, null, React.createElement(Controller, {
    testId: "input-reference",
    as: React.createElement(DateTime, Object.assign({}, dateProps, {
      ref: inputRef,
      closeOnSelect: true
    })),
    name: propFmt,
    control: props.formProps.control,
    rules: props.formProps.validation,
    onChange: handleChange,
    onBlur: handleBlur,
    mode: "onBlur"
  }), React.createElement("input", {
    type: "hidden",
    name: props.propName,
    ref: props.formProps.register
  }));
};

var InputSearch = function InputSearch(props) {
  var ref = useRef();
  var searchCriteria = {
    className: props.dtoClassName,
    fetchType: 'PAGED',
    max: props.maxResults || 10,
    sortFieldName: props.sortFieldName,
    start: 0
  };
  useEffect(function () {
    var wrapper = ref.current.select.select.controlRef.parentElement;
    wrapper.addEventListener('externalFocus', onExternalFocus, false);
    return function () {
      return wrapper.removeEventListener('externalFocus', onExternalFocus);
    };
  }, []);

  var loadOptions = function loadOptions(inputValue, callback) {
    if (props.customSearch) {
      props.customSearch({
        errorFunction: function errorFunction(mensagem) {
          showToast(mensagem, ERROR);
        },
        thenFunction: function thenFunction(result) {
          callback(result);
        }
      }, inputValue);
    } else {
      var searchExpressions = [];

      if (!isEmpty(inputValue)) {
        props.columns.forEach(function (col) {
          searchExpressions.push({
            fieldName: col.dataField,
            value: inputValue
          });
        });
      }

      if (props.searchExpressionsFull) {
        searchExpressions = props.searchExpressionsFull(searchExpressions);
      }

      if (props.searchExpressions) {
        searchExpressions = searchExpressions.concat(props.searchExpressions());
      }

      searchCriteria.expressions = adjustExpressions(searchExpressions);
      findAllByExpression(searchCriteria, {
        errorFunction: function errorFunction(mensagem) {
          showToast(mensagem, ERROR);
        },
        thenFunction: function thenFunction(result) {
          callback(result.content);
        }
      });
    }
  };

  var handleChange = function handleChange(selectedOption) {
    props.formProps.setValue(props.selectProps.id, selectedOption, true);
    props.setInputValue(selectedOption);

    if (props.onChange) {
      props.onChange(selectedOption);
    }
  };

  var handleBlur = function handleBlur() {
    try {
      return Promise.resolve(props.formProps.triggerValidation(props.selectProps.id)).then(function () {
        if (props.onBlur) {
          props.onBlur();
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var noOptionsMessage = function noOptionsMessage(inputTest) {
    var result;

    if (inputTest && isEmpty(inputTest.inputValue)) {
      result = props.noOptionsMessage || "Busque por: ".concat(props.columns.map(function (it) {
        return it.text;
      }).join(', '));
    } else {
      result = 'Nenhum resultado encontrado';
    }

    return result;
  };

  var handleKeyDown = function handleKeyDown(evt) {
    if (evt.key === 'Enter') {
      evt.preventDefault();

      if (ref.current.select.select.state.focusedOption) {
        ref.current.select.select.selectOption(ref.current.select.select.state.focusedOption);
      }

      if (props.selectProps && props.selectProps.onKeyUp) {
        var keyUpEvent = {
          currentTarget: {
            name: props.selectProps.id,
            id: props.selectProps.id
          },
          keyCode: evt.keyCode,
          type: evt.type,
          which: evt.which
        };
        setTimeout(function () {
          return props.selectProps.onKeyUp(keyUpEvent);
        }, 250);
      }
    }
  };

  props.formProps.register({
    name: props.selectProps.id
  }, props.formProps.validation);

  var formatOptionLabel = function formatOptionLabel(option) {
    return props.labelPropName ? option[props.labelPropName] : option.label;
  };

  var onExternalFocus = function onExternalFocus() {
    return ref.current.focus();
  };

  return React.createElement(React.Fragment, null, React.createElement(Async, Object.assign({}, props.selectProps, {
    loadOptions: debounce(loadOptions, 500),
    formatOptionLabel: formatOptionLabel,
    isClearable: true,
    cacheOptions: true,
    onChange: handleChange,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    noOptionsMessage: props.selectProps.noOptionsMessage || noOptionsMessage,
    ref: ref,
    value: props.selectProps.defaultValue || props.formProps.getValues && props.formProps.getValues()[props.selectProps.id],
    "data-testid": "input-search"
  })), withTooltip(props.tooltipProps, props.selectProps.id));
};

function validadeChild(validation) {
  var validationResult = true;

  if (validation && validation.validate) {
    validationResult = validation.validate();
  }

  return validationResult;
}

function isRequired$1(validation) {
  return validation && validation.required;
}

function validade(value, validation, validationFunc, errorMensage) {
  var validationResult = true;

  if (!isEmpty(value) || isRequired$1(validation)) {
    if (validationFunc(value)) {
      validationResult = validadeChild(validation);
    } else {
      validationResult = errorMensage;
    }
  }

  return validationResult;
}

function validateInputNumber(inputType, result) {
  if (inputType === InputType.NUMBER) {
    if (!result.min) {
      result.min = 0;
    }

    if (!result.max) {
      result.max = MAX_NUMBER;
    }

    if (!result.maxlength) {
      result.maxlength = 15;
    }
  }
}

function generalValidation(result, value) {
  var res = null;

  if (result.validate) {
    res = result.validate(value);
  }

  if (!res) {
    var strRequired = typeof value === 'string' && isEmpty(value.trim());
    var arrRequired = Array.isArray(value) && value.length === 0;

    if (strRequired || arrRequired) {
      res = REQUIRED_FIELD;
    }
  }

  return res;
}

function adjustGeneralValidation(result) {
  var adjResult = _objectSpread({}, result);

  if (typeof result.required === 'boolean' && result.required) {
    adjResult.validate = function (value) {
      return generalValidation(result, value);
    };

    adjResult.required = REQUIRED_FIELD;
  }

  if (typeof result.min === 'number' && !isNumEmpty(result.min)) {
    adjResult.min = {
      message: "Valor n\xE3o pode ser inferior a ".concat(result.min),
      value: result.min
    };
  }

  if (typeof result.max === 'number' && !isNumEmpty(result.max)) {
    adjResult.max = {
      message: "Valor n\xE3o pode ser superior a ".concat(result.max),
      value: result.max
    };
  }

  if (typeof result.minLength === 'number' && !isNumEmpty(result.minLength)) {
    adjResult.minLength = {
      message: "Campo deve ter no m\xEDnimo ".concat(result.minLength, " caracteres"),
      value: result.minLength
    };
  }

  if (typeof result.maxLength === 'number' && !isNumEmpty(result.maxLength)) {
    adjResult.maxLength = {
      message: "Campo deve ter no m\xE1ximo ".concat(result.maxLength, " caracteres"),
      value: result.maxLength
    };
  }

  if (result.pattern && !result.pattern.hasOwnProperty('message')) {
    adjResult.pattern = {
      message: 'Campo está fora do padrão',
      value: result.pattern
    };
  }

  return adjResult;
}

var validateCpfCnpj = function validateCpfCnpj(value, validation) {
  var res = true;

  if (value.length > 0) {
    if (value.length === 11) {
      res = validade(value, validation, isCPF, 'CPF inválido');
    } else if (value.length === 14) {
      res = validade(value, validation, isCNPJ, 'CNPJ inválido');
    } else {
      res = 'O valor inserido está incompleto.';
    }
  }

  return res;
};

function adjustValidation(props, inputType) {
  var validation = props.formProps.validation;

  var result = _objectSpread({}, validation);

  if (inputType) {
    if (inputType === InputType.CNPJ) {
      result.validate = function (value) {
        return validade(value, validation, isCNPJ, 'CNPJ inválido.');
      };
    }

    if (inputType === InputType.CPF) {
      result.validate = function (value) {
        return validade(value, validation, isCPF, 'CPF inválido.');
      };
    }

    if (inputType === InputType.CPF_CNPJ) {
      result.validate = function (value) {
        return validateCpfCnpj(value, validation);
      };
    }

    if (inputType === InputType.EMAIL) {
      result.pattern = {
        message: EMAIL_INVALIDO_MSG,
        value: EMAIL_REGEX_VALIDATION
      };

      result.validate = function (value) {
        return validade(value, validation, isEmail, EMAIL_INVALIDO_MSG);
      };
    }

    if (inputType === InputType.CEP) {
      result.pattern = {
        message: CEP_INVALIDO_MSG
      };

      result.validate = function (value) {
        return validade(value, validation, isCEP, CEP_INVALIDO_MSG);
      };
    }

    if (inputType === InputType.TELEFONE) {
      result.pattern = {
        message: TELEFONE_INVALIDO_MSG
      };

      result.validate = function (value) {
        return validade(value, validation, isTelefone, TELEFONE_INVALIDO_MSG);
      };
    }

    if (inputType === InputType.MASK) {
      result.pattern = {
        message: MASCARA_INVALIDA_MSG
      };

      result.validate = function (value) {
        return validade(value, validation, function () {
          return isMask(value, props.inputMaskedProps.mask);
        }, MASCARA_INVALIDA_MSG);
      };
    }

    validateInputNumber(inputType, result);

    if (inputType === InputType.URL) {
      result.pattern = {
        message: URL_INVALIDA_MSG,
        value: URL_REGEX_VALIDATION
      };

      result.validate = function (value) {
        return validade(value, validation, isURL, URL_INVALIDA_MSG);
      };
    }
  }

  return adjustGeneralValidation(result);
}

function getDateFormat(type) {
  if (type === InputType.DATE) {
    return DATE_MONTH_YEAR_PATTERN;
  } else {
    return false;
  }
}

function getTimeFormat(type) {
  if (type === InputType.TIME) {
    return TIME_PATTERN;
  } else {
    return false;
  }
}

function getInputDateMask$1(dateFormat, timeFormat) {
  var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mask = '';

  if (typeof dateFormat === 'string') {
    if (replace) {
      mask += dateFormat.replace(/[D|M|Y]/g, '9');
    } else {
      mask += dateFormat;
    }

    if (timeFormat) {
      mask += ' ';
    }
  }

  if (typeof timeFormat === 'string') {
    if (replace) {
      mask += timeFormat.replace(/[H|m|s]/g, '9');
    } else {
      mask += timeFormat;
    }
  }

  return mask;
}

function inputSearchRender(props, validation, inputProps) {
  var className = inputProps.className;
  var defaultValue = inputProps.defaultValue;

  if (props.inputSearchProps.selectProps) {
    defaultValue = props.inputSearchProps.selectProps.defaultValue || defaultValue;
    className = props.inputSearchProps.selectProps.className || className;
  }

  className += ' react-select-container';
  return React.createElement(Input, Object.assign({
    tag: InputSearch
  }, props.inputSearchProps, {
    selectProps: _objectSpread(_objectSpread({}, props.inputSearchProps.selectProps), {}, {
      className: className,
      classNamePrefix: 'react-select',
      defaultValue: defaultValue,
      id: props.id,
      isDisabled: inputProps.disabled,
      placeholder: '',
      value: props.value
    }),
    onChange: props.onChange,
    onBlur: props.onBlur,
    setInputValue: props.setInputValue,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    tooltipProps: getTooltipProps(props)
  }, inputProps));
}

function dropDownRender(props, validation, inputProps) {
  var options = props.inputDropDownProps.optionsProvider || [];
  var className = inputProps.className;
  var defaultValue = inputProps.defaultValue;

  if (props.inputDropDownProps.selectProps) {
    className = props.inputDropDownProps.selectProps.className || className;
    options = props.inputDropDownProps.selectProps.options || options;
    defaultValue = props.inputDropDownProps.selectProps.defaultValue || defaultValue;
  }

  options.forEach(function (it) {
    if (it.options) {
      var val = it.options.find(function (item) {
        return item.value === defaultValue;
      });

      if (val) {
        defaultValue = val;
      }
    } else if (it.value === defaultValue) {
      defaultValue = it;
    }
  });
  className += ' react-select-dropdown-container';
  return React.createElement(Input, Object.assign({
    tag: InputDropDown
  }, props.inputDropDownProps, {
    selectProps: _objectSpread(_objectSpread({}, props.inputDropDownProps.selectProps), {}, {
      className: className,
      classNamePrefix: 'react-select-dropdown',
      defaultValue: defaultValue,
      isDisabled: inputProps.disabled,
      name: props.id,
      options: options,
      placeholder: '',
      value: props.value
    }),
    onChange: props.onChange,
    onBlur: props.onBlur,
    setInputValue: props.setInputValue,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    tooltipProps: getTooltipProps(props)
  }, inputProps));
}

function cnpjRender(props, validation, inputProps) {
  return React.createElement(Input, {
    tag: InputMasked,
    inputProps: inputProps,
    mask: '99.999.999/9999-99',
    onChange: props.onChange,
    onBlur: props.onBlur,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    tooltipProps: getTooltipProps(props)
  });
}

function cpfRender(props, validation, inputProps) {
  return React.createElement(Input, {
    tag: InputMasked,
    inputProps: inputProps,
    mask: '999.999.999-99',
    onChange: props.onChange,
    onBlur: props.onBlur,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    tooltipProps: getTooltipProps(props)
  });
}

function cepRender(props, validation, inputProps) {
  return React.createElement(Input, {
    tag: InputMasked,
    inputProps: inputProps,
    mask: '99999-999',
    onChange: props.onChange,
    onBlur: props.onBlur,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    tooltipProps: getTooltipProps(props)
  });
}

function telefoneRender(props, validation, inputProps) {
  var phoneMask = ['(99) 99999-9999', '(99) 9999-9999', '9999-9999', '99999-9999'];
  return React.createElement(Input, {
    tag: InputMasked,
    inputProps: inputProps,
    mask: phoneMask,
    onChange: props.onChange,
    onBlur: props.onBlur,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    tooltipProps: getTooltipProps(props)
  });
}

function maskRender(props, validation, inputProps) {
  return React.createElement(Input, {
    tag: InputMasked,
    inputProps: inputProps,
    mask: props.inputMaskedProps.mask,
    onChange: props.onChange,
    onBlur: props.onBlur,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    tooltipProps: getTooltipProps(props)
  });
}

function getRenderInput(dateMask, props) {
  return function (renderInputProps, _, closeCalendar) {
    var onChange = function onChange(e) {
      if (e.target.value !== renderInputProps.value) {
        renderInputProps.onChange(e);
      }
    };

    var onFocus = function onFocus(e, programatic) {
      if (!programatic) {
        renderInputProps.onFocus(e);
      }
    };

    var onBlur = function onBlur(e, programatic) {
      if (programatic) {
        closeCalendar();
      }

      renderInputProps.onBlur();
    };

    return React.createElement(React.Fragment, null, React.createElement(InputMaskPolyfill, Object.assign({
      mask: dateMask
    }, renderInputProps, {
      id: "id".concat(props.id, "fmt"),
      onFocus: onFocus,
      onChange: onChange,
      onBlur: onBlur
    })), withTooltip(getTooltipProps(props), "".concat(props.id, "fmt")));
  };
}

function getDateProps(props, inputProps, dateFormat, timeFormat, dateMask) {
  var hasDateProps = props.inputDateProps && props.inputDateProps.dateProps;
  var hasInputDateProps = hasDateProps && props.inputDateProps.dateProps.inputProps;
  var dateClassNames = "".concat(inputProps.className, " react-date-container").concat(inputProps.disabled ? ' react-date--is-disabled' : '');
  return _objectSpread(_objectSpread({}, hasDateProps && props.inputDateProps.dateProps), {}, {
    className: dateClassNames,
    dateFormat: dateFormat,
    inputProps: _objectSpread(_objectSpread(_objectSpread({}, inputProps), hasInputDateProps && props.inputDateProps.dateProps.inputProps), {}, {
      className: 'form-control react-input-date'
    }),
    renderInput: getRenderInput(dateMask, props),
    timeFormat: timeFormat
  });
}

function dateRender(props, validation, inputProps) {
  var defaultValue = inputProps.defaultValue;
  var dateFormat = getDateFormat(props.type);
  var timeFormat = getTimeFormat(props.type);
  var dateMask = getInputDateMask$1(dateFormat, timeFormat);

  if (defaultValue && typeof defaultValue === 'string') {
    var datePattern = getInputDateMask$1(dateFormat, timeFormat, false);

    if (datePattern.length === defaultValue.length) {
      defaultValue = toDateTime(defaultValue, datePattern);
    } else {
      defaultValue = toDateTime(defaultValue);
    }
  }

  var dateProps = _objectSpread(_objectSpread({}, getDateProps(props, inputProps, dateFormat, timeFormat, dateMask)), {}, {
    value: defaultValue
  });

  return React.createElement(Input, {
    tag: InputDate,
    propName: props.id,
    dateProps: dateProps,
    onChange: props.onChange,
    onBlur: props.onBlur,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    inputType: props.type
  });
}

function referenceRender(props, validation, inputProps) {
  var dateFormat = MONTH_YEAR_PATTERN;
  var timeFormat = false;
  var dateMask = getInputDateMask$1(dateFormat, timeFormat);
  return React.createElement(Input, {
    tag: InputReference,
    propName: props.id,
    dateProps: getDateProps(props, inputProps, dateFormat, timeFormat, dateMask),
    onChange: props.onChange,
    onBlur: props.onBlur,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    })
  });
}

function emailRender(props, validation, inputProps, handleChange) {
  return React.createElement(React.Fragment, null, React.createElement(Input, Object.assign({
    innerRef: props.formProps.register(validation),
    type: 'email'
  }, inputProps, {
    onChange: handleChange,
    onBlur: props.onBlur
  })), withTooltip(getTooltipProps(props), inputProps.name));
}

function numberRender(props, validation, inputProps) {
  return React.createElement(Input, {
    tag: InputNumber,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    inputProps: inputProps,
    onChange: props.onChange,
    onBlur: props.onBlur,
    tooltipProps: getTooltipProps(props)
  });
}

function textAreaRender(props, validation, inputProps, handleChange) {
  var onKeyDown = function onKeyDown(e) {
    if ((e.keyCode || e.which) === 13) {
      if (e.ctrlKey) {
        e.currentTarget.value += '\r\n';
        handleChange(e);
      } else {
        e.preventDefault();
      }
    }
  };

  var onKeyUp = function onKeyUp(e) {
    if ((e.keyCode || e.which) === 13 && e.ctrlKey) {
      e.preventDefault();
    } else if (inputProps.onKeyUp) {
      inputProps.onKeyUp(e);
    }
  };

  return React.createElement(React.Fragment, null, React.createElement("textarea", Object.assign({
    ref: props.formProps.register(validation)
  }, inputProps, {
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onChange: handleChange,
    onBlur: props.onBlur
  })), withTooltip(getTooltipProps(props), inputProps.name));
}

function passwordRender(props, validation, inputProps, handleChange) {
  return React.createElement(React.Fragment, null, React.createElement(Input, Object.assign({
    innerRef: props.formProps.register(validation),
    type: "password"
  }, inputProps, {
    onChange: handleChange,
    onBlur: props.onBlur
  })), withTooltip(getTooltipProps(props), inputProps.name));
}

function urlRender(props, validation, inputProps, handleChange) {
  var onBlur = function onBlur() {
    var value = props.formProps.getValues()[inputProps.name];

    if (value && value.indexOf('https://') === -1 && value.indexOf('http://') === -1) {
      props.formProps.setValue(inputProps.name, "http://".concat(value));
    }

    if (props.onBlur) {
      props.onBlur();
    }
  };

  return React.createElement(React.Fragment, null, React.createElement(Input, Object.assign({
    innerRef: props.formProps.register(validation),
    type: "url"
  }, inputProps, {
    onChange: handleChange,
    onBlur: onBlur
  })), withTooltip(getTooltipProps(props), inputProps.name));
}

function fractionOfTimeRender(props, validation, inputProps) {
  return React.createElement(Input, {
    tag: InputFractionOfTime,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    inputProps: inputProps,
    onChange: props.onChange,
    onBlur: props.onBlur,
    tooltipProps: getTooltipProps(props)
  });
}

function moneyRender(props, validation, inputProps) {
  return React.createElement(Input, {
    tag: InputMoney,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    inputProps: inputProps,
    onChange: props.onChange,
    onBlur: props.onBlur,
    tooltipProps: getTooltipProps(props)
  });
}

function percentRender(props, validation, inputProps) {
  return React.createElement(Input, {
    tag: InputPercent,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    inputProps: inputProps,
    onChange: props.onChange,
    onBlur: props.onBlur,
    tooltipProps: getTooltipProps(props)
  });
}

function cpfCnpjRender(props, validation, inputProps) {
  return React.createElement(Input, {
    tag: InputCpfCnpj,
    formProps: _objectSpread(_objectSpread({}, props.formProps), {}, {
      validation: validation
    }),
    inputProps: inputProps,
    onChange: props.onChange,
    onBlur: props.onBlur,
    tooltipProps: getTooltipProps(props)
  });
}

function defaultRender(props, validation, inputProps, handleChange) {
  return React.createElement(React.Fragment, null, React.createElement(Input, Object.assign({
    innerRef: props.formProps.register(validation)
  }, inputProps, {
    onChange: handleChange,
    onBlur: props.onBlur
  })), withTooltip(getTooltipProps(props), inputProps.name));
}

function getMin$1(validation) {
  return validation && validation.min && validation.min.value;
}

function getMax$1(validation) {
  return validation && validation.max && validation.max.value;
}

function getMaxLength(validation) {
  return validation && validation.maxLength && validation.maxLength.value;
}

function getClassName(props) {
  var className = 'form-control';

  if (props.isInvalid) {
    className += ' is-invalid ';
  }

  return className;
}

function getDefaultValue(props) {
  return props.formProps.getValues && props.formProps.getValues() != null && props.formProps.getValues()[props.id];
}

function getTooltipProps(props) {
  var result = {};

  if (props.tooltipProps && !props.hidden) {
    var placement = 'bottom';

    if (props.type === InputType.DROP_DOWN || props.type === InputType.INPUT_SEARCH) {
      placement = 'top';
    }

    result = _objectSpread(_objectSpread({}, props.tooltipProps), {}, {
      placement: props.tooltipProps.placement || placement
    });
  }

  return result;
}

function bindEvent(props, context, rootListener) {
  props.onKeyUp = function (e) {
    context.onEvent({
      keyCode: e.keyCode,
      target: e.currentTarget,
      type: e.type,
      which: e.which
    });

    if (rootListener) {
      rootListener(e);
    }
  };
}

function getInputProps(props, validation) {
  var defaultValue = getDefaultValue(props);
  var className = getClassName(props);
  var min = getMin$1(validation);
  var max = getMax$1(validation);
  var maxLength = getMaxLength(validation);
  return _objectSpread(_objectSpread({}, props.inputProps), {}, {
    'aria-describedby': props.tooltipProps ? "tooltip-".concat(props.id) : props.addOnId,
    'aria-label': props.label,
    className: className,
    defaultValue: defaultValue,
    disabled: props.inputProps && props.inputProps.disabled || props.disabled,
    max: props.inputProps && props.inputProps.max || max,
    maxLength: props.inputProps && props.inputProps.maxLength || maxLength,
    min: props.inputProps && props.inputProps.min || min,
    name: props.id
  }, generateTestId("input-".concat(props.id)));
}

var InputGroupInlineControl = function InputGroupInlineControl(props) {
  var context = useInputContext();
  var result = null;
  var validation = adjustValidation(props, props.type);
  var inputProps = getInputProps(props, validation);

  var handleChange = function handleChange(evt) {
    var value = evt.target.value.trim();

    if (props.onChange) {
      props.onChange(value);
    }
  };

  if (context && context.onEvent) {
    bindEvent(inputProps, context, inputProps.onKeyUp || null);
  }

  switch (props.type) {
    case InputType.INPUT_SEARCH:
      if (context && context.onEvent) {
        if (!props.inputSearchProps.selectProps) {
          props.inputSearchProps.selectProps = {};
        }

        bindEvent(props.inputSearchProps.selectProps, context, props.inputSearchProps.selectProps.onKeyUp || null);
      }

      result = inputSearchRender(props, validation, inputProps);
      break;

    case InputType.DROP_DOWN:
      if (context && context.onEvent) {
        if (!props.inputDropDownProps.selectProps) {
          props.inputDropDownProps.selectProps = {};
        }

        bindEvent(props.inputDropDownProps.selectProps, context, props.inputDropDownProps.selectProps.onKeyUp || null);
      }

      result = dropDownRender(props, validation, inputProps);
      break;

    case InputType.CNPJ:
      result = cnpjRender(props, validation, inputProps);
      break;

    case InputType.CPF:
      result = cpfRender(props, validation, inputProps);
      break;

    case InputType.CEP:
      result = cepRender(props, validation, inputProps);
      break;

    case InputType.TELEFONE:
      result = telefoneRender(props, validation, inputProps);
      break;

    case InputType.MASK:
      result = maskRender(props, validation, inputProps);
      break;

    case InputType.DATE:
    case InputType.TIME:
      result = dateRender(props, validation, inputProps);
      break;

    case InputType.REFERENCE:
      result = referenceRender(props, validation, inputProps);
      break;

    case InputType.EMAIL:
      result = emailRender(props, validation, inputProps, handleChange);
      break;

    case InputType.NUMBER:
      result = numberRender(props, validation, inputProps);
      break;

    case InputType.TEXT_AREA:
      result = textAreaRender(props, validation, inputProps, handleChange);
      break;

    case InputType.PASSWORD:
      result = passwordRender(props, validation, inputProps, handleChange);
      break;

    case InputType.URL:
      result = urlRender(props, validation, inputProps, handleChange);
      break;

    case InputType.FRACTION_OF_TIME:
      result = fractionOfTimeRender(props, validation, inputProps);
      break;

    case InputType.MONEY:
      result = moneyRender(props, validation, inputProps);
      break;

    case InputType.PERCENT:
      result = percentRender(props, validation, inputProps);
      break;

    case InputType.CPF_CNPJ:
      result = cpfCnpjRender(props, validation, inputProps);
      break;

    default:
      result = defaultRender(props, validation, inputProps, handleChange);
  }

  return result;
};

var InputGroupInlineLabel = function InputGroupInlineLabel(props) {
  var labelAlign = props.labelAlign || 'flex-start';

  var style = _objectSpread({
    display: 'flex',
    justifyContent: labelAlign
  }, props.labelWidth && {
    width: "".concat(props.labelWidth, "px")
  });

  return React.createElement(Label, {
    className: "mb-0",
    style: style
  }, props.label);
};

var InputGroupInlinePrepend = function InputGroupInlinePrepend(props) {
  var icon = props.icon ? React.createElement(FontAwesomeIcon, {
    icon: props.icon
  }) : null;
  var labelPrepend = props.isPrependLabel ? props.label : null;
  var labelAlign = props.labelAlign || 'flex-start';

  var style = _objectSpread({
    justifyContent: labelAlign
  }, props.labelWidth && {
    width: "".concat(props.labelWidth, "px")
  });

  return React.createElement(InputGroupAddon, {
    addonType: "prepend"
  }, React.createElement(InputGroupText, {
    id: props.addOnId,
    style: style
  }, icon, labelPrepend));
};

var InputGroupInline = function InputGroupInline(props) {
  var _useState13 = useState(props.value),
      _useState14 = _slicedToArray(_useState13, 2),
      inputValue = _useState14[0],
      setInputValue = _useState14[1];

  var controlId = "id".concat(props.id.replace(/\./g, '_'));
  var addOnId = "".concat(props.id, "-addon");

  if (props.hidden) {
    props = _objectSpread(_objectSpread({}, props), {}, {
      inputProps: _objectSpread(_objectSpread({}, props.inputProps), {}, {
        type: 'hidden'
      })
    });
  }

  var apppend = React.createElement(InputGroupInlineAppend, Object.assign({}, props, {
    setInputValue: setInputValue
  }));
  var error = getObjectSubValue(props.formProps.errors, props.id);
  var errorFmt = getObjectSubValue(props.formProps.errors, "".concat(props.id, "Fmt"));
  var erroMsg = null;

  if (error) {
    erroMsg = error.message;
  } else if (errorFmt) {
    erroMsg = errorFmt.message;
  }

  var isInvalid = (error || errorFmt) && !isEmpty(erroMsg);
  var feedback = React.createElement(FormFeedback, {
    valid: !isInvalid
  }, erroMsg);
  var control = React.createElement(InputGroupInlineControl, Object.assign({
    addOnId: addOnId,
    isInvalid: isInvalid
  }, props, {
    value: inputValue,
    setInputValue: setInputValue
  }));
  return props.hidden ? control : React.createElement(FormGroup, null, !props.icon && !props.hideLabel && React.createElement(InputGroupInlineLabel, Object.assign({}, props)), React.createElement(InputGroup, {
    id: controlId,
    size: "sm"
  }, props.icon != null && !props.hideLabel && React.createElement(InputGroupInlinePrepend, Object.assign({}, props, {
    addOnId: addOnId
  })), control, apppend, feedback));
};

var ErroList = function ErroList(props) {
  var headerMessage = props.headerMessage || React.createElement(React.Fragment, null, "Existem informa\xE7\xF5es inv\xE1lidas.", React.createElement("br", null), "Verifique os campos indicados abaixo:");
  return React.createElement(React.Fragment, null, props.hideHeader ? null : headerMessage, React.createElement(ListGroup, {
    variant: "flush"
  }, props.erros.map(function (e) {
    return React.createElement(ListGroupItem, {
      key: e
    }, e);
  })));
};

var ProcessBar = function ProcessBar(props) {
  var history = useHistory();
  var debounceRef = useRef();

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showLoading = _useState16[0],
      setShowLoading = _useState16[1];

  useEffect(function () {
    debounceRef.current = debounce(onSubmit, 250);
    return function () {
      return debounceRef.current.flush();
    };
  });

  var onSubmit = function onSubmit() {
    setShowLoading(true);
    var erros = [];

    if (props.validateExtras) {
      erros = props.validateExtras();
    }

    if (erros && erros.length > 0) {
      setShowLoading(false);
      alertManager.emit(ACTION_EVENTS.SHOW, {
        message: React.createElement(ErroList, {
          erros: erros
        }),
        type: AlertType.ERROR
      });
    } else {
      Promise.resolve(props.handleSubmit()).then(function () {
        return setShowLoading(false);
      });
    }
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    debounceRef.current();
  };

  var handleClose = function handleClose() {
    if (props.handleClose) {
      props.handleClose();
    } else {
      history.push('dashboard');
    }
  };

  return React.createElement(React.Fragment, null, props.children, React.createElement("div", {
    className: "float-right"
  }, !props.hideSubmitButton && React.createElement(Button, Object.assign({
    size: "sm",
    color: "success",
    className: cx('mr-2', {
      'btn-spinner': showLoading
    }),
    disabled: showLoading,
    onClick: handleSubmit
  }, generateTestId('processbar-btn-ok')), showLoading ? React.createElement(React.Fragment, null, React.createElement("span", {
    className: "btn-wrapper--icon spinner-border spinner-border-sm",
    role: "status",
    "aria-hidden": "true"
  }), React.createElement("span", {
    className: "btn-wrapper--label"
  }, "Aguarde...")) : React.createElement(React.Fragment, null, React.createElement(FontAwesomeIcon, {
    icon: props.btnSubmitIcon || 'cog'
  }), React.createElement("span", {
    className: "ml-2"
  }, props.btnSubmitLabel || 'OK'))), !props.hideCancelButton && React.createElement(Button, Object.assign({
    color: "danger",
    onClick: handleClose,
    size: "sm"
  }, generateTestId('processbar-btn-cancel')), React.createElement(FontAwesomeIcon, {
    icon: props.btnCloseIcon || 'times'
  }), React.createElement("span", {
    className: "ml-2"
  }, props.btnCloseLabel || 'Cancelar'))));
};

var DetailEditForm = function DetailEditForm(props) {
  var detailRef = useRef();
  useEffect(function () {
    if (!props.disableInitialAutoFocus) {
      initialFocus(detailRef);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  var onSubmit = function onSubmit() {
    try {
      return Promise.resolve(props.formProps.triggerValidation()).then(function (result) {
        if (result) {
          props.handleSubmit(props.formProps.getValues(), props.validateExtras);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return React.createElement("div", {
    ref: detailRef
  }, React.createElement(InputGroupInline, {
    id: "rowIndex",
    formProps: props.formProps,
    hidden: true
  }), React.createElement(InputGroupInline, {
    id: "id",
    formProps: props.formProps,
    hidden: true
  }), React.createElement(InputProvider, {
    onEvent: handleFocusOnEnter.bind(null, props.useEnterAsTab, detailRef)
  }, props.children), React.createElement(ProcessBar, {
    handleSubmit: onSubmit,
    handleClose: props.handleCancel,
    hideSubmitButton: props.hideSubmitButton,
    hideCancelButton: props.hideCancelButton,
    btnSubmitIcon: "save",
    btnSubmitLabel: "Salvar"
  }, props.extraFooterContent));
};

var GridResponsiveWrapper = function GridResponsiveWrapper(props) {
  var style = {};

  if (props.limitGridHeight) {
    if (typeof props.limitGridHeight === 'number') {
      style.maxHeight = props.limitGridHeight;
    } else {
      style.maxHeight = "calc(100vh - ".concat(380 + (props.extraIgnoredSpacing || 0), "px)");
    }
  }

  return React.createElement("div", {
    className: props.className,
    style: style
  }, props.children);
};

var SortDirection;

(function (SortDirection) {
  SortDirection["ASC"] = "asc";
  SortDirection["DESC"] = "desc";
})(SortDirection || (SortDirection = {}));

var getColHeaderProps = function getColHeaderProps(column, index) {
  var cellProps = {
    className: cx('gt-th', {
      sort: column.sort
    }),
    tabIndex: index
  };

  if (!!column.headerStyle) {
    cellProps.style = typeof column.headerStyle === 'function' ? column.headerStyle(column, index) : column.headerStyle;
  }

  if (!!column.headerClasses) {
    var className = typeof column.headerClasses === 'function' ? column.headerClasses(column, index) : column.headerClasses;
    cellProps.className = cx(cellProps.className, className);
  }

  if (column.hidden) {
    cellProps.hidden = true;
  }

  return cellProps;
};

var getColHeaderDivProps = function getColHeaderDivProps(column, index) {
  var cellProps = {
    className: 'table-col-header'
  };
  var alignMap = {
    left: 'start',
    center: 'center',
    right: 'end'
  };

  if (!!column.headerAlign) {
    var align = typeof column.headerAlign === 'function' ? column.headerAlign(column, index) : column.headerAlign;
    cellProps.className = cx(cellProps.className, "justify-content-".concat(alignMap[align]));
  }

  return cellProps;
};

var getColBodyProps = function getColBodyProps(column, row, rowIndex, colIndex) {
  var cellProps = {
    className: 'gt-td'
  };

  if (!!column.align) {
    var align = typeof column.align === 'function' ? column.align(row[column.dataField], row, rowIndex, colIndex) : column.align;
    cellProps.className = cx(cellProps.className, "text-".concat(align));
  }

  if (!!column.style) {
    cellProps.style = typeof column.style === 'function' ? column.style(row[column.dataField], row, rowIndex, colIndex) : column.style;
  }

  if (!!column.classes) {
    var clx = typeof column.classes === 'function' ? column.classes(row[column.dataField], row, rowIndex, colIndex) : column.classes;
    cellProps.className = cx(cellProps.className, clx);
  }

  if (column.hidden) {
    cellProps.hidden = true;
  }

  return cellProps;
};

var getCardHeaderProps = function getCardHeaderProps(column, index) {
  var cellProps = {
    className: 'table-card-header'
  };

  if (!!column.headerCardAlign) {
    var align = typeof column.headerCardAlign === 'function' ? column.headerCardAlign(column, index) : column.headerCardAlign;
    cellProps.className = cx(cellProps.className, "text-".concat(align));
  }

  if (!!column.headerCardStyle) {
    cellProps.style = typeof column.headerCardStyle === 'function' ? column.headerCardStyle(column, index) : column.headerCardStyle;
  }

  if (!!column.headerCardClasses) {
    var className = typeof column.headerCardClasses === 'function' ? column.headerCardClasses(column, index) : column.headerCardClasses;
    cellProps.className = cx(cellProps.className, className);
  }

  if (column.hidden) {
    cellProps.hidden = true;
  }

  return cellProps;
};

var SortIcon = function SortIcon(props) {
  return React.createElement("div", {
    className: "sort-icon"
  }, React.createElement(FontAwesomeIcon, {
    icon: ['fas', 'long-arrow-alt-up'],
    className: cx({
      active: props.direction && props.direction === SortDirection.ASC
    })
  }), React.createElement(FontAwesomeIcon, {
    icon: ['fas', 'long-arrow-alt-down'],
    className: cx({
      active: props.direction && props.direction === SortDirection.DESC
    })
  }));
};

var GridTable = function GridTable(props) {
  var _useState17 = useState([]),
      _useState18 = _slicedToArray(_useState17, 2),
      selectedIndexes = _useState18[0],
      setSelectedIndexes = _useState18[1];

  var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      sort = _useState20[0],
      setSort = _useState20[1];

  var checkAll = useRef();
  var keyField = props.keyField || 'id';
  useEffect(function () {
    if (props.selection && Array.isArray(props.selection)) {
      setSelectedIndexes(props.selection);

      if (checkAll.current) {
        if (props.data.length > 0 && props.selection.length === props.data.length) {
          checkAll.current.checked = true;
        } else if (checkAll.current.checked) {
          checkAll.current.checked = false;
        }
      }
    }
  }, [props.selection]);

  var changeSelected = function changeSelected(e) {
    var forceHotKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var newState = _toConsumableArray(selectedIndexes);

    var row = props.data[e.currentTarget.tabIndex];

    if (props.multiple && (!props.multipleViaHotKey || e.ctrlKey || forceHotKey)) {
      var isSelected = newState.find(function (it) {
        return it[keyField] === row[keyField];
      });

      if (isSelected) {
        newState = newState.filter(function (it) {
          return it[keyField] !== row[keyField];
        });
      } else {
        newState.push(row);
      }
    } else {
      newState = [row];
    }

    if (newState.length === props.data.length) {
      if (props.multiple && props.onSelectAll) {
        props.onSelectAll(newState);
      }

      if (checkAll.current && !checkAll.current.checked) {
        checkAll.current.checked = true;
      }
    } else if (checkAll.current && checkAll.current.checked) {
      checkAll.current.checked = false;
    }

    setSelectedIndexes(newState);

    if (props.onSelection) {
      props.onSelection(newState);
    }
  };

  var onChangeSelectAll = function onChangeSelectAll() {
    if (props.multiple) {
      var data = checkAll.current.checked ? props.data : [];
      setSelectedIndexes(data);

      if (props.onSelectAll) {
        props.onSelectAll(data);
      }
    }
  };

  var onRowClick = function onRowClick(e) {
    e.preventDefault();
    changeSelected(e, true);
  };

  var onRowDoubleClick = function onRowDoubleClick(e) {
    e.preventDefault();

    if (props.onDoubleClick) {
      props.onDoubleClick(props.data[e.currentTarget.tabIndex]);
    }
  };

  var onCheckChange = function onCheckChange(e) {
    if (props.multiple) {
      changeSelected(e, true);
    }
  };

  var onSortClick = function onSortClick(e) {
    e.preventDefault();
    var column = props.columns[e.currentTarget.tabIndex];

    if (column.sort) {
      setSort(function (p) {
        var result = p && _objectSpread({}, p);

        if (result && result.column.dataField === column.dataField) {
          result.direction = result.direction === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
        } else {
          result = {
            column: column,
            direction: SortDirection.ASC
          };
        }

        if (props.onSort) {
          props.onSort(result);
        }

        return result;
      });
    }
  };

  var getContent = function getContent(column, row, rowIndex) {
    var result = getObjectSubValue(row, column.dataField);

    if (!!column.formatter) {
      result = column.formatter(result, row, rowIndex, column.formatExtraData);
    }

    return result;
  };

  var buildHeader = function buildHeader() {
    return React.createElement("tr", {
      className: cx('gt-tr', props.headerClasses),
      key: "rowHeader"
    }, props.multiple && React.createElement("th", {
      style: {
        width: 30
      },
      className: "gt-th col-header-check"
    }, React.createElement("input", {
      type: "checkbox",
      onChange: onChangeSelectAll,
      ref: checkAll
    })), props.columns.map(function (it, index) {
      return React.createElement("th", Object.assign({}, getColHeaderProps(it, index), {
        onClick: onSortClick,
        key: index
      }), React.createElement("div", Object.assign({}, getColHeaderDivProps(it, index)), React.createElement("span", null, it.text), it.sort && React.createElement(SortIcon, {
        direction: sort && sort.column && sort.column.dataField === it.dataField && sort.direction
      })));
    }));
  };

  var buildBody = function buildBody() {
    return props.data.map(function (item, indexItem) {
      var keys = selectedIndexes.map(function (it) {
        return it[keyField];
      });
      var rowClass = '';

      if (!!props.rowClasses) {
        rowClass = typeof props.rowClasses === 'function' ? props.rowClasses(item, indexItem) : props.rowClasses;
      }

      return React.createElement("tr", {
        key: indexItem,
        tabIndex: indexItem,
        onClick: onRowClick,
        onDoubleClick: onRowDoubleClick,
        className: cx('gt-tr', {
          active: keys.indexOf(item[keyField]) !== -1
        }, rowClass)
      }, props.multiple && React.createElement("td", {
        className: "gt-td col-body-check"
      }, React.createElement("input", {
        key: Math.random(),
        type: "checkbox",
        checked: keys.indexOf(item[keyField]) !== -1,
        className: "grid-multiple-select",
        style: {
          marginLeft: 0
        },
        readOnly: true,
        onChange: onCheckChange,
        tabIndex: indexItem
      })), props.columns.map(function (column, indexColumn) {
        return React.createElement("td", Object.assign({}, getColBodyProps(column, item, indexItem, indexColumn), {
          key: "".concat(indexItem, "-").concat(indexColumn)
        }), React.createElement("div", Object.assign({}, getCardHeaderProps(column, indexColumn)), column.text), React.createElement("span", null, getContent(column, item, indexItem)));
      }));
    });
  };

  var getBodyContent = function getBodyContent() {
    var result = buildBody();

    if (!!props.data && props.data.length === 0) {
      result = [React.createElement("tr", {
        key: "rowNenhumRegistro",
        className: "gt-tr"
      }, React.createElement("td", {
        colSpan: props.multiple ? props.columns.length + 1 : props.columns.length,
        align: "center",
        className: "gt-td nenhum-registro"
      }, "Nenhum registro encontrado."))];
    }

    return result;
  };

  var withAction = props.columns.find(function (it) {
    return it.dataField === 'actionColumn';
  }) !== undefined;
  return React.createElement(GridResponsiveWrapper, {
    className: "table-responsive",
    extraIgnoredSpacing: props.extraIgnoredSpacing,
    limitGridHeight: props.limitGridHeight
  }, React.createElement("table", {
    className: cx('table table-bordered table-striped table-hover grid-table', {
      multiple: props.multiple,
      withaction: withAction
    })
  }, React.createElement("thead", {
    className: "gt-thead"
  }, buildHeader()), React.createElement("tbody", {
    className: "gt-tbody"
  }, getBodyContent())));
};

var WikiButton = function WikiButton(props) {
  var wikiId = "wiki-btn-".concat(props.pageId);

  var getTooltip = function getTooltip() {
    var tooltipProps = {
      message: 'Clique aqui para obter mais informações'
    };

    if (props.pageTitle) {
      tooltipProps.message += " sobre: ".concat(props.pageTitle);
    }

    if (props.tooltipProps) {
      tooltipProps = _objectSpread(_objectSpread({}, tooltipProps), props.tooltipProps);
    }

    return React.createElement(UncontrolledTooltip, Object.assign({
      target: wikiId
    }, tooltipProps), tooltipProps.message);
  };

  var onClick = function onClick() {
    return navegarWiki(props.pageId);
  };

  return React.createElement(Button, Object.assign({}, props.buttonProps, {
    onClick: onClick,
    id: wikiId,
    color: "default",
    className: cx('wiki-button btn-pill p-0 float-right', {
      'd-40': !props.small,
      'd-20': props.small
    })
  }, generateTestId(wikiId)), React.createElement("span", {
    className: "btn-wrapper--icon d-flex justify-content-center align-items-center"
  }, React.createElement(FontAwesomeIcon, {
    icon: ['fas', 'question']
  })), getTooltip());
};

function setIndex(data) {
  return data && data.map(function (it, index) {
    return _objectSpread(_objectSpread({}, it), {}, {
      rowIndex: index
    });
  });
}

function getDetailEditFormWikiButton(detailViewWikiId, detailViewWikiTitle) {
  return detailViewWikiId ? React.createElement("div", {
    className: "def-wiki-button-wrapper"
  }, React.createElement(WikiButton, {
    pageId: detailViewWikiId,
    pageTitle: detailViewWikiTitle
  })) : null;
}

function showDefaultAlert() {
  var params = {
    message: DEFAULT_ONE_SELECTED_ITEM_MSG,
    type: AlertType.INFORMATION
  };
  alertManager.emit(ACTION_EVENTS.SHOW, params);
}

function showSingleRowAlert() {
  var params = {
    message: 'Para editar/remover selecione somente 1 registro',
    type: AlertType.INFORMATION
  };
  alertManager.emit(ACTION_EVENTS.SHOW, params);
}

function displaySubmitErrors(erros) {
  var params = {
    message: React.createElement(ErroList, {
      erros: erros
    }),
    type: AlertType.ERROR
  };
  alertManager.emit(ACTION_EVENTS.SHOW, params);
}

function getModalSize(detailViewSize) {
  var map = {
    default: null,
    small: 'sm',
    large: 'lg',
    extralarge: 'xl'
  };
  return map[detailViewSize || 'default'];
}

function getEditedItens(isEditing, tableData, data, props) {
  var editedItens = [];

  if (isEditing) {
    editedItens = tableData.map(function (it) {
      if (Number(it.rowIndex) === Number(data.rowIndex)) {
        return _objectSpread(_objectSpread({}, it), data);
      }

      return it;
    });
  } else {
    if (props.addOnTop) {
      editedItens = setIndex([data].concat(_toConsumableArray(tableData)));
    } else {
      editedItens = [].concat(_toConsumableArray(tableData), [_objectSpread(_objectSpread({}, data), {}, {
        rowIndex: tableData.length
      })]);
    }
  }

  return editedItens;
}

var DetailManagerForm = /*#__PURE__*/forwardRef(function (props, ref) {
  var location = useLocation();
  var Detail = props.detailView;

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      showModalView = _useState22[0],
      setShowModalView = _useState22[1];

  var _useState23 = useState(null),
      _useState24 = _slicedToArray(_useState23, 2),
      selectedItem = _useState24[0],
      setSelectedItem = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      isEditing = _useState26[0],
      setIsEditing = _useState26[1];

  var _useState27 = useState([]),
      _useState28 = _slicedToArray(_useState27, 2),
      tableData = _useState28[0],
      setTableData = _useState28[1];

  var compId = props.propName.replace(/\./g, '_');
  var rawData = props.formProps.watch(props.propName);
  useEffect(function () {
    var data = setIndex(rawData || []);
    var sort = getSort();

    if (sort) {
      onSort(sort, data);
    } else {
      setTableData(data);
    }
  }, [rawData, props.formProps]);
  useEffect(function () {
    var sort = getSort();

    if (sort) {
      onSort(sort);
    }
  }, [props.defaultSorted]);

  var getSort = function getSort() {
    var result = null;

    if (props.defaultSorted && props.defaultSorted.length > 0) {
      var sort = props.defaultSorted[0];
      var column = props.columns.find(function (it) {
        return it.dataField === sort.dataField;
      });
      var direction = sort.order === OrderType.DESC ? SortDirection.DESC : SortDirection.ASC;

      if (column) {
        result = {
          column: column,
          direction: direction
        };
      }
    }

    return result;
  };

  useImperativeHandle(ref, function () {
    return {
      externalAdd: function externalAdd() {
        return addNewItem();
      }
    };
  });

  var setDataWhenFinishOperation = function setDataWhenFinishOperation(data) {
    props.formProps.setValue(props.propName, data, false);
    setTableData(data);
    setSelectedItem([]);
  };

  var addNewItem = function addNewItem() {
    var execAdd = function execAdd() {
      gaModalView(location.pathname);
      setSelectedItem([]);
      setShowModalView(true);
      setIsEditing(false);
    };

    if (props.onBeforeAdd) {
      var onBeforeAddResult = props.onBeforeAdd(execAdd);

      if (onBeforeAddResult && onBeforeAddResult.hasOwnProperty('async') && onBeforeAddResult.async) {
        return;
      }
    }

    execAdd();
  };

  var editSelectedItem = function editSelectedItem(_) {
    var record = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var execEdit = function execEdit() {
      gaModalView(location.pathname);
      setShowModalView(true);
      setIsEditing(true);
    };

    if (record || selectedItem && selectedItem.length > 0) {
      if (selectedItem.length > 1) {
        showSingleRowAlert();
      } else {
        if (props.onBeforeEdit) {
          var onBeforeEditResult = props.onBeforeEdit(record || selectedItem[0], execEdit);

          if (onBeforeEditResult && onBeforeEditResult.hasOwnProperty('async') && onBeforeEditResult.async) {
            return;
          }
        }

        execEdit();
      }
    } else {
      showDefaultAlert();
    }
  };

  var removeSelectedItem = function removeSelectedItem() {
    var execRemove = function execRemove() {
      var params = {
        message: DEFAULT_DELETE_SELECTED_ITEM_MSG,
        onOkClick: function onOkClick() {
          var filteredItens = tableData.filter(function (it) {
            return Number(it.rowIndex) !== Number(selectedItem[0].rowIndex);
          });
          setDataWhenFinishOperation(filteredItens);

          if (props.onChange) {
            props.onChange(filteredItens, selectedItem[0]);
          }
        },
        type: AlertType.WARNING_YES_NO
      };
      alertManager.emit(ACTION_EVENTS.SHOW, params);
    };

    if (selectedItem && selectedItem.length > 0) {
      if (selectedItem.length > 1) {
        showSingleRowAlert();
      } else {
        if (props.onBeforeRemove) {
          var onBeforeRemoveResult = props.onBeforeRemove(selectedItem[0], execRemove);

          if (onBeforeRemoveResult && onBeforeRemoveResult.hasOwnProperty('async') && onBeforeRemoveResult.async) {
            return;
          }
        }

        execRemove();
      }
    } else {
      showDefaultAlert();
    }
  };

  var handleCloseModal = function handleCloseModal() {
    return setShowModalView(false);
  };

  var onSubmit = function onSubmit(data, validateExtras) {
    var erros = [];

    if (validateExtras) {
      erros = validateExtras(data, tableData, props.formProps.getValues());
    }

    if (erros && erros.length) {
      displaySubmitErrors(erros);
    } else {
      var editedItens = getEditedItens(isEditing, tableData, data, props);
      setShowModalView(false);
      setIsEditing(false);
      setDataWhenFinishOperation(editedItens);

      if (props.onChange) {
        props.onChange(editedItens, data);
      }

      var sort = getSort();

      if (sort) {
        onSort(sort);
      }
    }
  };

  var onSelection = function onSelection(items) {
    setSelectedItem(items.length > 0 ? items : null);

    if (props.onSelection) {
      props.onSelection(items);
    }
  };

  var onDoubleClick = function onDoubleClick(item) {
    if (item) {
      setSelectedItem([item]);
      editSelectedItem(null, item);
    }
  };

  var getSelectedItem = function getSelectedItem() {
    return selectedItem && selectedItem.length === 1 ? selectedItem[0] : null;
  };

  var onSort = function onSort(state) {
    var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return setTableData(function (data) {
      var result = _toConsumableArray(raw || data);

      result.sort(function (a, b) {
        var valA = valToString(getObjectSubValue(a, state.column.dataField));
        var valB = valToString(getObjectSubValue(b, state.column.dataField));
        var sort;

        if (state.column.filter && typeof state.column.filter === 'object' && state.column.filter.type === FilterType.DATE) {
          sort = moment(valA, 'DD/MM/YYYY').unix() - moment(valB, 'DD/MM/YYYY').unix();
        } else {
          sort = valA.localeCompare(valB, undefined, {
            numeric: true
          });
        }

        return sort * (state.direction === SortDirection.DESC ? -1 : 1);
      });
      return result;
    });
  };

  var getAddButton = function getAddButton() {
    return !props.hideAddButton && React.createElement(React.Fragment, null, React.createElement(Button, Object.assign({
      id: "addButton-".concat(compId),
      size: "sm",
      color: "success",
      className: "btn-pill d-30 p-0 border-0 mr-2",
      onClick: addNewItem,
      outline: true
    }, generateTestId("detail-btn-add-".concat(compId))), React.createElement(FontAwesomeIcon, {
      icon: "plus"
    })), React.createElement(UncontrolledTooltip, {
      target: "addButton-".concat(compId)
    }, "Clique aqui para adicionar"));
  };

  var getEditButton = function getEditButton() {
    return !props.hideEditButton && React.createElement(React.Fragment, null, React.createElement(Button, Object.assign({
      id: "editButton-".concat(compId),
      size: "sm",
      color: "warning",
      className: "btn-pill d-30 p-0 border-0 mr-2",
      onClick: editSelectedItem,
      outline: true
    }, generateTestId("detail-btn-edit-".concat(compId))), React.createElement(FontAwesomeIcon, {
      icon: "pen"
    })), React.createElement(UncontrolledTooltip, {
      target: "editButton-".concat(compId)
    }, "Clique aqui para alterar"));
  };

  var getRemoveButton = function getRemoveButton() {
    return !props.hideRemoveButton && React.createElement(React.Fragment, null, React.createElement(Button, Object.assign({
      id: "removeButton-".concat(compId),
      size: "sm",
      color: "danger",
      className: "btn-pill d-30 p-0 border-0 mr-2",
      onClick: removeSelectedItem,
      outline: true
    }, generateTestId("detail-btn-remove-".concat(compId))), React.createElement(FontAwesomeIcon, {
      icon: "trash"
    })), React.createElement(UncontrolledTooltip, {
      target: "removeButton-".concat(compId)
    }, "Clique aqui para remover"));
  };

  var getExtraButton = function getExtraButton() {
    return props.extraCustomContent;
  };

  var getWikiBtn = function getWikiBtn() {
    return props.wikiId && React.createElement("div", {
      className: "dmf-wiki-button-wrapper"
    }, React.createElement(WikiButton, {
      pageId: props.wikiId,
      pageTitle: props.wikiTitle
    }));
  };

  return React.createElement(Card, {
    className: "card-box mb-3",
    ref: props.formProps.register({
      name: props.propName
    })
  }, React.createElement(CardHeader, {
    className: "card-header p-2"
  }, React.createElement("div", {
    className: "card-header--title"
  }, props.disableCardTitle ? '' : props.title), React.createElement("div", {
    className: "card-header--actions"
  }, getAddButton(), getEditButton(), getRemoveButton(), getExtraButton(), getWikiBtn())), React.createElement(CardBody, null, React.createElement("div", Object.assign({
    key: "divBootstrapTableKey",
    className: "table-area"
  }, generateTestId("detailview-".concat(compId))), React.createElement(GridTable, {
    keyField: "rowIndex",
    columns: props.columns,
    data: tableData,
    onSelection: onSelection,
    onSelectAll: onSelection,
    onDoubleClick: props.disableDoubleClick ? null : onDoubleClick,
    onSort: onSort,
    multipleViaHotKey: true,
    multiple: props.multipleSelection || false,
    selection: selectedItem,
    limitGridHeight: 300
  })), React.createElement("div", Object.assign({
    key: "divFotterKey",
    className: "text-left"
  }, generateTestId("detailview-table-footer-".concat(compId))), "Registros: ", tableData.length)), React.createElement(Modal, {
    className: "detail-manager-form-content",
    centered: true,
    backdrop: "static",
    isOpen: showModalView,
    toggle: handleCloseModal,
    size: getModalSize(props.detailViewSize)
  }, React.createElement("div", {
    className: "modal-header"
  }, React.createElement("h5", {
    className: "modal-title"
  }, props.modalTitle || props.title), React.createElement("div", {
    className: "def-modal-button-wrapper"
  }, getDetailEditFormWikiButton(props.detailViewWikiId, props.detailViewWikiTitle), React.createElement("button", {
    type: "button",
    className: "close",
    "aria-label": "Close",
    onClick: handleCloseModal
  }, "\xD7"))), React.createElement(ModalBody, null, React.createElement(Detail, {
    selectedItem: getSelectedItem(),
    handleSubmit: onSubmit,
    handleCancel: handleCloseModal,
    parentFormProps: props.formProps
  }))));
});
var EditForm = /*#__PURE__*/forwardRef(function (props, ref) {
  var editRef = useRef();
  useEffect(function () {
    props.formProps.triggerValidation('id');

    if (!props.disableInitialAutoFocus) {
      initialFocus(editRef);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var canPersistData = true;
  var externalSubmitPromiseResolver = null;
  useImperativeHandle(ref, function () {
    return {
      close: function close() {
        var goBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return onClose(goBack);
      },
      focusOn: function focusOn(field) {
        return focusOnInput(editRef.current, field);
      },
      submit: function submit() {
        var persistData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return new Promise(function (resolve) {
          canPersistData = persistData;
          externalSubmitPromiseResolver = resolve;
          formPropsHandleSubmit();
        });
      }
    };
  });

  var onClose = function onClose() {
    var goBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (props.editViewProps.beforeClose) {
      props.editViewProps.beforeClose();
    } else if (!props.keepOnScreen) {
      dispatchClose(props.editViewProps, props.editViewProps.history, goBack, props.editViewProps.isModal);
    } else {
      props.editViewProps.history.push('dashboard');
    }
  };

  var asyncBeforeComplete = function asyncBeforeComplete(formData, resolve) {
    return function (newFormData) {
      persistForm(newFormData || formData).then(function () {
        return resolve();
      });
    };
  };

  var persistForm = function persistForm(formData) {
    return new Promise(function (resolve) {
      if (canPersistData) {
        var param = {
          errorFunction: function errorFunction(mensagem) {
            showToast(mensagem, ERROR);
            resolve();
          },
          thenFunction: function thenFunction(result) {
            var done = function done() {
              var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              var selectedItem = getSelectedItem(props.editViewProps);
              showToast(selectedItem && selectedItem.id === null ? REGISTRO_INSERIDO_COM_SUCESSO_MSG : REGISTRO_ALTERADO_COM_SUCESSO_MSG, SUCCESS);
              resolve();

              if (close) {
                onClose();
              }
            };

            if (externalSubmitPromiseResolver) {
              externalSubmitPromiseResolver(result);
            }

            if (props.afterPersist) {
              var afterPersistResult = props.afterPersist(result, done);

              if (afterPersistResult) {
                if (afterPersistResult.hasOwnProperty('async') && afterPersistResult.async) {
                  return;
                }
              }
            }

            done();
          }
        };
        var file = props.getFile && props.getFile(formData);

        if (file) {
          persistFiles(formData, props.dtoClassName, file, param);
        } else {
          persist(formData, props.dtoClassName, param);
        }
      } else {
        resolve();

        if (externalSubmitPromiseResolver) {
          externalSubmitPromiseResolver(formData);
        }
      }
    });
  };

  var onSubmit = function onSubmit(formData, event) {
    return new Promise(function (resolve) {
      if (event) {
        event.preventDefault();
      }

      var erros = [];

      if (props.validateExtras) {
        erros = props.validateExtras(formData);
      }

      if (erros && erros.length) {
        var params = {
          message: React.createElement(ErroList, {
            erros: erros
          }),
          type: AlertType.ERROR
        };
        alertManager.emit(ACTION_EVENTS.SHOW, params);
        resolve();
      } else {
        if (props.beforePersist) {
          var beforePersistResult = props.beforePersist(formData, asyncBeforeComplete(formData, resolve), resolve);

          if (beforePersistResult) {
            if (beforePersistResult.hasOwnProperty('async') && beforePersistResult.async) {
              if (props.beforePersist.length !== 3) {
                // Remove o loading do botão caso o beforePersist não esteja tratando o cancel.
                resolve();
              }

              return;
            } else {
              formData = beforePersistResult;
            }
          }
        }

        persistForm(formData).then(function () {
          return resolve();
        });
      }
    });
  };

  var cancelarClickHandler = function cancelarClickHandler() {
    return onClose();
  };

  var formPropsHandleSubmit = props.formProps.handleSubmit(onSubmit);
  return React.createElement("div", Object.assign({
    ref: editRef
  }, getComponentBasicProps(props, 'm-1'), generateTestId("editview-".concat(props.dtoClassName))), React.createElement(Form, {
    noValidate: true,
    autoComplete: "off",
    className: "edit-form"
  }, React.createElement(InputGroupInline, {
    id: "id",
    formProps: props.formProps,
    hidden: true
  }), React.createElement(InputProvider, {
    onEvent: handleFocusOnEnter.bind(null, props.useEnterAsTab, editRef)
  }, props.children), props.externalSubmit === true ? null : React.createElement(ProcessBar, {
    handleSubmit: formPropsHandleSubmit,
    handleClose: cancelarClickHandler,
    hideSubmitButton: props.hideSubmitButton,
    hideCancelButton: props.hideCancelButton,
    btnSubmitIcon: "save",
    btnSubmitLabel: "Salvar"
  }, props.customFooter)));
});

var DeleteButton = function DeleteButton(props) {
  function handleRemove() {
    props.handleRemove(props.id);
  }

  return React.createElement("span", Object.assign({
    onClick: handleRemove
  }, generateTestId('file-input-delete-btn')), React.createElement(FontAwesomeIcon, {
    className: "file-item-icon-trash",
    size: "1x",
    icon: "trash",
    color: "#d84046"
  }));
};

var FileInputPreview = function FileInputPreview(props) {
  var _useState29 = useState([]),
      _useState30 = _slicedToArray(_useState29, 2),
      preview = _useState30[0],
      setPreview = _useState30[1];

  var limitSize = props.limitSizeBytes || SIZE_TWO_BYTES;
  var maxFiles = props.maxFiles || 1;
  var value = props.formProps.watch(props.propImageName);
  useEffect(function () {
    if (!value) {
      setPreview([]);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [value]);

  function handleChange(evt) {
    var files = evt.target.files;

    if (preview.length + files.length > maxFiles) {
      props.formProps.setValue(props.propImageName, []);
      setPreview([]);
      showToast(React.createElement(React.Fragment, null, React.createElement("p", null, "Voc\xEA excedeu a quantidade m\xE1xima de arquivos permitida!"), React.createElement("span", null, "Quantidade m\xE1x: ", maxFiles)), ERROR);
    } else {
      var resultListErrors = [];
      var resultList = [];

      for (var i = 0; i < files.length; i++) {
        var file = files.item(i);
        var arquivo = {
          file: file,
          id: uuidv4(),
          nomeArquivo: file.name
        };

        if (file.size > limitSize) {
          resultListErrors.push(arquivo);
        } else {
          resultList.push(arquivo);
        }
      }

      var finalResult = [].concat(_toConsumableArray(preview), resultList);
      setPreview(finalResult);
      props.formProps.setValue(props.propImageName, finalResult);
      evt.target.value = '';

      if (resultListErrors.length > 0) {
        var compError = React.createElement(React.Fragment, null, React.createElement("p", null, "Os seguintes arquivos n\xE3o podem ser importados devido seu tamanho ultrapassar o limite de ", formatBytes(limitSize)), React.createElement("ul", null, resultListErrors.map(function (it) {
          return React.createElement("li", {
            key: it.id
          }, it.nomeArquivo);
        })));
        showToast(compError, ERROR);
      }
    }
  }

  function getIconByTypeOfFile(filename) {
    var result = {
      color: '#2f353a',
      icon: null
    };
    var extension = getExtension(filename);

    switch (extension) {
      case 'png':
      case 'jpeg':
      case 'jpg':
        result.icon = 'file-image';
        break;

      case 'txt':
        result.icon = 'file-alt';
        break;

      case '7z':
      case 'zip':
      case 'rar':
        result.icon = 'file-archive';
        break;

      case 'mp3':
        result.icon = 'file-audio';
        break;

      case 'csv':
        result.icon = 'file-csv';
        break;

      case 'xls':
        result.icon = 'file-excel';
        break;

      case 'pdf':
        result.icon = 'file-pdf';
        break;

      case 'ppt':
      case 'pptx':
        result.icon = 'file-powerpoint';
        break;

      case 'mp4':
      case 'mkv':
      case 'avi':
        result.icon = 'file-video';
        break;

      case 'doc':
      case 'docx':
        result.icon = 'file-word';
        break;

      default:
        result.icon = 'file';
    }

    return React.createElement(FontAwesomeIcon, {
      className: "ml-3",
      size: "3x",
      icon: result.icon,
      color: result.color
    });
  }

  function handleRemove(id) {
    var restItens = preview.filter(function (it) {
      return it.id !== id;
    });
    setPreview(restItens);
    props.formProps.setValue(props.propImageName, restItens);
  }

  function renderFileItem(item) {
    return React.createElement("div", {
      key: item.id,
      className: "file-item"
    }, React.createElement(DeleteButton, {
      id: item.id,
      handleRemove: handleRemove
    }), getIconByTypeOfFile(item.nomeArquivo), React.createElement("div", {
      className: "file-item-info"
    }, React.createElement("strong", null, item.nomeArquivo), React.createElement("span", null, formatBytes(item.file.size))));
  }

  function getPlaceholder() {
    return props.isMultiple && maxFiles > 1 ? "Selecione um ou no m\xE1ximo ".concat(maxFiles, " arquivos") : 'Selecione um arquivo';
  }

  return React.createElement(Card, null, React.createElement("label", {
    htmlFor: props.propImageName,
    ref: props.formProps.register({
      name: props.propImageName
    })
  }, React.createElement("div", null, React.createElement(FontAwesomeIcon, {
    size: "4x",
    icon: "cloud-upload-alt",
    color: "#20a8d8"
  }), React.createElement("span", {
    className: "ml-3"
  }, getPlaceholder())), React.createElement("input", Object.assign({
    type: "file",
    id: props.propImageName,
    multiple: props.isMultiple,
    onChange: handleChange,
    accept: props.acceptedTypes
  }, generateTestId("file-input-".concat(props.propImageName))))), preview && preview.length > 0 && React.createElement("div", {
    className: "files-preview"
  }, preview.map(renderFileItem)));
};

var TAMANHO_LIMITE_KB = 200;
var TIPOS_PERMITIDOS = ['image/png', 'image/jpeg'];

var ImageInputControl = function ImageInputControl(props) {
  var tooltipTarget = props.tooltipProps ? props.tooltipProps.target : "tooltip-".concat(props.name);
  var tipos = props.acceptFileType || TIPOS_PERMITIDOS;
  var tamanho = props.maxFileSize || TAMANHO_LIMITE_KB;

  var _useState31 = useState(null),
      _useState32 = _slicedToArray(_useState31, 2),
      preview = _useState32[0],
      setPreview = _useState32[1];

  var inputRef = useRef();
  useEffect(function () {
    if (props.value && typeof props.value === 'string') {
      setPreview("data:image/png;base64,".concat(props.value));
    }
  }, [props.value]);

  var onChange = function onChange(e) {
    e.persist();
    var file = e.target.files[0];

    if (file) {
      if (tipos.indexOf(file.type) === -1) {
        alertManager.emit(ACTION_EVENTS.SHOW, {
          message: 'Formato do arquivo inválido',
          type: AlertType.INFORMATION
        });
        file = null;
      } else if (file.size / 1024 > tamanho) {
        alertManager.emit(ACTION_EVENTS.SHOW, {
          message: 'O tamanho máximo permitido para upload é de 200kb',
          type: AlertType.INFORMATION
        });
        file = null;
      } else {
        var reader = new FileReader();

        reader.onload = function () {
          return setPreview(reader.result);
        };

        reader.readAsDataURL(file);
      }
    }

    props.onChange(file);
    props.onBlur(file);
  };

  var onRemove = function onRemove(event) {
    inputRef.current.value = null;
    setPreview(null);
    props.onChange(null);
    props.onBlur(null);

    if (props.onRemove) {
      props.onRemove(event);
    }
  };

  return React.createElement("div", {
    className: cx('react-input-image-preview', {
      disabled: props.disabled
    })
  }, !props.disabled && React.createElement(React.Fragment, null, React.createElement(UncontrolledTooltip, Object.assign({
    target: tooltipTarget
  }, props.tooltipProps), props.tooltipMsg || 'Alterar Foto 120x120 pixels (Tamanho máximo 200 KB)'), React.createElement("div", {
    className: "remove-image"
  }, React.createElement(Button, {
    id: 'buttonRemove',
    color: "red",
    onClick: onRemove,
    className: "btn-pill d-30 p-0 align-top btn-animated-icon btn-animated-icon--secondary"
  }, React.createElement("span", {
    className: "btn-wrapper--icon"
  }, React.createElement(FontAwesomeIcon, {
    color: 'red',
    icon: 'times'
  })), React.createElement(UncontrolledTooltip, {
    target: 'buttonRemove',
    placement: "top"
  }, "Remover")))), React.createElement("label", {
    id: tooltipTarget.toString(),
    htmlFor: props.name
  }, preview ? React.createElement("img", {
    src: preview,
    alt: "Preview"
  }) : React.createElement("div", null, React.createElement(FontAwesomeIcon, {
    size: "4x",
    icon: "cloud-upload-alt",
    color: "#20a8d8"
  })), React.createElement("input", Object.assign({
    ref: inputRef,
    type: "file",
    id: props.name,
    accept: tipos.join(','),
    name: props.name,
    onChange: onChange,
    disabled: props.disabled
  }, generateTestId("input-file-image-".concat(props.name))))));
};

var ImageInputPreview = function ImageInputPreview(props) {
  return React.createElement(Controller, {
    as: React.createElement(ImageInputControl, Object.assign({}, props)),
    name: props.propImageName,
    control: props.formProps.control,
    rules: props.formProps.validation,
    disabled: props.disabled,
    mode: "onBlur"
  });
};

var InputDebounce = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(InputDebounce, _React$PureComponent);

  var _super = _createSuper(InputDebounce);

  function InputDebounce(props) {
    var _this;

    _classCallCheck(this, InputDebounce);

    _this = _super.call(this, props);
    _this.flush = null;
    _this.notify = null;
    _this.isDebouncing = false;

    _this.onChange = function (event) {
      event.persist();
      var oldValue = _this.state.value;

      _this.setState({
        value: event.target.value
      }, function () {
        var value = _this.state.value;

        if (value.length >= _this.props.minLength) {
          _this.notify(event);

          return;
        }

        if (oldValue.length > value.length) {
          _this.notify(_objectSpread(_objectSpread({}, event), {}, {
            target: _objectSpread(_objectSpread({}, event.target), {}, {
              value: ''
            })
          }));
        }
      });
    };

    _this.doNotify = function (args) {
      _this.props.onChange(args);
    };

    _this.state = {
      value: ''
    };
    return _this;
  }

  _createClass(InputDebounce, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      var debounceTimeout = this.props.debounceTimeout;

      if (debounceTimeout < 0) {
        this.notify = function () {
          return null;
        };
      } else if (debounceTimeout === 0) {
        this.notify = this.doNotify;
      } else {
        var debouncedChangeFunc = debounce(function (event) {
          _this2.isDebouncing = false;

          _this2.doNotify(event);
        }, debounceTimeout);

        this.notify = function (event) {
          _this2.isDebouncing = true;
          debouncedChangeFunc(event);
        };

        this.flush = function () {
          return debouncedChangeFunc.flush();
        };
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.isDebouncing) {
        return;
      }

      var value = this.props.value;
      var oldValue = prevProps.value;
      var stateValue = this.state.value;

      if (typeof value !== 'undefined' && oldValue !== value && stateValue !== value) {
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.flush) {
        this.flush();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          element = _this$props.element,
          type = _this$props.type,
          className = _this$props.className;
      return React.createElement(element, _objectSpread({
        className: className,
        onChange: this.onChange,
        type: type,
        value: this.state.value
      }, generateTestId("input-debounce-".concat(id))));
    }
  }]);

  return InputDebounce;
}(React.PureComponent);

InputDebounce.defaultProps = {
  debounceTimeout: 500,
  element: 'input',
  minLength: 2,
  type: 'text'
};

var Loading = function Loading(props) {
  var result = null;

  if (props.isLoading) {
    result = React.createElement(Row, {
      className: "text-center"
    }, React.createElement(Col, null, React.createElement(Spinner, {
      animation: "border",
      role: "status",
      variant: "primary"
    }, "Carregando...")));
  } else if (props.error) {
    result = React.createElement("div", null, "Ocorreu um erro ao carregar a p\xE1gina.");
  }

  return result;
};

var Progress = function Progress() {
  var progressReducer = useSelector(function (state) {
    return state.progressReducer;
  });
  return React.createElement(Modal, {
    size: "sm",
    centered: true,
    isOpen: progressReducer.showing,
    backdrop: "static"
  }, React.createElement(ModalBody, null, React.createElement(Progress$1, Object.assign({}, progressReducer.data), progressReducer.data.label)));
};

var Router = function Router(props) {
  var loginReducer = useSelector(function (state) {
    return state.loginReducer;
  });
  return React.createElement(BrowserRouter, Object.assign({}, props), props.routes.map(function (_ref6, i) {
    var requireAuthentication = _ref6.requireAuthentication,
        component = _ref6.component,
        routeProps = _objectWithoutProperties(_ref6, _excluded);

    var result;

    if (!requireAuthentication || loginReducer.param) {
      result = React.createElement(Route, Object.assign({
        key: i,
        component: component
      }, routeProps));
    } else {
      var renderFunc = function renderFunc() {
        return React.createElement(Redirect, {
          to: "/"
        });
      };

      result = React.createElement(Route, Object.assign({
        key: i
      }, routeProps, {
        render: renderFunc
      }));
    }

    return result;
  }));
};

var EditViewModal = function EditViewModal(props) {
  var EditViewComp = getViewElement(props.editViewId);
  return React.createElement(Modal, Object.assign({
    size: props.modalProps.size || 'xl'
  }, props.modalProps), React.createElement(EditViewComp, Object.assign({}, props.extraProps, {
    isModal: true,
    beforeClose: props.modalProps.toggle,
    windowToggle: props.modalProps.toggle,
    selectedItem: props.selectedItem
  })));
};

var EventType = {
  ACESSO: 'ACESSO',
  FAV_CHECK: 'FAV_CHECK',
  FAV_RESULT: 'FAV_RESULT',
  FAV_TOGGLE: 'FAV_TOGGLE',
  GRUPO_REL_OPEN: 'GRUPO_REL_OPEN'
};
var eventManager = {
  events: {},
  on: function on(type, callback) {
    if (Object.keys(this.events).indexOf(type) === -1) {
      this.events[type] = [];
    }

    this.events[type].push(callback);
    return this;
  },
  off: function off(type) {
    if (Object.keys(this.events).indexOf(type) !== -1) {
      delete this.events[type];
    }

    return this;
  },
  emit: function emit(type) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    if (Object.keys(this.events).indexOf(type) !== -1) {
      this.events[type].forEach(function (it) {
        return it.apply(void 0, args);
      });
    }
  }
};

var FavButton = function FavButton(props) {
  var btnId = 'fav-button';

  var onClick = function onClick() {
    return eventManager.emit(EventType.FAV_TOGGLE, {
      modulo: props.modulo,
      id: props.id
    });
  };

  return React.createElement(Button, Object.assign({
    id: btnId,
    onClick: onClick,
    color: "default",
    className: "fav-button btn-pill d-40 p-0 float-right"
  }, generateTestId(btnId)), React.createElement("span", {
    className: "btn-wrapper--icon d-flex justify-content-center align-items-center"
  }, React.createElement(FontAwesomeIcon, {
    icon: props.active ? faStar : faStar$1
  })), React.createElement(UncontrolledTooltip, {
    target: btnId
  }, props.active ? 'Remover dos Favoritos' : 'Adicionar aos Favoritos'));
};

var WrapperSimple = function WrapperSimple(_ref7) {
  var children = _ref7.children,
      sectionHeading = _ref7.sectionHeading,
      testId = _ref7.testId,
      wrapBody = _ref7.wrapBody;
  return React.createElement(Card, Object.assign({
    className: "card-box mb-3"
  }, generateTestId(testId ? testId : 'wrapper-simple')), React.createElement(CardHeader, null, React.createElement("div", {
    className: "card-header--title font-size-md font-weight-bold py-2"
  }, sectionHeading)), wrapBody === false ? children : React.createElement(CardBody, null, children));
};

var RatingButton = function RatingButton(_ref8) {
  var onClick = _ref8.onClick;
  var btnId = 'rating-button';
  return React.createElement(Button, Object.assign({
    id: btnId,
    onClick: onClick,
    color: "default",
    className: "rating-button btn-pill d-40 p-0 float-right"
  }, generateTestId(btnId)), React.createElement("span", {
    className: "btn-wrapper--icon d-flex justify-content-center align-items-center"
  }, React.createElement(FontAwesomeIcon, {
    icon: faThumbsUp
  })), React.createElement(UncontrolledTooltip, {
    target: btnId
  }, "Deixe sua opini\xE3o aqui sobre essa tela."));
};

function getService$1() {
  return create('/ger');
}

function evaluateScreen(ratingDTO, usuarioLogado, param) {
  send(getService$1().post('/evaluateScreen', ratingDTO, {
    params: {
      usuarioLogado: usuarioLogado
    }
  }), param);
}

var RatingPage = function RatingPage(_ref9) {
  var viewId = _ref9.viewId,
      onSendForm = _ref9.onSendForm;

  var _useSelector = useSelector(function (state) {
    return state.loginReducer;
  }),
      param = _useSelector.param;

  var formProps = useForm({
    defaultValues: {
      screenName: viewId,
      evaluationValue: 0,
      comment: ''
    },
    mode: 'onBlur'
  });
  useEffect(function () {
    formProps.register('evaluationValue');
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  function onSubmit(data) {
    evaluateScreen(data, param.usuario, {
      errorFunction: function errorFunction(mensagem) {
        return showToast(mensagem, ERROR);
      },
      thenFunction: function thenFunction(result) {
        return showToast('Avaliação enviada com sucesso!', SUCCESS);
      }
    });
    onSendForm();
  }

  function changeRating(value) {
    formProps.setValue('evaluationValue', value);
  }

  return React.createElement(Row, null, React.createElement(Col, null, React.createElement(Form, {
    noValidate: true
  }, React.createElement(InputGroupInline, {
    id: "screenName",
    formProps: formProps,
    hidden: true
  }), React.createElement(FormGroup, {
    className: "d-flex justify-content-center"
  }, React.createElement(Rating, {
    className: "testid",
    onChange: changeRating,
    emptySymbol: React.createElement("span", {
      className: "mr-2 text-muted"
    }, React.createElement(FontAwesomeIcon, {
      size: "2x",
      icon: ['far', 'thumbs-up']
    })),
    fullSymbol: React.createElement("span", {
      className: "mr-2"
    }, React.createElement(FontAwesomeIcon, {
      color: "#4191ff",
      size: "2x",
      icon: faThumbsUp
    }))
  })), React.createElement(InputGroupInline, {
    formProps: _objectSpread(_objectSpread({}, formProps), {}, {
      validation: {
        maxLength: 200
      }
    }),
    id: "comment",
    isPrependLabel: true,
    label: "Coment\xE1rio",
    type: InputType.TEXT_AREA
  }), React.createElement(Button, Object.assign({
    color: "first",
    className: "mt-1",
    block: true,
    onClick: formProps.handleSubmit(onSubmit)
  }, generateTestId('evaluateScreenBtn')), React.createElement(FontAwesomeIcon, {
    icon: ['far', 'paper-plane']
  }), " Enviar"))));
};

var getWindowId = function getWindowId(title) {
  return title && typeof title === 'string' ? "window-".concat(title.toLowerCase().replace(/[^\w]/g, '')) : 'window-custom-title';
};

var WindowComponent = function WindowComponent(props) {
  var _useHistory = useHistory(),
      location = _useHistory.location,
      push = _useHistory.push;

  var _useState33 = useState(false),
      _useState34 = _slicedToArray(_useState33, 2),
      showRatingModal = _useState34[0],
      setShowRatingModal = _useState34[1];

  var _useState35 = useState(false),
      _useState36 = _slicedToArray(_useState35, 2),
      favActive = _useState36[0],
      setFavActive = _useState36[1];

  var isModal = props.searchDataGridProps && props.searchDataGridProps.extraData && props.searchDataGridProps.extraData.isModal;
  var urlData = location.pathname.substr(1).split('/');
  var exibirFav = urlData.length === 2;
  var exibirGrupoRel = exibirFav && urlData[1].indexOf('ReportView') !== -1 && !isModal;
  var windowId = getWindowId(props.title);

  var _useState37 = useState(false),
      _useState38 = _slicedToArray(_useState37, 2),
      done = _useState38[0],
      setDone = _useState38[1];

  var _useState39 = useState([]),
      _useState40 = _slicedToArray(_useState39, 2),
      errors = _useState40[0],
      setErrors = _useState40[1];

  useEffect(function () {
    eventManager.on(EventType.FAV_RESULT, function (modulo, id, active) {
      if (modulo === urlData[0].toUpperCase() && id === urlData[1]) {
        setFavActive(active);
      }
    });
    setTimeout(function () {
      return eventManager.emit(EventType.FAV_CHECK, {
        modulo: urlData[0].toUpperCase(),
        id: urlData[1]
      });
    }, 500);
    return function () {
      return eventManager.off(EventType.FAV_RESULT);
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useEffect(function () {
    if (props.globalParameter && props.dependencies) {
      Promise.all(props.dependencies.map(function (d) {
        return d();
      })).then(function (values) {
        if (values && values.filter(function (it) {
          return !isEmpty(it);
        }).length > 0) {
          setErrors(values.filter(function (it) {
            return it;
          }));
        }

        setDone(true);
      }).catch(function () {
        setDone(false);
        setErrors([]);
      });
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.dependencies]);

  var toggleRatingModal = function toggleRatingModal() {
    return setShowRatingModal(!showRatingModal);
  };

  var goToAgenda = function goToAgenda() {
    return push("/".concat(urlData[0], "/agendaProcessView"));
  };

  var openGrupoRelatorio = function openGrupoRelatorio() {
    return eventManager.emit(EventType.GRUPO_REL_OPEN, urlData[0].toUpperCase(), urlData[1]);
  };

  var getHeadingSection = function getHeadingSection() {
    var header = [];

    if (props.hiddenHeader !== true) {
      header.push(React.createElement("span", {
        key: "pageTitle"
      }, props.title));
      var iconContainer = [];

      if (props.isModal || props.searchDataGridProps && props.searchDataGridProps.extraData.isModal) {
        iconContainer.push(React.createElement(Button, {
          onClick: props.windowToggle,
          className: "float-right btn-pill d-40 p-0 border-0",
          color: "dark",
          outline: true,
          key: "windowToggle"
        }, React.createElement(FontAwesomeIcon, {
          icon: faTimes
        })));
      }

      if (props.wikiId || props.wikiTitle) {
        iconContainer.push(React.createElement(WikiButton, {
          key: "pageTitleWiki",
          pageId: props.wikiId,
          pageTitle: props.wikiTitle
        }));
      }

      if (!props.hiddenHeader) {
        iconContainer.push(React.createElement(RatingButton, {
          key: "ratingButton",
          onClick: toggleRatingModal
        }));
      }

      if (exibirGrupoRel) {
        iconContainer.push(React.createElement(React.Fragment, null, React.createElement(Button, {
          id: "".concat(windowId, "-btnGrupoRelatorio"),
          onClick: openGrupoRelatorio,
          className: "btn-grupo-rel float-right btn-pill d-40 p-0 border-0",
          color: "dark",
          outline: true,
          key: "grupoRelatorio"
        }, React.createElement(FontAwesomeIcon, {
          icon: faLayerGroup
        })), React.createElement(UncontrolledTooltip, {
          target: "".concat(windowId, "-btnGrupoRelatorio")
        }, "Adicionar a um Grupo de Relat\xF3rio")));
      }

      if (exibirFav) {
        iconContainer.push(React.createElement(FavButton, {
          key: "favButton",
          active: favActive,
          modulo: urlData[0].toUpperCase(),
          id: urlData[1]
        }));
      }

      if (props.showBtnAgendarProcesso) {
        iconContainer.push(React.createElement(Button, {
          onClick: goToAgenda,
          className: "float-right btn-pill d-40 p-0 border-0 ml-2",
          color: "info",
          outline: true,
          key: "goToAgenda",
          id: "".concat(windowId, "-goToAgenda")
        }, React.createElement(FontAwesomeIcon, {
          icon: faCalendarAlt
        }), React.createElement(UncontrolledTooltip, {
          target: "".concat(windowId, "-goToAgenda")
        }, "Agendar Processos")));
      }

      header.push(React.createElement("div", {
        id: "icon-container",
        key: "pageTitleIconContainer"
      }, iconContainer));
    }

    return React.createElement("div", {
      className: "d-flex justify-content-between align-items-center"
    }, header);
  };

  return !done || errors.length === 0 ? React.createElement(React.Fragment, null, React.createElement(WrapperSimple, {
    sectionHeading: getHeadingSection(),
    testId: windowId,
    wrapBody: props.wrapBody
  }, props.children), React.createElement(Modal, {
    centered: true,
    backdrop: "static",
    isOpen: showRatingModal,
    toggle: toggleRatingModal,
    size: "xs"
  }, React.createElement(ModalHeader, {
    toggle: toggleRatingModal
  }, "Deixe sua opini\xE3o aqui sobre essa tela"), React.createElement(ModalBody, null, React.createElement(RatingPage, {
    viewId: location.pathname,
    onSendForm: toggleRatingModal
  })))) : React.createElement(ErroList, {
    erros: errors,
    hideHeader: true
  });
};

function loadIcons() {
  library.add(faAddressCard, faBell, faBuilding, faCalendarAlt$1, faChartBar, faCheckCircle, faClock, faCommentDots, faComments, faCopy, faDotCircle, faEnvelope, faEye, faFile, faFileAlt, faFileArchive, faFileAudio, faFileCode, faFileExcel, faFileImage, faFilePdf, faFileVideo, faFileWord, faFolder, faFolderOpen, faGem, faImages, faKeyboard, faLifeRing, faLightbulb, faMap, faObjectGroup, faQuestionCircle, far, faSquare, faThumbsUp$1, faTimesCircle, faTrashAlt, faUser, faUserCircle);
  library.add(fas, faAlignCenter, faAngleDoubleLeft, faAngleDoubleRight, faAngleDown, faAngleLeft, faAngleRight, faAngleUp, faArrowDown, faArrowLeft, faArrowRight, faArrowsAltH, faArrowUp, faAward, faBars, faBatteryEmpty, faBatteryFull, faBirthdayCake, faBomb, faBookOpen, faBusAlt, faCameraRetro, faCarBattery, faCaretRight, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCloudUploadAlt, faCog, faCubes, faDesktop, faDonate, faDownload, faEllipsisH, faEllipsisV, faExclamationCircle, faExternalLinkAlt, faEyeDropper, faFileContract, faFileCsv, faFileInvoiceDollar, faFilePowerpoint, faFilm, faFilter, faHeart, faIdCard, faInfoCircle, faKey, faLemon, faLink, faMapMarkedAlt, faNetworkWired, faPager, faPaste, faPen, faPencilRuler, faPlayCircle, faPlus, faPlusCircle, faPrint, faQuoteRight, faReceipt, faReply, fas, faSadTear, faSave, faSearch, faShapes, faShareSquare, faSignOutAlt, faSitemap, faSlidersH, faSmile, faSmileWink, faStar, faStarHalfAlt, faSync, faTable, faTachometerAlt, faTimes, faTrash, faUndoAlt, faUnlockAlt, faUpload, faUserClock, faUserCog);
}

var Footer = function Footer(_ref10) {
  var footerShadow = _ref10.footerShadow,
      footerBgTransparent = _ref10.footerBgTransparent,
      firstChildren = _ref10.firstChildren,
      secondChildren = _ref10.secondChildren;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: cx('app-footer text-black-50', {
      'app-footer--opacity-bg': footerBgTransparent,
      'app-footer--shadow': footerShadow
    })
  }, React.createElement("div", {
    className: "app-footer--first"
  }, firstChildren), React.createElement("div", {
    className: "app-footer--second"
  }, secondChildren)));
};

var HeaderMenu = function HeaderMenu(_ref11) {
  var children = _ref11.children;
  return React.createElement("div", {
    className: "app-header-menu"
  }, children);
};

var PageTitle = function PageTitle(_ref12) {
  var pageTitleShadow = _ref12.pageTitleShadow,
      titleHeading = _ref12.titleHeading,
      pageTitleDescription = _ref12.pageTitleDescription,
      titleDescription = _ref12.titleDescription;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: cx('app-page-title', {
      'app-page-title--shadow': pageTitleShadow
    })
  }, React.createElement("div", null, React.createElement("div", {
    className: "app-page-title--first"
  }, React.createElement("div", {
    className: "app-page-title--heading"
  }, React.createElement("h1", null, titleHeading), pageTitleDescription && React.createElement("div", {
    className: "app-page-title--description"
  }, titleDescription))))));
};

var WrapperContainer = function WrapperContainer(_ref13) {
  var children = _ref13.children,
      sectionHeading = _ref13.sectionHeading,
      testId = _ref13.testId;
  return React.createElement("div", Object.assign({
    className: "example-card-container mb-3"
  }, generateTestId(testId ? testId : 'wrapper-container')), React.createElement("div", {
    className: "container"
  }, React.createElement("h5", {
    className: "display-4 mb-4 font-weight-bold"
  }, sectionHeading), children));
};

var WrapperSeamless = function WrapperSeamless(_ref14) {
  var children = _ref14.children,
      sectionHeading = _ref14.sectionHeading,
      testId = _ref14.testId;
  return React.createElement("div", Object.assign({
    className: "example-card-seamless mb-3"
  }, generateTestId(testId ? testId : 'wrapper-seamless')), React.createElement("h5", {
    className: "display-4 mb-4 font-weight-bold"
  }, sectionHeading), children);
};

var SuspenseLoading = function SuspenseLoading(_ref15) {
  var loader = _ref15.loader,
      message = _ref15.message;
  return React.createElement("div", {
    className: "d-flex align-items-center flex-column vh-100 justify-content-center text-center py-3"
  }, React.createElement("div", {
    className: "d-flex align-items-center flex-column px-4"
  }, loader ? loader : React.createElement(BeatLoader, {
    color: '#3c44b1',
    loading: true
  })), React.createElement("div", {
    className: "text-muted font-size-xl text-center pt-3"
  }, message || 'Aguarde enquanto preparamos tudo para você'));
};

var defaultAccordionTitleColor = 'light';
var defaultAccordionHeaderColor = 'menu';

var findWarningItems = function findWarningItems(errors) {
  var inputListParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  var keys = Object.keys(errors).filter(function (key) {
    return errors[key].type === 'required';
  });

  if (keys.length > 0) {
    keys.forEach(function (key) {
      var inputPosition = inputListParam.find(function (item) {
        return item.inputs.indexOf(key) !== -1;
      });

      if (inputPosition !== undefined) {
        list.push(inputPosition.index);
      }
    });
  }

  return list;
};

var getChildrens = function getChildrens(props, inputList) {
  var warningItems = [];
  var setFirstOpen = false;
  var childrens = props.children;

  if (Children.count(childrens) > 0) {
    if (props.firstOpen !== false) {
      setFirstOpen = Children.toArray(childrens).find(function (child) {
        return child.props.open;
      }) === undefined;
    }

    if (props.formProps) {
      warningItems = findWarningItems(props.formProps.errors, inputList);
    }

    childrens = Children.map(childrens, function (child, index) {
      var newProps = {
        index: index,
        title: child.props.title
      };

      if (index === 0 && setFirstOpen) {
        newProps.open = true;
      }

      if (child.props.titleColor === undefined) {
        newProps.titleColor = props.titleColor || defaultAccordionTitleColor;
      }

      if (child.props.headerColor === undefined) {
        newProps.headerColor = props.headerColor || defaultAccordionHeaderColor;
      }

      if (warningItems.indexOf(index + 1) !== -1) {
        newProps.headerColor = 'danger';
      }

      return cloneElement(child, newProps);
    });
  }

  return childrens;
};

var Accordion = function Accordion(props) {
  var _useState41 = useState([]),
      _useState42 = _slicedToArray(_useState41, 2),
      inputList = _useState42[0],
      setInputList = _useState42[1];

  var accordionRef = useRef();
  var childrens = getChildrens(props, inputList);
  useLayoutEffect(function () {
    if (props.formProps) {
      setInputList(findInputChildrens(accordionRef, '.accordion > .accordion-item'));
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.children]);
  return React.createElement("div", Object.assign({}, getComponentBasicProps(props, 'accordion mb-3'), {
    ref: accordionRef
  }), childrens);
};

var accordionIcon = ['fas', 'angle-up'];

var AccordionItem = function AccordionItem(props) {
  var _useState43 = useState(false),
      _useState44 = _slicedToArray(_useState43, 2),
      open = _useState44[0],
      setOpen = _useState44[1];

  useEffect(function () {
    setOpen(props.open);
  }, [props.open]);

  var toggleState = function toggleState() {
    return setOpen(function (prevState) {
      return !prevState;
    });
  };

  return React.createElement(Card, {
    className: cx('accordion-item', {
      'card-box': true,
      'panel-open': open
    })
  }, React.createElement(Card, null, React.createElement(CardHeader, null, React.createElement("div", {
    className: "panel-title"
  }, React.createElement("div", {
    className: "accordion-toggle"
  }, React.createElement(Button, Object.assign({
    color: "link",
    size: "lg",
    className: cx(['d-flex align-items-center justify-content-between', "text-".concat(props.titleColor), "bg-".concat(props.headerColor)]),
    onClick: toggleState,
    "aria-expanded": open
  }, generateTestId("accordion-item-".concat(props.index)), {
    disabled: props.disabled || false
  }), React.createElement("span", null, props.title), React.createElement(FontAwesomeIcon, {
    icon: accordionIcon,
    className: "font-size-xl accordion-icon"
  }))))), React.createElement(Collapse, {
    isOpen: open
  }, React.createElement(CardBody, null, props.children))));
};

var Checkbox = function Checkbox(props) {
  var boxId = "box-check-".concat(props.id.replace(/\./g, '_'));
  var checkId = "check-".concat(props.id.replace(/\./g, '_'));

  var getTooltip = function getTooltip() {
    if (props.tooltipProps) {
      var tooltipProps = _objectSpread({
        message: null,
        placement: 'bottom-start'
      }, props.tooltipProps);

      return React.createElement(UncontrolledTooltip, Object.assign({
        target: boxId
      }, tooltipProps), tooltipProps.message);
    }

    return null;
  };

  var getLabel = function getLabel() {
    var result = null;

    if (props.labelProps && props.label) {
      var labelProps = _objectSpread({
        for: checkId
      }, props.labelProps);

      result = React.createElement(Label, Object.assign({}, labelProps), props.label);
    }

    return result;
  };

  return React.createElement("div", Object.assign({
    id: boxId,
    className: "summer-checkbox"
  }, generateTestId(boxId)), React.createElement(CustomInput, Object.assign({}, props.inputProps || {}, {
    type: "switch",
    label: props.labelProps ? null : props.label,
    name: props.id,
    id: checkId,
    innerRef: props.formProps.register,
    disabled: props.disabled || false,
    onChange: props.onChange,
    style: {
      display: 'inline-block'
    }
  }, generateTestId(checkId))), getLabel(), getTooltip());
};

var Box = function Box(props) {
  var getHeader = function getHeader() {
    var result = null;

    if (props.title) {
      result = React.createElement(CardHeader, Object.assign({}, getComponentBasicProps(props.headerProps, 'font-weight-bold bg-light')), props.title, props.wikiId ? React.createElement(WikiButton, {
        pageId: props.wikiId,
        pageTitle: props.wikiTitle,
        buttonProps: {
          style: {
            position: 'absolute',
            right: '0.5rem',
            top: 5
          }
        },
        small: true
      }) : null);
    }

    return result;
  };

  return React.createElement(Card, Object.assign({}, getComponentBasicProps(props, 'box-card')), getHeader(), React.createElement(CardBody, Object.assign({}, getComponentBasicProps(props.bodyProps)), props.children));
};

var TabGroup = function TabGroup(props) {
  var _useState45 = useState(1),
      _useState46 = _slicedToArray(_useState45, 2),
      activeTab = _useState46[0],
      setActiveTab = _useState46[1];

  var _useState47 = useState([]),
      _useState48 = _slicedToArray(_useState47, 2),
      inputList = _useState48[0],
      setInputList = _useState48[1];

  var tabGroupRef = useRef();
  useLayoutEffect(function () {
    if (props.formProps) {
      setInputList(findInputChildrens(tabGroupRef, '.tab-content > .tab-pane'));
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.children]);

  var findWarningItems = function findWarningItems() {
    var list = [];
    var keys = Object.keys(props.formProps.errors).filter(function (key) {
      return props.formProps.errors[key].type === 'required';
    });

    if (keys.length > 0) {
      keys.forEach(function (key) {
        var inputPosition = inputList.find(function (item) {
          return item.inputs.indexOf(key) !== -1;
        });

        if (inputPosition !== undefined) {
          list.push(inputPosition.index);
        }
      });
    }

    return list;
  };

  var warningItems = props.formProps ? findWarningItems() : [];

  var toggleTab = function toggleTab(_ref16) {
    var target = _ref16.target;
    var tabIndex = target.tabIndex;

    if (tabIndex !== activeTab) {
      setActiveTab(tabIndex);

      if (props.onChange) {
        props.onChange(childrens[tabIndex - 1].props.id || tabIndex);
      }
    }
  };

  var getNavItem = function getNavItem(item, index) {
    var tabIndex = index + 1;
    return React.createElement(NavItem, {
      key: index
    }, React.createElement(NavLink, {
      className: cx({
        active: activeTab === tabIndex,
        'd-none': item.props.hidden,
        'warning-nav-link': warningItems.indexOf(tabIndex) !== -1
      }),
      tabIndex: tabIndex,
      onClick: toggleTab,
      disabled: item.props.disabled || false
    }, item.props.title));
  };

  var getContentItem = function getContentItem(item, index) {
    return React.createElement(TabPane, {
      tabId: index + 1,
      className: cx('mb-0 pt-3 pb-3', {
        'd-none': item.props.hidden
      }),
      key: index
    }, item);
  };

  var childrens = Children.toArray(props.children).filter(function (item) {
    return item !== null;
  });
  return React.createElement(React.Fragment, null, React.createElement(Nav, {
    tabs: true
  }, childrens.map(getNavItem)), React.createElement("div", {
    ref: tabGroupRef
  }, React.createElement(TabContent, {
    activeTab: activeTab
  }, childrens.map(getContentItem))));
};

var Tab = function Tab(props) {
  return React.createElement(React.Fragment, null, props.children);
};

var Dock = function Dock() {
  var dockReducer = useSelector(function (state) {
    return state.dockReducer;
  });
  return dockReducer.content ? React.createElement("div", {
    className: "promo-section-wrapper"
  }, React.createElement("div", {
    className: "promo-section-buttons-wrapper",
    style: {
      top: "calc(50% - ".concat(30 * Children.count(dockReducer.content.props.children), "px)")
    }
  }, React.createElement("div", {
    className: "promo-section-buttons"
  }, dockReducer.content))) : null;
};

var DockItem = function DockItem(props) {
  var getTooltip = function getTooltip() {
    if (props.tooltipProps || props.text) {
      var tooltipProps = _objectSpread({
        message: null,
        placement: 'left'
      }, props.tooltipProps);

      return React.createElement(UncontrolledTooltip, Object.assign({
        target: props.id
      }, tooltipProps), tooltipProps.message || props.text);
    }

    return null;
  };

  return React.createElement(Button, {
    id: props.id,
    onClick: props.onClick,
    className: cx('dock-button shadow-none text-center rounded-sm', "bg-neutral-".concat(props.color), "text-".concat(props.color))
  }, React.createElement("div", {
    className: "align-icon"
  }, React.createElement(FontAwesomeIcon, {
    icon: props.icon,
    className: "font-size-lg"
  })), React.createElement("span", null, props.text), getTooltip());
};

var DockItemList = function DockItemList(props) {
  return React.createElement(React.Fragment, null, props.children);
};

var insideOfWizard = 'inside-of-wizard';

var Wizard = function Wizard(props) {
  var defaultPrevButton = {
    hidden: false,
    disabled: true,
    label: 'Voltar',
    color: 'primary'
  };
  var defaultNextButton = {
    hidden: false,
    disabled: false,
    label: 'Prosseguir',
    color: 'primary'
  };
  var defaultFinishProp = {
    cancelButton: {
      hidden: false,
      disabled: false,
      label: 'Cancelar',
      color: 'danger'
    },
    confirmButton: {
      hidden: false,
      disabled: false,
      label: 'Finalizar',
      color: 'success'
    },
    onCancel: function onCancel() {
      return null;
    },
    onConfirm: function onConfirm() {
      return null;
    }
  };
  var history = useHistory$1();

  var _useState49 = useState(0),
      _useState50 = _slicedToArray(_useState49, 2),
      currentPage = _useState50[0],
      setCurrentPage = _useState50[1];

  var _useState51 = useState(defaultPrevButton),
      _useState52 = _slicedToArray(_useState51, 2),
      prevButton = _useState52[0],
      setPrevButton = _useState52[1];

  var _useState53 = useState(defaultNextButton),
      _useState54 = _slicedToArray(_useState53, 2),
      nextButton = _useState54[0],
      setNextButton = _useState54[1];

  var _useState55 = useState(defaultFinishProp),
      _useState56 = _slicedToArray(_useState55, 2),
      finishProp = _useState56[0],
      setFinishProp = _useState56[1];

  var _useState57 = useState([]),
      _useState58 = _slicedToArray(_useState57, 2),
      inputFields = _useState58[0],
      setInputFields = _useState58[1];

  var wizardRef = useRef();

  var isNone = function isNone(value) {
    return value === false || value === null;
  };

  var updatePrevButton = function updatePrevButton(newState) {
    return setPrevButton(function (prevState) {
      return newState === null || newState === false ? null : _objectSpread(_objectSpread({}, prevState), newState);
    });
  };

  var updateNextButton = function updateNextButton(newState) {
    return setNextButton(function (prevState) {
      return newState === null || newState === false ? null : _objectSpread(_objectSpread({}, prevState), newState);
    });
  };

  var updateFinishProp = function updateFinishProp(newState) {
    return setFinishProp(function (prevState) {
      return newState === null || newState === false ? null : _objectSpread(_objectSpread(_objectSpread({}, prevState), newState), {}, {
        cancelButton: isNone(newState.cancelButton) ? {} : _objectSpread(_objectSpread(_objectSpread({}, defaultFinishProp.cancelButton), prevState.cancelButton), newState.cancelButton),
        confirmButton: isNone(newState.confirmButton) ? {} : _objectSpread(_objectSpread(_objectSpread({}, defaultFinishProp.confirmButton), prevState.confirmButton), newState.confirmButton)
      });
    });
  };

  useEffect(function () {
    if ((!history.location.state || !history.location.state.currentState || history.location.state.currentState !== insideOfWizard) && currentPage > 0) {
      // goBack executado pelo EditForm ou outro componente retorna a Wizard para a page 1
      prevButtonHandle(null, 0);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [history.location.state]);
  useEffect(function () {
    if (props.prevButton) {
      updatePrevButton(props.prevButton);
    }
  }, [props.prevButton]);
  useEffect(function () {
    if (props.nextButton) {
      updateNextButton(props.nextButton);
    }
  }, [props.nextButton]);
  useEffect(function () {
    if (props.finishProps || props.finishProps === false) {
      updateFinishProp(props.finishProps);
    }
  }, [props.finishProps]);
  useLayoutEffect(function () {
    setInputFields(findInputChildrens(wizardRef, '.wizard-page'));
  }, [props.children]);
  var pages = Children.toArray(props.children);

  var prevent = function prevent(e) {
    return e.preventDefault();
  };

  var getNavItem = function getNavItem(item, index) {
    return React.createElement("li", {
      key: index,
      className: cx('card-box', {
        current: index === currentPage
      })
    }, React.createElement("a", {
      href: "#/",
      onClick: prevent
    }, React.createElement("div", {
      className: "label"
    }, item.props.title), React.createElement("div", {
      className: "step-indicator"
    }, index + 1)));
  };

  var getContentItem = function getContentItem(item, index) {
    return cloneElement(item, {
      visible: currentPage === index
    });
  };

  var getFinishContainer = function getFinishContainer() {
    var result = null;

    if (currentPage === pages.length - 1 && finishProp) {
      var hasCancel = Object.keys(finishProp.cancelButton).length > 0;
      var hasConfirm = Object.keys(finishProp.confirmButton).length > 0;
      result = React.createElement("div", {
        className: "wizard-finish-container"
      }, hasCancel && React.createElement(Button, {
        size: "sm",
        hidden: finishProp.cancelButton.hidden,
        color: finishProp.cancelButton.color,
        disabled: finishProp.cancelButton.disabled,
        onClick: finishProp.onCancel,
        className: hasConfirm && 'mr-2'
      }, React.createElement(FontAwesomeIcon, {
        icon: "times"
      }), " ", finishProp.cancelButton.label), hasConfirm && React.createElement(Button, {
        size: "sm",
        hidden: finishProp.confirmButton.hidden,
        color: finishProp.confirmButton.color,
        disabled: finishProp.confirmButton.disabled,
        onClick: finishProp.onConfirm
      }, React.createElement(FontAwesomeIcon, {
        icon: "check"
      }), " ", finishProp.confirmButton.label));
    }

    return result;
  };

  var prevButtonHandle = function prevButtonHandle(_) {
    var defaultPrevPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if ((!prevButton.disabled || defaultPrevPage !== null) && currentPage > 0) {
      var prevPage = defaultPrevPage !== null ? defaultPrevPage : currentPage - 1;
      var callbackResult = true;

      if (props.onBeforePageChange) {
        callbackResult = props.onBeforePageChange(pages[currentPage].props.id, pages[prevPage].props.id);
      }

      if (callbackResult) {
        setCurrentPage(prevPage);

        if (prevPage === 0) {
          updatePrevButton({
            disabled: true
          });
        }

        if (prevPage < pages.length - 1) {
          var newNextButtonProps = {};

          if (!props.nextButton || !props.nextButton.disabled) {
            newNextButtonProps.disabled = false;
          }

          if (!props.nextButton || !props.nextButton.hidden) {
            newNextButtonProps.hidden = false;
          }

          if (Object.keys(newNextButtonProps).length > 0) {
            updateNextButton(newNextButtonProps);
          }
        }

        if (props.onAfterPageChange) {
          props.onAfterPageChange(pages[prevPage].props.id);
        }
      }
    }
  };

  var nextButtonHandle = function nextButtonHandle() {
    var nextPage = currentPage + 1;

    if (!nextButton.disabled && nextPage < pages.length) {
      validateCurrentWindow().then(function () {
        var callbackResult = true;

        if (props.onBeforePageChange) {
          callbackResult = props.onBeforePageChange(pages[currentPage].props.id, pages[nextPage].props.id);
        }

        if (callbackResult) {
          setCurrentPage(nextPage);

          if (nextPage === pages.length - 1) {
            updateNextButton({
              disabled: true,
              hidden: finishProp !== null
            });
          }

          if (nextPage > 0) {
            var historyState = history.location.state;

            if (!historyState || !historyState.currentState || historyState.currentState !== insideOfWizard) {
              history.push({
                state: {
                  currentState: insideOfWizard
                }
              });
            }

            if (!props.prevButton || !props.prevButton.disabled) {
              updatePrevButton({
                disabled: false
              });
            }
          }

          if (props.onAfterPageChange) {
            props.onAfterPageChange(pages[nextPage].props.id);
          }
        }
      });
    }
  };

  var validateCurrentWindow = function validateCurrentWindow() {
    return new Promise(function (resolve) {
      if (props.validateRequiredFields !== false && props.formProps) {
        var inputList = inputFields.find(function (item) {
          return item.index === currentPage;
        });

        if (inputList !== undefined) {
          props.formProps.triggerValidation(inputList.inputs).then(function (success) {
            if (success) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      } else {
        resolve();
      }
    });
  };

  return React.createElement("div", {
    className: "wizard"
  }, React.createElement("div", {
    className: "horizontal"
  }, React.createElement("ul", {
    className: "steps-indicator"
  }, pages.map(getNavItem))), React.createElement("div", {
    className: "p-3",
    ref: wizardRef
  }, pages.map(getContentItem)), React.createElement("div", {
    className: "actions p-4 ".concat(prevButton.hidden ? 'justify-content-end' : '')
  }, React.createElement(Button, {
    size: "sm",
    outline: true,
    hidden: prevButton.hidden,
    color: prevButton.color,
    disabled: prevButton.disabled,
    onClick: prevButtonHandle
  }, prevButton.label), React.createElement("div", {
    className: "float-right"
  }, React.createElement(Button, {
    className: "mr-2",
    size: "sm",
    hidden: nextButton.hidden,
    color: nextButton.color,
    disabled: nextButton.disabled,
    onClick: nextButtonHandle
  }, nextButton.label), React.createElement(ProcessBar, {
    hideSubmitButton: true,
    hideCancelButton: nextButton.hidden
  })), getFinishContainer()));
};

var WizardPage = function WizardPage(props) {
  return React.createElement("div", {
    className: cx('wizard-page', {
      'd-none': !props.visible
    })
  }, props.children);
};

var CustomSearch = function CustomSearch(props) {
  var _useState59 = useState(props.searchText || props.defaultSearchValue || ''),
      _useState60 = _slicedToArray(_useState59, 2),
      inputValue = _useState60[0],
      setInputValue = _useState60[1];

  var searchClickHandler = function searchClickHandler() {
    props.onSearch(inputValue);
  };

  var onChangeHandler = function onChangeHandler(changeEvent) {
    var value = changeEvent.target.value;
    setInputValue(value);

    if (!isEmpty(value) || props.emitEmptySearch) {
      props.onSearch(value);
    }
  };

  var clearClickHandler = function clearClickHandler() {
    props.onClear();
    setInputValue('');
  };

  var exportClickHandler = function exportClickHandler() {
    if (props.onExport) {
      props.onExport();
    }
  };

  var addClickHandler = function addClickHandler() {
    if (props.onExport) {
      props.onOpenAddScreen();
    }
  };

  var label = props.placeHolder || 'Digite aqui para pesquisar';
  var inputGroup = React.createElement(InputGroup, {
    size: "sm"
  }, React.createElement(InputGroupAddon, {
    addonType: "prepend"
  }, React.createElement(Button, Object.assign({
    onClick: searchClickHandler,
    color: "first"
  }, generateTestId("btn-search-".concat(props.id))), React.createElement(FontAwesomeIcon, {
    icon: "search"
  }))), React.createElement(InputDebounce, Object.assign({}, props.inputProps, {
    id: props.id,
    "aria-label": label,
    className: "form-control custom-search-action-bar",
    value: inputValue,
    onChange: onChangeHandler
  })), React.createElement(InputGroupAddon, {
    addonType: "append"
  }, React.createElement(UncontrolledTooltip, {
    target: "buttonCustomSearchClear",
    placement: "bottom"
  }, props.clearTooltipMsg || 'Clique aqui para limpar a pesquisa'), React.createElement(Button, {
    id: "buttonCustomSearchClear",
    color: "warning",
    onClick: clearClickHandler,
    size: "sm"
  }, React.createElement(FontAwesomeIcon, {
    icon: "eraser"
  }))));
  var extraButtons = React.createElement("div", {
    "aria-label": "Extra Buttons"
  }, props.extraButtons, props.showExportCsvButton ? React.createElement(React.Fragment, null, React.createElement(UncontrolledTooltip, {
    target: "buttonCustomSearchCsv",
    placement: "bottom"
  }, props.exportCsvTooltipMsg || 'Clique aqui para exportar os dados como csv'), React.createElement(Button, Object.assign({
    id: "buttonCustomSearchCsv",
    color: "primary",
    onClick: exportClickHandler
  }, generateTestId("btn-search-csv-".concat(props.id)), {
    size: "sm"
  }), React.createElement(FontAwesomeIcon, {
    icon: "file-csv"
  }), " Exportar")) : null, props.hideAddButton ? null : React.createElement(React.Fragment, null, React.createElement(UncontrolledTooltip, {
    target: "buttonCustomSearchAdd",
    placement: "bottom"
  }, props.addButtonTooltipMsg || 'Clique aqui para incluir um novo registro'), React.createElement(Button, Object.assign({
    id: "buttonCustomSearchAdd",
    color: "success",
    onClick: addClickHandler
  }, generateTestId("btn-search-add-".concat(props.id))), React.createElement(FontAwesomeIcon, {
    icon: "plus"
  }), " Incluir")));
  var searchWithExtraButtons = props.showExportCsvButton || !props.hideAddButton ? React.createElement(Row, {
    className: "mb-3"
  }, React.createElement(Col, {
    sm: 8
  }, inputGroup), React.createElement(Col, {
    className: "d-flex col justify-content-end"
  }, extraButtons)) : React.createElement(Row, {
    className: "mb-3"
  }, React.createElement(Col, null, inputGroup));
  return React.createElement("div", {
    className: "mb-3"
  }, searchWithExtraButtons);
};

var Tree = function Tree(props) {
  var _useState61 = useState(),
      _useState62 = _slicedToArray(_useState61, 2),
      arvore = _useState62[0],
      setArvore = _useState62[1];

  useEffect(function () {
    renderTreeList(props.parentNodesIdList);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.listenerRenderTree, props.parentNodesIdList]);

  var renderTreeList = function renderTreeList(nodes) {
    if (props.nodeList.length > 0) {
      setArvore(props.nodeList.map(function (node, index) {
        return nodes.includes(index) ? renderTree(node) : null;
      }));
    }
  };

  var handleLabelClick = function handleLabelClick(id) {
    return function (e) {
      if (props.labelClickFunc) {
        props.labelClickFunc(e, id);
      }
    };
  };

  var handleLabelDobleClick = function handleLabelDobleClick(id) {
    return function (e) {
      e.preventDefault();

      if (props.labelDoubleClick) {
        props.labelDoubleClick(id);
      }
    };
  };

  var getLabel = function getLabel(node) {
    return React.createElement("span", {
      onDoubleClick: handleLabelDobleClick(node.id),
      className: "tree-label-wrapper"
    }, props.labelFunc(node));
  };

  var renderTree = function renderTree(node) {
    return React.createElement(TreeItem, {
      key: node.id || '',
      nodeId: node.id ? node.id.toString() : '',
      label: getLabel(node),
      onLabelClick: handleLabelClick(node.id)
    }, Array.isArray(node.children) && node.children.map(renderTree));
  };

  return props.nodeList.length > 0 && React.createElement(TreeView, {
    defaultExpanded: props.idsExpandedItems || props.nodeList.map(function (element) {
      return element.id.toString();
    }),
    defaultCollapseIcon: props.collapsedIcon || React.createElement(FontAwesomeIcon, {
      icon: "arrow-circle-down"
    }),
    defaultExpandIcon: props.expandIcon || React.createElement(FontAwesomeIcon, {
      icon: "arrow-circle-right"
    })
  }, arvore);
};

function convertToTree(itens) {
  var showCheckbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var result = [];

  if (itens.length > 0) {
    var _iterator = _createForOfIteratorHelper(itens),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var obj = _step.value;

        var raiz = _objectSpread(_objectSpread({}, obj), {}, {
          children: [],
          label: obj.label,
          showCheckbox: showCheckbox,
          value: obj.id
        });

        result.push(addChild(raiz, obj.children, showCheckbox));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return result;
}

function addChild(noRaiz, nodes, showCheckbox) {
  var _iterator2 = _createForOfIteratorHelper(nodes),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var obj = _step2.value;

      var node = _objectSpread(_objectSpread({}, obj), {}, {
        children: [],
        label: obj.label,
        showCheckbox: showCheckbox,
        value: obj.id
      });

      if (obj.icon) {
        node.icon = React.createElement(FontAwesomeIcon, {
          className: "rct-icon rct-icon-half-check",
          icon: obj.icon,
          color: obj.color
        });
      } // pega todos os filhos do node


      if (obj.children != null && obj.children.length > 0) {
        addChild(node, obj.children, showCheckbox);
      } // adiciona os fihos no node


      noRaiz.children.push(node);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return noRaiz;
}

var TreeCheckBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState63 = useState([]),
      _useState64 = _slicedToArray(_useState63, 2),
      checkedItens = _useState64[0],
      setCheckedItens = _useState64[1];

  var _useState65 = useState([]),
      _useState66 = _slicedToArray(_useState65, 2),
      expandedItens = _useState66[0],
      setExpandedItens = _useState66[1];

  var _useState67 = useState([]),
      _useState68 = _slicedToArray(_useState67, 2),
      nodes = _useState68[0],
      setNodes = _useState68[1];

  var _useState69 = useState(true),
      _useState70 = _slicedToArray(_useState69, 2),
      marcarTodos = _useState70[0],
      setMarcarTodos = _useState70[1];

  useImperativeHandle(ref, function () {
    return {
      selecionarTodos: function selecionarTodos() {
        if (marcarTodos) {
          var listCheck = [];
          nodes.forEach(function (it) {
            listCheck = listCheck.concat(buscarValue(it));
          });
          setCheckedItens(listCheck);
        } else {
          setCheckedItens([]);
        }

        setMarcarTodos(!marcarTodos);
      }
    };
  });
  useEffect(function () {
    setExpandedItens(props.expanded);
  }, [props.expanded]);
  useEffect(function () {
    setNodes(convertToTree(props.nodeList, props.showCheckbox));
  }, [props.renderTree]);
  useEffect(function () {
    if (props.selectedNodes) {
      props.selectedNodes(props.idTree, checkedItens);
    }
  }, [checkedItens]);
  var onCheck = useCallback(function (value) {
    setCheckedItens(value);
  }, [checkedItens]);
  var onExpand = useCallback(function (value) {
    setExpandedItens(value);
  }, [expandedItens]);

  var onClick = function onClick(targetNode) {
    if (props.getSelectedNode) {
      props.getSelectedNode(targetNode);
    }
  };

  var buscarValue = function buscarValue(noAtual) {
    var listCheck = [];

    if (!isEmpty(noAtual.children) && noAtual.children.length === 0) {
      listCheck = [noAtual.value];
    } else {
      noAtual.children.forEach(function (no) {
        listCheck = listCheck.concat(buscarValue(no));
      });
    }

    return listCheck;
  };

  return React.createElement(CheckboxTree, {
    nodes: nodes,
    checked: checkedItens,
    expanded: expandedItens,
    onCheck: onCheck,
    onExpand: onExpand,
    onClick: onClick,
    disabled: props.disabled,
    nativeCheckboxes: true,
    icons: {
      check: React.createElement(FontAwesomeIcon, {
        className: "rct-icon rct-icon-check",
        icon: "check-square"
      }),
      expandClose: React.createElement(FontAwesomeIcon, {
        className: "rct-icon rct-icon-expand-close",
        icon: "chevron-right"
      }),
      expandOpen: React.createElement(FontAwesomeIcon, {
        className: "rct-icon rct-icon-expand-open",
        icon: "chevron-down"
      }),
      halfCheck: React.createElement(FontAwesomeIcon, {
        className: "rct-icon rct-icon-half-check",
        icon: "check-square"
      }),
      leaf: React.createElement(FontAwesomeIcon, {
        className: "rct-icon rct-icon-leaf-close",
        icon: "file"
      }),
      parentClose: React.createElement(FontAwesomeIcon, {
        className: "rct-icon rct-icon-parent-close",
        icon: "folder"
      }),
      parentOpen: React.createElement(FontAwesomeIcon, {
        className: "rct-icon rct-icon-parent-open",
        icon: "folder-open"
      }),
      uncheck: React.createElement(FontAwesomeIcon, {
        className: "rct-icon rct-icon-uncheck",
        icon: ['fas', 'square']
      })
    }
  });
});

var normalizeReference = function normalizeReference(value) {
  var result = value;

  if (value.length === 7 && value.indexOf('/') === 2) {
    result = value.replace(/\D/g, '').replace(/(\d{2})(\d{4})/g, '$2$1');
  }

  return result;
};

var ActionButton = function ActionButton(props) {
  return React.createElement(Button, {
    className: "dropdown-item",
    onClick: props.onClick
  }, props.label);
};

var EQ = {
  label: 'Igual à (=)',
  value: '='
};
var NE = {
  label: 'Diferente de (!=)',
  value: '!='
};
var GT = {
  label: 'Maior que (>)',
  value: '>'
};
var GE = {
  label: 'Maior ou igual à (>=)',
  value: '>='
};
var LT = {
  label: 'Menor que (<)',
  value: '<'
};
var LE = {
  label: 'Menor ou igual à (<=)',
  value: '<='
};
var COMPARATOR_ENUM_VALUES = [EQ, NE, GT, GE, LT, LE];

var GenericDebounce = function GenericDebounce(props) {
  var debounceRef = useRef();

  var onDebounce = function onDebounce(event) {
    props.onChange(event);
  };

  useEffect(function () {
    debounceRef.current = debounce(onDebounce, props.debounceTimeout || 500);
    return function () {
      return debounceRef.current.flush();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  var onChange = function onChange(event) {
    if (event.persist) {
      event.persist();
    }

    debounceRef.current(event);
  };

  return cloneElement(props.children, {
    onChange: onChange
  });
};

var InputSearchComparator = function InputSearchComparator(props) {
  var _useState71 = useState(EQ.value),
      _useState72 = _slicedToArray(_useState71, 2),
      currentSelection = _useState72[0],
      setCurrentSelection = _useState72[1];

  var _useState73 = useState(false),
      _useState74 = _slicedToArray(_useState73, 2),
      isOpen = _useState74[0],
      setIsOpen = _useState74[1];

  var toggle = function toggle() {
    return setIsOpen(function (p) {
      return !p;
    });
  };

  var changeSelectedItem = function changeSelectedItem(value) {
    return function () {
      setCurrentSelection(value);
      setIsOpen(false);
      props.onChange(value);
    };
  };

  return React.createElement(Dropdown, {
    isOpen: isOpen,
    toggle: toggle,
    "data-testid": "input-search-comparator",
    size: "sm"
  }, React.createElement(UncontrolledTooltip, {
    target: "buttonComparatorSearch-".concat(props.uniqueId),
    placement: "top"
  }, "Clique aqui para selecionar o tipo de comparador a ser utilizado na busca"), React.createElement(DropdownToggle, {
    color: "dark",
    className: "buttonComparatorSearch",
    id: "buttonComparatorSearch-".concat(props.uniqueId)
  }, currentSelection), React.createElement(DropdownMenu, null, COMPARATOR_ENUM_VALUES.map(function (it, index) {
    return React.createElement(Button, {
      key: index,
      className: "dropdown-item",
      onClick: changeSelectedItem(it.value)
    }, it.label);
  })));
};

var DateTimeFix = DateTime;
var InputSearchDate = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState75 = useState(EQ.value),
      _useState76 = _slicedToArray(_useState75, 2),
      currentComparator = _useState76[0],
      setCurrentComparator = _useState76[1];

  var _useState77 = useState(null),
      _useState78 = _slicedToArray(_useState77, 2),
      value = _useState78[0],
      setValue = _useState78[1];

  var maskRef = useRef();
  useEffect(function () {
    if (currentComparator && value) {
      onSearch();
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [currentComparator]);
  useEffect(function () {
    onSearch();
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [value]);

  var onChangeComparator = function onChangeComparator(comparator) {
    return setCurrentComparator(comparator);
  };

  var onChange = function onChange(e) {
    var val = null;

    if (e && typeof e === 'object') {
      var dateValue = e.toDate();
      val = format(dateValue, 'DD/MM/YYYY');
    }

    setValue(val);
  };

  var onSearch = function onSearch() {
    return props.onSearch(value ? {
      comparator: currentComparator,
      value: value
    } : null);
  };

  var renderInput = function renderInput(renderInputProps) {
    var v = renderInputProps.value;

    if (v.replace(/[_/]/g, '').length === 8 && !moment(v, DATE_MONTH_YEAR_PATTERN).isValid()) {
      renderInputProps.value = '';
      setTimeout(function () {
        var node = maskRef.current.getInputDOMNode();
        node.selectionStart = node.selectionEnd = 0;
      }, 50);
    }

    return React.createElement(InputMask, Object.assign({
      mask: "99/99/9999",
      ref: maskRef
    }, renderInputProps, {
      className: "form-control form-control-sm",
      autoComplete: "off"
    }));
  };

  useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        return setValue('');
      }
    };
  });
  return React.createElement("div", {
    className: "rbc-row"
  }, React.createElement(InputSearchComparator, {
    onChange: onChangeComparator,
    uniqueId: props.uniqueId
  }), React.createElement(GenericDebounce, {
    onChange: onChange,
    "data-testid": "input-search-date"
  }, React.createElement(DateTimeFix, {
    className: "form-control filter-date",
    dateFormat: "DD/MM/YYYY",
    timeFormat: false,
    value: value,
    renderInput: renderInput
  })));
});
var InputSearchNumber = /*#__PURE__*/forwardRef(function (props, ref) {
  var comparator = useRef(EQ.value);
  var inputRef = useRef();

  var onChangeComparator = function onChangeComparator(comp) {
    comparator.current = comp;

    if (inputRef.current.value) {
      onChange();
    }
  };

  var onChange = function onChange() {
    props.onSearch({
      comparator: comparator.current,
      value: inputRef.current.value
    });
  };

  useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        inputRef.current.value = '';
        props.onSearch(null);
      }
    };
  });
  return React.createElement("div", {
    className: "rbc-row"
  }, React.createElement(InputSearchComparator, {
    onChange: onChangeComparator,
    uniqueId: props.uniqueId
  }), React.createElement(GenericDebounce, {
    onChange: onChange,
    "data-testid": "input-search-number"
  }, React.createElement(Input, {
    type: "number",
    innerRef: inputRef,
    autoComplete: "off",
    bsSize: "sm"
  })));
});
var InputSearchReference = /*#__PURE__*/forwardRef(function (props, ref) {
  var inputRef = useRef();

  var onChange = function onChange(_ref17) {
    var target = _ref17.target;

    if (target.value) {
      if (parseInt(target.value.substring(0, 2), 10) > 12) {
        target.value = '';
      } else {
        var value = target.value.replace(/\D/g, '').replace(/(\d{2})(\d{4})/g, '$2$1');

        if (value.length === 6 || value.length === 0) {
          props.onSearch(value);
        }
      }
    }
  };

  useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        inputRef.current.setInputValue('__/____');
        props.onSearch('');
      }
    };
  });
  return React.createElement(GenericDebounce, {
    onChange: onChange,
    "data-testid": "input-search-reference"
  }, React.createElement(InputMask, {
    ref: inputRef,
    mask: "99/9999",
    className: "filter text-filter form-control form-control-sm",
    autoComplete: "off"
  }));
});
var InputSearchSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var inputRef = useRef();

  var _useState79 = useState([]),
      _useState80 = _slicedToArray(_useState79, 2),
      options = _useState80[0],
      setOptions = _useState80[1];

  var _useState81 = useState(''),
      _useState82 = _slicedToArray(_useState81, 2),
      placeholder = _useState82[0],
      setPlaceholder = _useState82[1];

  useEffect(function () {
    if (typeof props.column.filter !== 'boolean' && !!props.column.filter.options) {
      setOptions(props.column.filter.options.options);
      setPlaceholder(props.column.filter.options.placeholder || 'Selecione...');
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        inputRef.current.select.clearValue();
        props.onSearch(null);
      }
    };
  });

  var onChange = function onChange(value) {
    if (value) {
      props.onSearch({
        comparator: EQ.value,
        value: value.value
      });
    }
  };

  return React.createElement(Select, {
    ref: inputRef,
    options: options,
    placeholder: placeholder,
    className: "form-control form-control-sm filter-dropdown",
    onChange: onChange,
    "data-testid": "input-search-select"
  });
});
var InputSearchText = /*#__PURE__*/forwardRef(function (props, ref) {
  var inputRef = useRef();

  var onChange = function onChange(e) {
    props.onSearch(e.target.value);
  };

  useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        inputRef.current.value = '';
        props.onSearch('');
      }
    };
  });
  return React.createElement(GenericDebounce, {
    onChange: onChange,
    "data-testid": "input-search-text"
  }, React.createElement(Input, {
    innerRef: inputRef,
    autoComplete: "off",
    bsSize: "sm"
  }));
});
var WIKI_FILTROS = 7933;

var ActionBar = function ActionBar(props) {
  var formProps = useForm({
    mode: 'onBlur'
  });
  var searchRef = useRef();
  var uniqueId = useRef(Math.floor(Math.random() * 10001));
  var history = useHistory();

  var _useState83 = useState(false),
      _useState84 = _slicedToArray(_useState83, 2),
      dropdownOpen = _useState84[0],
      setDropdownOpen = _useState84[1];

  var _useState85 = useState(null),
      _useState86 = _slicedToArray(_useState85, 2),
      searchInput = _useState86[0],
      setSearchInput = _useState86[1];

  var _useState87 = useState(false),
      _useState88 = _slicedToArray(_useState87, 2),
      filtrosAlterados = _useState88[0],
      setFiltrosAlterados = _useState88[1];

  var filtros = props.columns.filter(function (it) {
    return !!it.filter;
  });
  useEffect(function () {
    setTimeout(function () {
      formProps.setValue([_defineProperty({}, "filterCheckTodos---".concat(uniqueId.current), true)].concat(_toConsumableArray(filtros.map(function (it) {
        return _defineProperty({}, "".concat(it.dataField, "---").concat(uniqueId.current), true);
      }))));
      checkSigleFilter();
    }, 500);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  var checkSigleFilter = function checkSigleFilter() {
    var checks = formProps.getValues();
    var selecionados = Object.keys(checks).filter(function (it) {
      return checks[it] && it !== "filterCheckTodos---".concat(uniqueId.current);
    }).map(function (it) {
      return it.replace("---".concat(uniqueId.current), '');
    });

    if (selecionados.length === 1) {
      var item = filtros.find(function (it) {
        return it.dataField === selecionados[0];
      });

      if (item.filter && typeof item.filter !== 'boolean' && item.filter.type) {
        switch (item.filter.type) {
          case FilterType.REFERENCE:
            setSearchInput(React.createElement(InputSearchReference, {
              ref: searchRef,
              onSearch: onChangeSearch,
              uniqueId: uniqueId.current
            }));
            break;

          case FilterType.NUMBER:
            setSearchInput(React.createElement(InputSearchNumber, {
              ref: searchRef,
              onSearch: onChangeSearch,
              uniqueId: uniqueId.current
            }));
            break;

          case FilterType.DATE:
            setSearchInput(React.createElement(InputSearchDate, {
              ref: searchRef,
              onSearch: onChangeSearch,
              uniqueId: uniqueId.current
            }));
            break;

          case FilterType.SELECT:
            setSearchInput(React.createElement(InputSearchSelect, {
              ref: searchRef,
              onSearch: onChangeSearch,
              uniqueId: uniqueId.current,
              column: item
            }));
            break;

          default:
            setSearchInput(null);
            break;
        }
      }
    } else {
      setSearchInput(null);
    }
  };

  var toggleFilter = function toggleFilter() {
    if (dropdownOpen && filtrosAlterados) {
      searchRef.current.clear();
      setFiltrosAlterados(false);
    }

    setDropdownOpen(!dropdownOpen);
  };

  var onChangeTodos = function onChangeTodos(e) {
    formProps.setValue(filtros.map(function (it) {
      return _defineProperty({}, "".concat(it.dataField, "---").concat(uniqueId.current), e.target.checked);
    }));
    checkSigleFilter();
  };

  var onChangeFiltro = function onChangeFiltro() {
    if (!filtrosAlterados) {
      setFiltrosAlterados(true);
    }

    var checks = formProps.getValues();
    var allCheck = Object.keys(checks).filter(function (it) {
      return it !== "filterCheckTodos---".concat(uniqueId.current);
    }).every(function (it) {
      return checks[it];
    });
    formProps.setValue("filterCheckTodos---".concat(uniqueId.current), allCheck);
    checkSigleFilter();
  };

  var onChangeSearch = function onChangeSearch(e) {
    var checks = formProps.getValues();
    var selecionados = Object.keys(checks).filter(function (it) {
      return checks[it] && it !== "filterCheckTodos---".concat(uniqueId.current);
    }).map(function (it) {
      return it.replace("---".concat(uniqueId.current), '');
    });
    props.onSearch(e ? props.columns.filter(function (it) {
      return selecionados.indexOf(it.dataField) !== -1;
    }).map(function (column) {
      var expression = {
        fieldName: column.dataField,
        value: null
      };

      if (typeof e === 'object') {
        expression.comparator = e.comparator;
        expression.value = e.value;
      } else {
        if (column.filter && typeof column.filter === 'object' && column.filter.type === FilterType.REFERENCE) {
          expression.value = normalizeReference(e);
        } else {
          expression.value = e;
        }
      }

      return expression;
    }) : []);
  };

  var onClear = function onClear() {
    searchRef.current.clear();

    if (props.onClear) {
      props.onClear();
    }
  };

  var getExtraContent = function getExtraContent() {
    return typeof props.extraContent === 'function' ? props.extraContent() : props.extraContent;
  };

  var getActions = function getActions() {
    var result = null;
    var actions = typeof props.actions === 'function' ? props.actions() : props.actions;

    if (actions && actions.length > 0) {
      result = React.createElement(UncontrolledDropdown, {
        className: "actions-list",
        size: "sm"
      }, React.createElement(DropdownToggle, {
        color: "dark",
        caret: true
      }, "A\xE7\xF5es"), React.createElement(DropdownMenu, null, actions.map(function (it, index) {
        return React.createElement(ActionButton, Object.assign({}, it, {
          key: index
        }));
      })));
    }

    return result;
  };

  var defaultCancelClick = function defaultCancelClick() {
    return history.push('dashboard');
  };

  var getCancelButton = function getCancelButton() {
    var result = null;
    var cancelProps = props.cancelButtonProps ? props.cancelButtonProps : {
      hideCancelButton: false
    };

    if (!cancelProps.hideCancelButton) {
      result = React.createElement("div", null, React.createElement(UncontrolledTooltip, {
        target: "buttonCustomSearchCancel-".concat(uniqueId.current),
        placement: "bottom"
      }, "Clique aqui para voltar a tela inicial"), React.createElement(Button, Object.assign({
        id: "buttonCustomSearchCancel-".concat(uniqueId.current),
        color: "danger",
        onClick: cancelProps.handleCancelClick || defaultCancelClick,
        size: "sm",
        className: "ml-2 btn-action"
      }, generateTestId('buttonCustomSearchCancel')), React.createElement(FontAwesomeIcon, {
        icon: "times"
      }), " Cancelar"));
    }

    return result;
  };

  var onClickSearch = function onClickSearch(event) {
    return event.preventDefault();
  };

  var prevent = function prevent(e) {
    return e.preventDefault();
  };

  return React.createElement(Row, null, React.createElement(Col, {
    className: "action-bar d-flex flex-wrap w-100 justify-content-between"
  }, React.createElement("div", {
    className: "action-bar-search-box"
  }, React.createElement(InputGroup, {
    className: "action-bar-search float-left",
    size: "sm"
  }, React.createElement(InputGroupAddon, {
    addonType: "prepend"
  }, React.createElement(Button, {
    color: "first",
    onClick: onClickSearch,
    style: {
      cursor: 'default'
    },
    className: "disabled-e"
  }, React.createElement(FontAwesomeIcon, {
    icon: "search"
  }))), React.createElement(Form, {
    autoComplete: "off",
    onSubmit: prevent,
    className: "form-control p-0 border-0"
  }, searchInput || React.createElement(InputSearchText, {
    ref: searchRef,
    onSearch: onChangeSearch
  })), filtros.length > 0 && React.createElement(InputGroupAddon, {
    addonType: "append"
  }, React.createElement(Dropdown, {
    isOpen: dropdownOpen,
    toggle: toggleFilter,
    size: "sm"
  }, React.createElement(UncontrolledTooltip, {
    target: "buttonFilterSearch-".concat(uniqueId.current),
    placement: "top"
  }, "Clique aqui para selecionar os campos que ser\xE3o filtrados"), React.createElement(DropdownToggle, Object.assign({
    color: "primary",
    className: "buttonFilterSearch",
    id: "buttonFilterSearch-".concat(uniqueId.current)
  }, generateTestId('buttonFilterSearch')), React.createElement(FontAwesomeIcon, {
    icon: "filter"
  })), React.createElement(DropdownMenu, {
    right: true,
    persist: true,
    style: {
      padding: 10,
      width: 230,
      zIndex: 2000
    },
    container: "body"
  }, filtros.length > 1 && React.createElement(Row, null, React.createElement(Col, null, React.createElement(Checkbox, {
    formProps: formProps,
    label: "Todos",
    id: "filterCheckTodos---".concat(uniqueId.current),
    onChange: onChangeTodos
  }), React.createElement("div", {
    className: "float-right",
    style: {
      marginTop: 1
    }
  }, React.createElement(WikiButton, {
    pageId: WIKI_FILTROS,
    small: true
  })))), filtros.map(function (it, index) {
    return React.createElement(Row, {
      style: {
        paddingTop: 10
      },
      key: index
    }, React.createElement(Col, null, React.createElement(Checkbox, {
      formProps: formProps,
      label: it.text,
      id: "".concat(it.dataField, "---").concat(uniqueId.current),
      onChange: onChangeFiltro
    })));
  })))), React.createElement(InputGroupAddon, {
    addonType: "append"
  }, React.createElement(UncontrolledTooltip, {
    target: "buttonCustomSearchClear-".concat(uniqueId.current),
    placement: "bottom"
  }, "Clique aqui para limpar a pesquisa"), React.createElement(Button, Object.assign({
    id: "buttonCustomSearchClear-".concat(uniqueId.current),
    className: "buttonCustomSearchClear",
    color: "warning",
    onClick: onClear,
    size: "sm"
  }, generateTestId('buttonCustomSearchClear')), React.createElement(FontAwesomeIcon, {
    icon: "eraser"
  })))), React.createElement("div", {
    className: cx('d-inline-block', {
      'float-right': props.extraContentRight
    })
  }, getExtraContent())), (!!props.actions || !props.hideAddButton) && React.createElement("div", {
    className: "action-buttons col d-inline-block pl-0 pr-0"
  }, React.createElement("div", {
    className: "d-flex justify-content-end"
  }, getActions(), props.hideAddButton !== true && React.createElement("div", null, React.createElement(UncontrolledTooltip, {
    target: "buttonCustomSearchAdd-".concat(uniqueId.current),
    placement: "bottom"
  }, "Clique aqui para incluir um novo registro"), React.createElement(Button, Object.assign({
    id: "buttonCustomSearchAdd-".concat(uniqueId.current),
    color: "success",
    onClick: props.onAddClick,
    size: "sm",
    className: "ml-2 btn-action"
  }, generateTestId('buttonCustomSearchAdd')), React.createElement(FontAwesomeIcon, {
    icon: "plus"
  }), " Incluir")), props.isModal ? null : getCancelButton()))));
};

var AutoCompleteOff = function AutoCompleteOff(props) {
  var prevent = function prevent(e) {
    return e.preventDefault();
  };

  return React.createElement(Form, {
    onSubmit: prevent,
    autoComplete: "off"
  }, props.children);
};

var ALL = {
  label: 'Todos os Registros',
  value: 'ALL'
};
var PAGE = {
  label: 'Página Atual',
  value: 'PAGE'
};
var EXPORT_TYPE_ENUM_VALUES = [ALL, PAGE];
var LINE_BREAK = '\r\n';

var toCSV = function toCSV(data) {
  var header = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ';';
  var strHeader = "".concat(header.join(separator)).concat(header.length ? LINE_BREAK : '');
  var strBody = data.map(function (it) {
    return it.map(function (s) {
      return "\"".concat((s === null ? '' : s).toString().replace(/[\\"]/g, '""'), "\"");
    }).join(separator);
  }).join(LINE_BREAK);
  return new Blob([strHeader, strBody], {
    type: 'application/csv;charset-utf-8'
  });
};

var saveToCSV = function saveToCSV(data) {
  var header = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var separator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ';';
  var filename = name || "".concat(moment().format('DD.MM.YYYY-HH.mm'), ".csv");
  var blob = toCSV(data, header, separator);
  saveAs(blob, filename);
};

var saveToXLS = function saveToXLS(data) {
  var header = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var filename = name || "".concat(moment().format('DD.MM.YYYY-HH.mm'), ".xlsx");
  var book = XLSX.utils.book_new();
  var sheet = XLSX.utils.aoa_to_sheet([header].concat(_toConsumableArray(data)));
  XLSX.utils.book_append_sheet(book, sheet, filename);
  XLSX.writeFile(book, filename, {
    type: 'binary',
    bookType: 'xlsx'
  });
};

var GridDataExport = function GridDataExport(props) {
  var formProps = useForm({
    defaultValues: {
      formato: CSV.value,
      tipo: ALL.value
    },
    mode: 'onBlur'
  });
  var uniqueId = useRef(Math.floor(Math.random() * 10001));

  var _useState89 = useState(false),
      _useState90 = _slicedToArray(_useState89, 2),
      isOpen = _useState90[0],
      setIsOpen = _useState90[1];

  var _useState91 = useState(props.columns),
      _useState92 = _slicedToArray(_useState91, 2),
      selection = _useState92[0],
      setSelection = _useState92[1];

  useEffect(function () {
    return setSelection(props.columns);
  }, [props.columns]);

  var toggle = function toggle() {
    return setIsOpen(false);
  };

  var open = function open() {
    return setIsOpen(true);
  };

  var onSelection = function onSelection(list) {
    return setSelection(list);
  };

  var getContent = function getContent(column, row, rowIndex) {
    var result = getObjectSubValue(row, column.dataField);

    if (!!column.formatter) {
      result = column.formatter(result, row, rowIndex, column.formatExtraData);
    }

    if (isValidElement(result)) {
      result = result.props.children;
    }

    return result;
  };

  var buildData = function buildData(content) {
    var selected = selection.map(function (it) {
      return it.dataField;
    });
    var cols = props.columns.filter(function (it) {
      return selected.indexOf(it.dataField) !== -1;
    });
    return {
      body: content.map(function (item) {
        return cols.map(function (it, index) {
          return getContent(it, item, index);
        });
      }),
      header: cols.map(function (it) {
        return it.text;
      })
    };
  };

  var onSubmit = function onSubmit() {
    return new Promise(function (resolve) {
      if (selection.length) {
        var _formProps$getValues = formProps.getValues(),
            tipo = _formProps$getValues.tipo,
            formato = _formProps$getValues.formato;

        findAllByExpression(tipo === ALL.value ? _objectSpread(_objectSpread({}, props.criteria), {}, {
          fetchType: 'ALL',
          start: 0
        }) : props.criteria, {
          errorFunction: function errorFunction(mensagem) {
            showToast(mensagem, ERROR);
            resolve(false);
          },
          thenFunction: function thenFunction(res) {
            resolve(true);

            var _buildData = buildData(res.content),
                header = _buildData.header,
                body = _buildData.body;

            if (formato === CSV.value) {
              saveToCSV(body, header);
            } else if (formato === EXCEL.value) {
              saveToXLS(body, header);
            }
          }
        });
      } else {
        alertManager.emit(ACTION_EVENTS.SHOW, {
          message: 'Selecione as columas que dever ser exportadas.',
          type: AlertType.INFORMATION
        });
        resolve(false);
      }
    });
  };

  var handleSubmit = function handleSubmit() {
    try {
      return Promise.resolve(onSubmit()).then(function (_onSubmit) {
        if (_onSubmit) {
          toggle();
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var columns = [{
    dataField: 'text',
    text: 'Campo'
  }];
  return React.createElement("div", {
    className: "grid-export"
  }, React.createElement(Modal, {
    isOpen: isOpen,
    backdrop: "static",
    size: "md",
    toggle: toggle,
    centered: true,
    className: "grid-export-modal"
  }, React.createElement(ModalHeader, {
    toggle: toggle
  }, "Exportar Dados"), React.createElement(ModalBody, null, React.createElement(Row, null, React.createElement(Col, null, React.createElement(InputGroupInline, {
    id: "tipo",
    label: "Exportar:",
    formProps: formProps,
    inputDropDownProps: {
      optionsProvider: EXPORT_TYPE_ENUM_VALUES,
      selectProps: {
        isClearable: false
      }
    },
    type: InputType.DROP_DOWN
  })), React.createElement(Col, null, React.createElement(InputGroupInline, {
    id: "formato",
    label: "Formato:",
    formProps: formProps,
    inputDropDownProps: {
      optionsProvider: [CSV, EXCEL],
      selectProps: {
        isClearable: false
      }
    },
    type: InputType.DROP_DOWN
  }))), React.createElement(Row, {
    className: "mt-2"
  }, React.createElement(Col, null, React.createElement(Label, null, "Selecione os campos a serem exportados:"), React.createElement(GridTable, {
    columns: columns,
    data: props.columns,
    keyField: "dataField",
    multiple: true,
    selection: selection,
    onSelection: onSelection,
    onSelectAll: onSelection
  })))), React.createElement(ModalFooter, null, React.createElement(ProcessBar, {
    handleClose: toggle,
    handleSubmit: handleSubmit,
    btnSubmitLabel: "Exportar",
    btnSubmitIcon: "download"
  }))), React.createElement(Button, {
    className: "export",
    id: "btn-export-".concat(uniqueId.current),
    onClick: open
  }, React.createElement(FontAwesomeIcon, {
    icon: faFileDownload
  })), React.createElement(UncontrolledTooltip, {
    target: "btn-export-".concat(uniqueId.current),
    placement: "left"
  }, "Exportar dados"));
};

var GridPagination = function GridPagination(props) {
  var commonPaginationProps = {
    current: props.current,
    locale: localeInfo,
    onChange: props.onChange,
    pageSize: props.pageSize,
    total: props.total
  };
  var paginationProps = props.onChangePageSize ? {
    onShowSizeChange: props.onChangePageSize,
    selectComponentClass: Select$1,
    showSizeChanger: true
  } : {}; // @ts-ignore

  var pagination = React.createElement(Pagination, Object.assign({}, commonPaginationProps, paginationProps, {
    showQuickJumper: true
  }));
  return React.createElement(AutoCompleteOff, null, React.createElement("div", {
    className: "grid-pagination-mobile"
  }, React.createElement("div", {
    className: "p-2 rounded bg-secondary d-flex justify-content-center align-items-center flex-column"
  }, React.createElement(Pagination, Object.assign({}, commonPaginationProps, {
    showLessItems: true
  })), props.showMobileTotalCount && React.createElement("div", {
    className: "mt-2"
  }, "Registros: ", props.total))), !props.onlyMobile && React.createElement("div", {
    className: "grid-pagination-desktop"
  }, React.createElement("div", {
    className: "px-3 py-1 rounded bg-secondary d-flex justify-content-center align-items-center position-relative"
  }, React.createElement("div", {
    className: "num-registros"
  }, "Registros: ", props.total), pagination, props.gridExportProps && React.createElement(GridDataExport, Object.assign({}, props.gridExportProps)))));
};

var ChangeType;

(function (ChangeType) {
  ChangeType[ChangeType["SEARCH_EXPRESSION"] = 1] = "SEARCH_EXPRESSION";
})(ChangeType || (ChangeType = {}));

var ModalConfirmationView = function ModalConfirmationView(props) {
  var toggle = function toggle() {
    return props.done(false);
  };

  return React.createElement(Modal, {
    centered: true,
    backdrop: "static",
    isOpen: true,
    toggle: toggle
  }, React.createElement(ModalHeader, {
    toggle: toggle
  }, props.title), React.createElement(ModalBody, null, React.createElement(props.confirmationView, {
    selectedItem: props.selectedItem,
    done: props.done
  })));
};

var ActionColumn = function ActionColumn(props) {
  var _useState93 = useState(false),
      _useState94 = _slicedToArray(_useState93, 2),
      isEditing = _useState94[0],
      setIsEditing = _useState94[1];

  var _useState95 = useState(false),
      _useState96 = _slicedToArray(_useState95, 2),
      isRemoving = _useState96[0],
      setIsRemoving = _useState96[1];

  var _useState97 = useState(null),
      _useState98 = _slicedToArray(_useState97, 2),
      confirmationView = _useState98[0],
      setConfirmationView = _useState98[1];

  var onRemoveSuccess = function onRemoveSuccess() {
    setIsRemoving(false);
    showToast(REGISTRO_EXCLUIDO_COM_SUCESSO_MSG, SUCCESS);
    props.editProps.refreshFunc();

    if (props.editProps.afterRemove) {
      props.editProps.afterRemove();
    }
  };

  var onRemoveError = function onRemoveError(message) {
    setIsRemoving(false);
    showToast(message, ERROR);
  };

  var onRemoveCancel = function onRemoveCancel() {
    return setIsRemoving(false);
  };

  var removeCallback = function removeCallback(success) {
    setConfirmationView(null);

    if (success) {
      if (props.editProps.customRemove) {
        props.editProps.customRemove(props.record, onRemoveSuccess, onRemoveError, onRemoveCancel);
      } else {
        remove(props.record, props.editProps.dtoClassName, {
          errorFunction: function errorFunction(mensagem) {
            return onRemoveError(mensagem);
          },
          thenFunction: function thenFunction() {
            return onRemoveSuccess();
          }
        });
      }
    } else {
      onRemoveCancel();
    }
  };

  var editCallback = function editCallback(success) {
    setConfirmationView(null);

    if (success) {
      props.viewToModal.openEdit(props.record, function () {
        return setIsEditing(false);
      });
    } else {
      setIsEditing(false);
    }
  };

  var execRemove = function execRemove() {
    setIsRemoving(true);

    if (props.editProps.removeConfirmationView) {
      setConfirmationView(React.createElement(ModalConfirmationView, {
        title: "Confirmar Remo\xE7\xE3o",
        confirmationView: props.editProps.removeConfirmationView,
        selectedItem: props.record,
        done: removeCallback
      }));
    } else {
      alertManager.emit(ACTION_EVENTS.SHOW, {
        message: DEFAULT_DELETE_SELECTED_ITEM_MSG,
        onNoClick: function onNoClick() {
          return onRemoveCancel();
        },
        onOkClick: function onOkClick() {
          return removeCallback(true);
        },
        type: AlertType.WARNING_YES_NO
      });
    }
  };

  var onRemoveClick = function onRemoveClick() {
    if (props.editProps.beforeRemove) {
      var beforeRemoveResult = props.editProps.beforeRemove(props.record, execRemove);

      if (!beforeRemoveResult || !beforeRemoveResult.async) {
        execRemove();
      }
    } else {
      execRemove();
    }
  };

  function onEditClick() {
    setIsEditing(true);

    if (props.editProps.editConfirmationView) {
      setConfirmationView(React.createElement(ModalConfirmationView, {
        title: "Confirmar Edi\xE7\xE3o",
        confirmationView: props.editProps.editConfirmationView,
        selectedItem: props.record,
        done: editCallback
      }));
    } else {
      editCallback(true);
    }
  }

  var checkHide = function checkHide(param) {
    var result = param;

    if (typeof param === 'function') {
      result = param(props.record);
    }

    return !result;
  };

  var editId = "actionColumnEditButton-".concat(props.index);
  var removeId = "actionColumnRemoveButton-".concat(props.index);
  return React.createElement("div", {
    className: "text-center",
    style: {
      width: 65
    }
  }, confirmationView, props.editProps && checkHide(props.editProps.hideEditButton) && React.createElement(React.Fragment, null, React.createElement(UncontrolledTooltip, {
    target: editId,
    placement: "bottom-start"
  }, "Clique aqui para alterar"), React.createElement(Button, Object.assign({
    size: "sm",
    color: "link",
    className: "p-0 d-30 text-warning",
    id: editId,
    onClick: onEditClick,
    disabled: isEditing
  }, generateTestId(editId)), React.createElement(FontAwesomeIcon, {
    icon: ['fas', 'pencil-alt']
  }))), props.editProps && checkHide(props.editProps.hideRemoveButton) && React.createElement(React.Fragment, null, React.createElement(UncontrolledTooltip, {
    target: removeId,
    placement: "bottom-start"
  }, "Clique aqui para remover"), React.createElement(Button, Object.assign({
    size: "sm",
    color: "link",
    className: "p-0 d-30 text-danger",
    id: removeId,
    onClick: onRemoveClick,
    disabled: isRemoving
  }, generateTestId(removeId)), React.createElement(FontAwesomeIcon, {
    icon: ['fas', 'times']
  }))));
};

function enumColumn(props, enumType) {
  var result = _objectSpread(_objectSpread({}, props), {}, {
    formatExtraData: enumType,
    formatter: enumFormatter
  });

  if (typeof result.filter === 'boolean') {
    result.filter = {
      options: {
        options: enumType
      },
      type: FilterType.SELECT
    };
  } else if (result.filter) {
    result.filter = _objectSpread(_objectSpread({}, result.filter), {}, {
      options: {
        options: enumType
      }
    });
  }

  return result;
}

function boolColumn(props) {
  var result = _objectSpread(_objectSpread({}, props), {}, {
    formatter: boolFormatter
  });

  if (typeof result.filter === 'boolean' && result.filter) {
    result.filter = {
      options: {
        options: booleanOptionList()
      },
      type: FilterType.SELECT
    };
  }

  return result;
}

function currencyColumn(props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    formatter: currencyFomatter
  });
}

function referenceColumn(props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    filter: {
      type: FilterType.REFERENCE
    },
    formatter: referenceFormatter
  });
}

function decimalColumn(props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    filter: {
      type: FilterType.NUMBER
    },
    formatter: decimalFormatter
  });
}

function dateColumn(props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    filter: {
      type: FilterType.DATE
    },
    formatter: function formatter(cell) {
      return React.createElement("span", {
        style: {
          display: 'block',
          minWidth: 65
        }
      }, cell);
    }
  });
}

var actionColumn = function actionColumn(extraData, viewToModal) {
  return {
    classes: 'col-body-acoes',
    dataField: 'actionColumn',
    formatExtraData: extraData,
    formatter: function formatter(_, row, rowIndex, formatExtraData) {
      return React.createElement(ActionColumn, {
        index: rowIndex,
        record: row,
        editProps: formatExtraData,
        viewToModal: viewToModal
      });
    },
    headerCardClasses: 'col-header-acoes',
    headerStyle: {
      width: 80
    },
    text: 'Ações'
  };
};

function getExtraData(props, editViewId, dtoClassName) {
  var customExtraData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var extraData = _objectSpread(_objectSpread(_objectSpread({}, props), customExtraData), {}, {
    editViewId: editViewId,
    dtoClassName: dtoClassName
  });

  if (props.searchDataGridProps) {
    extraData = _objectSpread(_objectSpread({}, extraData), props.searchDataGridProps.extraData);
  }

  return extraData;
}

var ViewToModal = /*#__PURE__*/forwardRef(function (props, ref) {
  var history = useHistory();

  var _useState99 = useState(false),
      _useState100 = _slicedToArray(_useState99, 2),
      renderView = _useState100[0],
      setRenderView = _useState100[1];

  var _useState101 = useState(null),
      _useState102 = _slicedToArray(_useState101, 2),
      selectedItem = _useState102[0],
      setSelectedItem = _useState102[1];

  useImperativeHandle(ref, function () {
    return {
      openAdd: function openAdd() {
        if (props.extraData.isModal) {
          showModal();
        } else {
          openView(null);
        }
      },
      openEdit: function openEdit(record, onFinishLock) {
        if (props.useFindByExample) {
          findByExample(record, props.extraData.dtoClassName, {
            errorFunction: function errorFunction(mensagem) {
              onFinishLock();
              showToast(mensagem, ERROR);
            },
            thenFunction: function thenFunction(result) {
              onFinishLock();

              if (props.extraData.isModal) {
                showModal(result);
              } else {
                openView(result);
              }
            }
          });
        } else {
          findById(record, props.extraData.dtoClassName, {
            errorFunction: function errorFunction(mensagem) {
              onFinishLock();
              showToast(mensagem, ERROR);
            },
            thenFunction: function thenFunction(result) {
              onFinishLock();

              if (props.extraData.isModal) {
                showModal(result);
              } else {
                openView(result);
              }
            }
          });
        }
      }
    };
  });

  var showModal = function showModal() {
    var dataGridItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    gaModalView(history.location.pathname);
    setSelectedItem(dataGridItem);
    setRenderView(true);
  };

  var openView = function openView(selected) {
    return openChildView({
      dtoClassName: props.extraData.dtoClassName,
      editViewId: props.extraData.editViewId,
      selectedItem: selected,
      title: props.extraData.title,
      usuario: props.extraData.usuario,
      viewId: props.extraData.viewId
    }, history);
  };

  var onHide = function onHide() {
    setSelectedItem(null);
    setRenderView(false);
    props.refreshFunc();
  };

  return React.createElement(React.Fragment, null, renderView && React.createElement(EditViewModal, Object.assign({
    key: "editViewModal",
    editViewId: props.extraData.editViewId,
    modalProps: {
      backdrop: 'static',
      isOpen: true,
      size: props.extraData.size,
      toggle: onHide
    },
    selectedItem: selectedItem
  }, props.parentProps, generateTestId("searchview-edit-modal-".concat(props.extraData.dtoClassName)))));
});
/* eslint-disable react-hooks/exhaustive-deps */

var SearchDataGridNew = /*#__PURE__*/forwardRef(function (props, ref) {
  var isMounted = useRef(false);
  var isViaDTO = useRef(true);
  var viewToModal = useRef();
  var canFind = useRef(props.findOnRender !== false);
  var keyField = props.keyField || 'id';

  var _useState103 = useState(props.columns),
      _useState104 = _slicedToArray(_useState103, 2),
      columns = _useState104[0],
      setColumns = _useState104[1];

  var _useState105 = useState([]),
      _useState106 = _slicedToArray(_useState105, 2),
      data = _useState106[0],
      setData = _useState106[1];

  var _useState107 = useState([]),
      _useState108 = _slicedToArray(_useState107, 2),
      rawData = _useState108[0],
      setRawData = _useState108[1];

  var _useState109 = useState([]),
      _useState110 = _slicedToArray(_useState109, 2),
      selection = _useState110[0],
      setSelection = _useState110[1];

  var _useState111 = useState(null),
      _useState112 = _slicedToArray(_useState111, 2),
      searchCriteria = _useState112[0],
      setSearchCriteria = _useState112[1];

  var _useState113 = useState(false),
      _useState114 = _slicedToArray(_useState113, 2),
      filtrouDefault = _useState114[0],
      setFiltrouDefault = _useState114[1];

  var _useState115 = useState({
    page: 1,
    sizePerPage: props.sizePerPage || 20,
    totalSize: data.length
  }),
      _useState116 = _slicedToArray(_useState115, 2),
      pagination = _useState116[0],
      setPagination = _useState116[1];

  useEffect(function () {
    isMounted.current = true;
    isViaDTO.current = !!props.dtoClassName;

    if (!!props.dtoClassName) {
      var criteria = {
        className: props.dtoClassName,
        expressions: buildExpressions(),
        fetchType: 'PAGED',
        max: pagination.sizePerPage,
        start: 0
      };

      if (props.defaultSorted && props.defaultSorted.length > 0) {
        criteria.sortDescending = props.defaultSorted[0].order === OrderType.DESC;
        criteria.sortFieldName = props.defaultSorted[0].dataField;
        criteria.disableNaturalSort = props.defaultSorted[0].disableNaturalSort || false;
      }

      setSearchCriteria(criteria);
    }

    if (!props.extraData || !props.extraData.hideActionColumn) {
      setColumns(function (p) {
        return [].concat(_toConsumableArray(p), [actionColumn(_objectSpread(_objectSpread({}, props.extraData), {}, {
          refreshFunc: refreshFunc
        }), viewToModal.current)]);
      });
    }

    return function () {
      return isMounted.current = false;
    };
  }, []);
  useEffect(function () {
    var newColumns = _toConsumableArray(props.columns);

    if (props.columns.find(function (it) {
      return it.dataField === 'actionColumn';
    }) === undefined && (!props.extraData || !props.extraData.hideActionColumn)) {
      newColumns.push(actionColumn(_objectSpread(_objectSpread({}, props.extraData), {}, {
        refreshFunc: refreshFunc
      }), viewToModal.current));
    }

    setColumns(newColumns);
  }, [props.columns]);
  useEffect(function () {
    if (!!props.data && Array.isArray(props.data) && !isViaDTO.current) {
      setRawData(props.data);
      loadDataViaProp(props.data, 1);
    }
  }, [props.data]);
  useEffect(function () {
    if (canFind.current) {
      findAll();
    }
  }, [searchCriteria]);
  useEffect(function () {
    if (props.selectRow && props.selectRow.onSelect) {
      props.selectRow.onSelect(selection, true, -1, 'setFromNew');
    }
  }, [selection]);
  useEffect(function () {
    if (props.selectRow && props.selectRow.selected && props.selectRow.selected.length > 0) {
      var exp = {
        className: props.dtoClassName,
        expressions: adjustExpressions([{
          fieldName: keyField,
          operation: OperationEnum.NUMBER_IN,
          value: props.selectRow.selected
        }]),
        fetchType: 'ALL',
        max: 0,
        start: 0
      };
      findAllByExpression(exp, {
        thenFunction: function thenFunction(res) {
          return setSelection(res.content);
        }
      });
    }
  }, [props.selectRow]);
  useImperativeHandle(ref, function () {
    return {
      goTo: onChangePagination,
      notifyChange: function notifyChange(type) {
        if (type === ChangeType.SEARCH_EXPRESSION) {
          if (!canFind.current) {
            canFind.current = true;
          }

          refreshFunc();
        }
      },
      openAddView: onAddHandler
    };
  });

  var refreshFunc = function refreshFunc() {
    setSearchCriteria(function (p) {
      return _objectSpread(_objectSpread({}, p), {}, {
        expressions: buildExpressions()
      });
    });
    setSelection([]);
  };

  var findAll = function findAll() {
    if (searchCriteria && searchCriteria.expressions) {
      var expressions = searchCriteria.expressions;

      if (props.searchExpressionsFull) {
        expressions = props.searchExpressionsFull(searchCriteria.expressions).map(function (it) {
          if (isEmpty(it.conditionalGroup)) {
            it.conditionalGroup = 'searchExpressionsFull';
          }

          return it;
        });
      }

      searchCriteria.expressions = adjustExpressions(expressions);
      findAllByExpression(searchCriteria, {
        errorFunction: function errorFunction(mensagem) {
          showToast(mensagem, ERROR);
        },
        thenFunction: function thenFunction(result) {
          if (isMounted.current) {
            afterSearch(result);
          }
        }
      });
    }
  };

  var afterSearch = function afterSearch(result) {
    setPagination(function (state) {
      return {
        page: result.start / state.sizePerPage + 1,
        sizePerPage: result.max,
        totalSize: result.total
      };
    });
    setData(result.content);

    if (props.extraData && props.extraData.isModal) {
      updateSelectedItem(result.content);
    }

    if (props.onAfterSearch) {
      props.onAfterSearch();
    }
  };

  var buildExpressions = function buildExpressions() {
    var expressions = [];

    if (props.searchExpressions) {
      props.searchExpressions().forEach(function (exp) {
        if (isEmpty(exp.conditionalGroup)) {
          exp.conditionalGroup = 'searchExpressions';
        }

        expressions.push(exp);
      });
    }

    if (!filtrouDefault && (!props.extraData || !props.extraData.isModal)) {
      setFiltrouDefault(true);

      if (props.defaultSearchExpressions) {
        props.defaultSearchExpressions().forEach(function (exp) {
          if (isEmpty(exp.conditionalGroup)) {
            exp.conditionalGroup = 'defaultSearchExpressions';
          }

          expressions.push(exp);
        });
      }
    }

    return expressions;
  };

  var loadDataViaProp = function loadDataViaProp(records, page) {
    var sizePerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : pagination.sizePerPage;
    var offset = sizePerPage * (page - 1);
    setPagination(function (p) {
      return _objectSpread(_objectSpread({}, p), {}, {
        page: page,
        totalSize: records.length
      });
    });
    setData(Array.from(Array(sizePerPage), function (_, index) {
      return records[offset + index];
    }).filter(function (it) {
      return it;
    }));
  };

  var updateSelectedItem = function updateSelectedItem(records) {
    if (props.selectRow && props.selectRow.selected && props.selectRow.selected.length > 0 && props.selectRow.onSelect) {
      var selected = props.selectRow.selected.map(function (id) {
        return records.find(function (it) {
          return it[keyField] === id;
        });
      }).filter(function (it) {
        return it !== undefined;
      });
      props.selectRow.onSelect(selected, true, -1, 'forceUpdate');
    }
  };

  var onSelection = function onSelection(items) {
    return setSelection(items);
  };

  var onSelectAll = function onSelectAll(items) {
    return setSelection(items);
  };

  var onSort = function onSort(state) {
    if (isViaDTO.current) {
      setSearchCriteria(function (p) {
        return _objectSpread(_objectSpread({}, p), {}, {
          disableNaturalSort: state.column.disableNaturalSort || false,
          sortDescending: state.direction === SortDirection.DESC,
          sortFieldName: state.column.dataField
        });
      });
    } else {
      setRawData(function (p) {
        var result = _toConsumableArray(p);

        result.sort(function (a, b) {
          var valA = valToString(getObjectSubValue(a, state.column.dataField));
          var valB = valToString(getObjectSubValue(b, state.column.dataField));
          return valA.localeCompare(valB, undefined, {
            numeric: true
          }) * (state.direction === SortDirection.DESC ? -1 : 1);
        });
        loadDataViaProp(result, pagination.page);
        return result;
      });
    }
  };

  var onChangePagination = function onChangePagination(page) {
    setPagination(function (p) {
      return _objectSpread(_objectSpread({}, p), {}, {
        page: page
      });
    });

    if (isViaDTO.current) {
      setSearchCriteria(function (p) {
        return _objectSpread(_objectSpread({}, p), {}, {
          start: pagination.sizePerPage * (page - 1)
        });
      });
    } else {
      loadDataViaProp(rawData, page);
    }
  };

  var onChangePaginationSize = function onChangePaginationSize(_, sizePerPage) {
    setTimeout(function () {
      return setPagination(function (p) {
        return _objectSpread(_objectSpread({}, p), {}, {
          page: 1,
          sizePerPage: sizePerPage
        });
      });
    }, 500);

    if (isViaDTO.current) {
      setSearchCriteria(function (p) {
        return _objectSpread(_objectSpread({}, p), {}, {
          start: 0,
          max: sizePerPage
        });
      });
    } else {
      loadDataViaProp(rawData, 1, sizePerPage);
    }
  };

  var normalize = function normalize(val) {
    return val.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  };

  var onSearch = function onSearch(expressions) {
    if (isViaDTO.current) {
      setPagination(function (p) {
        return _objectSpread(_objectSpread({}, p), {}, {
          page: 1
        });
      });
      setSearchCriteria(function (p) {
        return _objectSpread(_objectSpread({}, p), {}, {
          start: 0,
          expressions: [].concat(_toConsumableArray(buildExpressions()), _toConsumableArray(expressions))
        });
      });
    } else {
      if (expressions.length) {
        setRawData(function (p) {
          var filtered = p.filter(function (it) {
            var result = false;
            expressions.forEach(function (expression) {
              if (!result) {
                var cmp = expression.value.toString();
                var value = getObjectSubValue(it, expression.fieldName).toString();

                if (expression.comparator) {
                  switch (expression.comparator) {
                    case ComparatorEnum.EQ:
                      result = value.toLowerCase() === cmp.toLowerCase();
                      break;

                    case ComparatorEnum.GT:
                      result = value.localeCompare(cmp) > 0;
                      break;

                    case ComparatorEnum.GE:
                      result = value.localeCompare(cmp) >= 0;
                      break;

                    case ComparatorEnum.LT:
                      result = value.localeCompare(cmp) < 0;
                      break;

                    case ComparatorEnum.LE:
                      result = value.localeCompare(cmp) <= 0;
                      break;
                  }
                } else {
                  result = normalize(value).indexOf(normalize(cmp)) !== -1;
                }
              }
            });
            return result;
          });
          loadDataViaProp(filtered, 1);
          return filtered;
        });
      } else {
        setRawData(props.data);
        loadDataViaProp(props.data, 1);
      }
    }
  };

  var onAddHandler = function onAddHandler() {
    if (viewToModal && viewToModal.current) {
      viewToModal.current.openAdd();
    }
  };

  var onDoubleClick = function onDoubleClick(item) {
    if (viewToModal && viewToModal.current) {
      if (props.extraData.isModal) {
        setSelection([item]);
        props.selectRow.onSelect([item], true, -1, 'forceUpdate');
        props.onSelect();
      } else {
        viewToModal.current.openEdit(item, function () {
          return null;
        });
      }
    }
  };

  var getCustomHeaderContent = function getCustomHeaderContent() {
    return typeof props.customHeaderContent === 'function' ? props.customHeaderContent() : props.customHeaderContent;
  };

  var getCustomFooterContent = function getCustomFooterContent() {
    return typeof props.customFooterContent === 'function' ? props.customFooterContent() : props.customFooterContent;
  };

  return React.createElement("div", {
    className: "grid-wrapper"
  }, !props.hideActionBar && React.createElement(ActionBar, {
    columns: props.columns,
    onSearch: onSearch,
    actions: props.actionButtons,
    onAddClick: onAddHandler,
    extraContent: props.actionBarExtraContent,
    extraContentRight: props.actionBarExtraContentRight,
    hideAddButton: props.addButtonProps && props.addButtonProps.hideAddButton,
    cancelButtonProps: props.cancelButtonProps,
    isModal: props.extraData && props.extraData.isModal,
    onClear: props.onSearchClean
  }), getCustomHeaderContent() || '', React.createElement(GridPagination, {
    onlyMobile: true,
    pageSize: pagination.sizePerPage,
    current: pagination.page,
    total: pagination.totalSize,
    onChange: onChangePagination,
    onChangePageSize: onChangePaginationSize
  }), React.createElement(GridTable, {
    columns: columns,
    data: data,
    onSort: onSort,
    keyField: props.keyField,
    onSelection: onSelection,
    onSelectAll: onSelectAll,
    selection: selection,
    rowClasses: props.rowClasses,
    headerClasses: props.headerClasses,
    multiple: props.selectRow && props.selectRow.mode === 'checkbox',
    multipleViaHotKey: props.selectRow && props.selectRow.multipleViaHotKey,
    onDoubleClick: props.disableDoubleClick ? null : onDoubleClick,
    extraIgnoredSpacing: props.extraIgnoredSpacing,
    limitGridHeight: true
  }), React.createElement(GridPagination, {
    pageSize: pagination.sizePerPage,
    current: pagination.page,
    total: pagination.totalSize,
    onChange: onChangePagination,
    onChangePageSize: onChangePaginationSize,
    showMobileTotalCount: true,
    gridExportProps: props.hideExportFromGrid || !isViaDTO.current ? null : {
      columns: props.columns,
      criteria: searchCriteria
    }
  }), getCustomFooterContent() || '', React.createElement(ViewToModal, {
    ref: viewToModal,
    extraData: props.extraData,
    refreshFunc: findAll,
    parentProps: props,
    useFindByExample: props.useFindByExample
  }));
});
var InputSearchGrid = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState117 = useState(null),
      _useState118 = _slicedToArray(_useState117, 2),
      selectedItem = _useState118[0],
      setSelectedItem = _useState118[1];

  var _useState119 = useState(null),
      _useState120 = _slicedToArray(_useState119, 2),
      tmpValue = _useState120[0],
      setTmpValue = _useState120[1];

  var _useState121 = useState(false),
      _useState122 = _slicedToArray(_useState121, 2),
      isAdd = _useState122[0],
      setIsAdd = _useState122[1];

  var _useState123 = useState(false),
      _useState124 = _slicedToArray(_useState123, 2),
      isEdit = _useState124[0],
      setIsEdit = _useState124[1];

  var compId = props.propName.replace(/\./g, '_');

  var setIndex = function setIndex(data) {
    return data && data.map(function (it, rowIndex) {
      return _objectSpread(_objectSpread({}, it), {}, {
        rowIndex: rowIndex
      });
    });
  };

  var tableData = setIndex(props.formProps.watch(props.propName) || []);
  useImperativeHandle(ref, function () {
    return {
      select: function select(row) {
        return setSelectedItem(row);
      }
    };
  });

  var onSelection = function onSelection(items) {
    var row = items.length > 0 ? items[0] : null;
    setSelectedItem(row);

    if (props.onSelect) {
      props.onSelect(row);
    }
  };

  var onSelectModal = function onSelectModal(value) {
    return setTmpValue(value);
  };

  var addNewItem = function addNewItem() {
    if (props.onBeforeAdd) {
      var result = props.onBeforeAdd(function () {
        return setIsAdd(true);
      });

      if (!result || !result.async) {
        setIsAdd(true);
      }
    } else {
      setIsAdd(true);
    }
  };

  var onHideModal = function onHideModal() {
    setIsAdd(false);
    setTmpValue(null);
  };

  var onConfirmModal = function onConfirmModal() {
    if (tmpValue && tmpValue.length > 0) {
      if (isEdit && selectedItem) {
        var newData = tableData.map(function (it) {
          return it.rowIndex === selectedItem.rowIndex ? tmpValue[0] : it;
        });
        props.formProps.setValue(props.propName, newData, true);
      } else {
        props.formProps.setValue(props.propName, [].concat(_toConsumableArray(tableData), _toConsumableArray(tmpValue)), true);
      }

      if (props.onChange) {
        props.onChange(tmpValue, isEdit ? 'edit' : 'add');
      }
    }

    setTmpValue(null);
    setIsEdit(false);
    setIsAdd(false);
  };

  var removeSelectedItem = function removeSelectedItem() {
    if (selectedItem) {
      var exec = function exec() {
        var filteredItens = tableData.filter(function (it) {
          return Number(it.rowIndex) !== Number(selectedItem.rowIndex);
        });
        props.formProps.setValue(props.propName, filteredItens);

        if (props.onChange) {
          props.onChange([selectedItem], 'remove');
        }
      };

      var done = function done() {
        var showConfirmMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (showConfirmMessage) {
          alertManager.emit(ACTION_EVENTS.SHOW, {
            message: DEFAULT_DELETE_SELECTED_ITEM_MSG,
            onOkClick: exec,
            type: AlertType.WARNING_YES_NO
          });
        } else {
          exec();
        }
      };

      if (props.onBeforeRemove) {
        var result = props.onBeforeRemove(selectedItem, done);

        if (!result || !result.async) {
          done();
        }
      } else {
        done();
      }
    } else {
      alertManager.emit(ACTION_EVENTS.SHOW, {
        message: DEFAULT_ONE_SELECTED_ITEM_MSG,
        type: AlertType.INFORMATION
      });
    }
  };

  var editItem = function editItem() {
    if (selectedItem) {
      if (props.onBeforeEdit) {
        var result = props.onBeforeEdit(selectedItem, function () {
          return setIsEdit(true);
        });

        if (!result || !result.async) {
          setIsEdit(true);
        }
      } else {
        setIsEdit(true);
      }
    } else {
      alertManager.emit(ACTION_EVENTS.SHOW, {
        message: DEFAULT_ONE_SELECTED_ITEM_MSG,
        type: AlertType.INFORMATION
      });
    }
  };

  return React.createElement(React.Fragment, null, React.createElement(Card, {
    className: "card-box mb-3",
    ref: props.formProps.register({
      name: props.propName
    })
  }, React.createElement(CardHeader, {
    className: "card-header p-2"
  }, React.createElement("div", {
    className: "card-header--title"
  }, props.title), React.createElement("div", {
    className: "card-header--actions"
  }, props.extraButtons, React.createElement(Button, Object.assign({
    id: "addButton-".concat(compId),
    size: "sm",
    color: "success",
    className: "btn-pill d-30 p-0 border-0 mr-2",
    onClick: addNewItem,
    outline: true
  }, generateTestId("isGrid-btn-add-".concat(compId))), React.createElement(FontAwesomeIcon, {
    icon: "plus"
  })), React.createElement(UncontrolledTooltip, {
    target: "addButton-".concat(compId)
  }, "Clique aqui para adicionar"), !props.hideEditButton && React.createElement(React.Fragment, null, React.createElement(Button, Object.assign({
    id: "editButton-".concat(compId),
    size: "sm",
    color: "warning",
    className: "btn-pill d-30 p-0 border-0 mr-2",
    onClick: editItem,
    outline: true
  }, generateTestId("isGrid-btn-edit-".concat(compId))), React.createElement(FontAwesomeIcon, {
    icon: "pen"
  })), React.createElement(UncontrolledTooltip, {
    target: "editButton-".concat(compId)
  }, "Clique aqui para alterar")), React.createElement(Button, Object.assign({
    id: "removeButton-".concat(compId),
    size: "sm",
    color: "danger",
    className: "btn-pill d-30 p-0 border-0 mr-2",
    onClick: removeSelectedItem,
    outline: true
  }, generateTestId("isGrid-btn-remove-".concat(compId))), React.createElement(FontAwesomeIcon, {
    icon: "trash"
  })), React.createElement(UncontrolledTooltip, {
    target: "removeButton-".concat(compId)
  }, "Clique aqui para remover"))), React.createElement(CardBody, null, React.createElement("div", Object.assign({
    key: "divBootstrapTableKey",
    className: "table-area"
  }, generateTestId("isGrid-".concat(compId))), React.createElement(GridTable, {
    keyField: "rowIndex",
    columns: props.columns,
    data: tableData,
    onSelection: onSelection,
    selection: selectedItem ? [selectedItem] : [],
    onDoubleClick: props.disableDoubleClick ? null : editItem
  })), React.createElement("div", Object.assign({
    key: "divFotterKey",
    className: "text-left"
  }, generateTestId("isGrid-table-footer-".concat(compId))), "Registros: ", tableData.length))), (isAdd || isEdit) && React.createElement(SearchViewModal, {
    modalProps: {
      isOpen: true,
      toggle: onHideModal,
      bsSize: 'xl',
      backdrop: 'static'
    },
    onSelect: onConfirmModal,
    searchDataGridProps: {
      searchExpressions: props.searchExpressions,
      selectRow: {
        clickToSelect: true,
        hideSelectAll: true,
        mode: 'radio',
        onSelect: onSelectModal
      }
    },
    searchViewId: props.searchViewId
  }));
});
var DEFAULT_COLORS = [THEME_PRIMARY, THEME_SECONDARY, THEME_SUCCESS, THEME_DANGER, THEME_WARNING, THEME_INFO, THEME_DARK];

var InputColor = function InputColor(props) {
  var togglePickerId = "toggleColorpickerPopover".concat(props.id);
  var width = props.width || '240px';
  var colors = props.colors || DEFAULT_COLORS;
  var label = props.label || 'Selecionar Cor';
  var btnColor = props.btnColor || 'dark';
  var btnSize = props.btnSize || 'sm';

  var _useState125 = useState(props.color || props.formProps.getValues()[props.id] || colors[0]),
      _useState126 = _slicedToArray(_useState125, 2),
      color = _useState126[0],
      setColor = _useState126[1];

  var handleChange = function handleChange(value) {
    if (colors.includes(value.hex)) {
      props.formProps.setValue(props.id, value.hex);
      setColor(value.hex);

      if (props.onChange) {
        props.onChange(value);
      }
    }
  };

  return React.createElement(React.Fragment, null, React.createElement(Button, {
    id: togglePickerId,
    color: btnColor,
    size: btnSize,
    className: "badge-wrapper"
  }, React.createElement(Badge, {
    style: {
      backgroundColor: color
    },
    className: "badge-position badge-position--top-right badge-circle-inner"
  }, "Cor"), label), React.createElement(UncontrolledPopover, {
    trigger: "legacy",
    target: togglePickerId,
    popperClassName: "popover-custom-wrapper popover-custom-lg d-flex justify-content-center align-items-center p-2",
    placement: props.placement
  }, React.createElement(BlockPicker, Object.assign({}, props, {
    ref: props.formProps.register({
      name: props.id
    }, props.formProps.validation),
    "data-testid": "input-color",
    onChangeComplete: handleChange,
    colors: colors,
    color: color,
    width: width,
    triangle: "hide"
  }))));
};

export { ACTION_EVENTS, ANO, Accordion, AccordionItem, ActionBar, AlertContainer, AlertType, AutoCompleteOff, Box, CALIMA_DANGER, CALIMA_DARK, CALIMA_INFO, CALIMA_LIGHT, CALIMA_ORANGE, CALIMA_PRIMARY, CALIMA_SUCCESS, CALIMA_WARNING, CEP_INVALIDO_MSG, CONTAINER_STATUS_OK, CSV, ChangeType, Checkbox, ComparatorEnum, CountComparatorEnum, CustomSearch, DATE, DATES, DATE_MONTH_YEAR_PATTERN, DATE_MONTH_YEAR_TIME_PATTERN, DEFAULT_DELETE_SELECTED_ITEM_MSG, DEFAULT_ONE_SELECTED_ITEM_MSG, DESIGN_TYPE_ENUM, DeleteButton, DetailEditForm, DetailManagerForm, Dock, DockItem, DockItemList, EMAIL_INVALIDO_MSG, EMAIL_REGEX_VALIDATION, ERROR, EXCEL, EditForm, EditViewModal, ErroList, EventType, FileInputPreview, FilterType, Footer, GRAPHIC, GridPagination, GridTable, HTML, HeaderMenu, INFORMATION, ImageInputPreview, InputColor, InputDebounce, InputGroupInline, InputSearchGrid, InputType, Loading, MASCARA_INVALIDA_MSG, MAX_MONEY_NUMBER, MAX_NUMBER, MONTH_YEAR_PATTERN, NAO, ONLY_ALPHA_MESSAGE, ONLY_ALPHA_NUM_MESSAGE, ONLY_NUMBER_MESSAGE, OperationEnum, OrderType, PageTitle, PositionEnum, ProcessBar, Progress, REFERENCE, REFERENCES, REF_PATTERN, REGISTRO_ALTERADO_COM_SUCESSO_MSG, REGISTRO_EXCLUIDO_COM_SUCESSO_MSG, REGISTRO_INSERIDO_COM_SUCESSO_MSG, REQUIRED_FIELD, RTF, Router, SIM, SIMPLE, SIZE_ONE_HUNDRED_BYTES, SIZE_TWO_BYTES, STORAGE_CHANGE_EVENT, SUCCESS, SearchDataGridNew as SearchDataGrid, SearchViewModal, SelectModeEnum, SortDirection, SuspenseLoading, TELEFONE_INVALIDO_MSG, TEXT, THEME_DANGER, THEME_DARK, THEME_INFO, THEME_PRIMARY, THEME_SECONDARY, THEME_SUCCESS, THEME_WARNING, TIME_PATTERN, Tab, TabGroup, ToastMsg, Tree, TreeCheckBox, URL_INVALIDA_MSG, URL_REGEX_VALIDATION, WARNING, WORD, WikiButton, WindowComponent, Wizard, WizardPage, WrapperContainer, WrapperSeamless, WrapperSimple, YEAR_MONTH_DATE_PATTERN, YEAR_MONTH_DATE_TIME_PATTERN, accordionIcon, actionColumn, add, addMilliseconds, addSeconds, adjustExpressions, adjustValidation, alertManager, boolColumn, boolFormatter, booleanOptionList, cepFormatter, cepMaskFormatter, cloneEvent, cnpjFormatter, cnpjMaskFormatter, compare, consultarSituacao, consultarSituacaoFalhaConexao, cpfFormatter, cpfMaskFormatter, create, createCustomEvent, createLoadable, createStorageChanged, currencyColumn, currencyFomatter, currentDate, currentMomentDate, dateColumn, dateTimeValidator, dateValidator, dec, decimalColumn, decimalFormatter, decimalMaskFormatter, defaultAccordionHeaderColor, defaultAccordionTitleColor, defaultDecrypt, defaultEncrypt, deleteFromLocalStorage, deleteFromSessionStorage, dispatchClose, actions$2 as dockActions, reducer$2 as dockReducer, enc, enumColumn, enumFormatter, environment, errorFunc, eventManager, fillText, fillZero, findAll, findAllByExpression, findByExample, findById, findInputChildrens, focusOnInput, format, formatBytes, formatDate, formatDateTime, formatRef, formatSaldo, formatTime, gaEvent, gaModalView, gaOutboundLink, gaPageView, generateTestId, gerarSequenciaChars, getComponentBasicProps, getExtension, getExtraData, getFirstChildrenFound, getInputSelector, getMaxFloatValue, getMaxLengthMoney, getMaxMoney, getNextVisibleElement, getObjectSubValue, getRandomUUID, getSelectedItem, getViewElement, handleFocusOnEnter, initialFocus, initializeGA, isCEP, isCNPJ, isCPF, isElementVisible, isEmail, isEmpty, isMask, isNotEmpty, isNumEmpty, isRequired$1 as isRequired, isTelefone, isURL, loadIcons, actions$1 as loginActions, reducer$1 as loginReducer, loginToken, md5, navegarWiki, navegarWikiController, notificarFalhaLogin, obterTokenLogin, onlyAlpha, onlyAlphaNum, onlyNumber, openChildView, parseDateToRef, parseLastDay, parseRefToDate, percentualFormatter, percentualMaskFormatter, persist, persistFiles, persistList, phoneFormatter, phoneMaskFormatter, phoneWithDDDFormatter, actions as progressActions, reducer as progressReducer, recuperarLogin, refToFormat, refToFormatYearAndMonth, referenceColumn, referenceFormatter, remove, removeAccents, removeList, send, showToast, toDate, toDateTime, useInterval, useLocalStorage, useSessionStorage, valToString, validade, validadeChild, validarLoginController, validateUniqueProp, withTooltip, writeInLocalStorage, writeInSessionStorage };